export default {
    nl: {
        aboutToExpire: 'Verloopt binnenkort',
        absentOn: 'Afwezig op',
        accept: 'Accepteren',
        Accept: 'Ter acceptatie',
        Accepted: 'Geaccepteerd',
        accessToEvaluationByTrainers: 'Inzage evaluaties door docenten',
        accessToEvaluationByTrainersSubtitle:
            'Docenten mogen alle evaluaties inzien, ook van elkaars trainingen.',
        accreditation: 'Accreditatie',
        'accreditation.status': `{status, select,
            accepted {Verwerkt door PE-Online}
            failed {Niet verwerkt door PE-Online}
            badResponse {Ongeldig verklaard door PE-Online}
            error {Fout in PE-Online}
            pending {In behandeling}
            notValid {Ongeldig}
            other {Geen status vanuit PE-Online}
        }`,
        'accreditation.process': 'Verwerken',
        'accreditation.processDate': 'Verwerkingsdatum',
        'accreditation.processed': 'Verwerkt',
        'accreditation.endDate': 'Voldaan op',
        'accreditation.info': 'Accreditatie instellingen',
        'accreditation.setBySdb': 'Ingesteld door SDB',
        'accreditation.processSuccess': 'Accreditaties zijn verwerkt',
        'accreditation.saveFailed':
            'Het opslaan van de accreditatie instellingen is niet gelukt. Probeer het opnieuw.',
        'accreditation.processTitle': 'Accreditaties verwerken',
        'accreditation.processText':
            'Alle resultaten van deze opleiding zullen direct worden verwerkt. Het is mogelijk dat dit enige tijd duurt.',
        'accreditation.processDoYouWantToContinue': 'Wil je doorgaan met verwerken?',
        accreditations: 'Accreditaties',
        achieved: 'Behaald',
        AchievedResults: 'Behaalde resultaten',
        achievedOn: 'Behaald op',
        Achievement: 'Resultaat',
        AchievementIsAboutToExpire: 'Uw resultaat verloopt binnenkort!',
        AchievementIsExpired: 'Uw resultaat is verlopen',
        AchievementIsFailed: 'U bent gezakt',
        AchievementIsMandatory: 'Uw resultaat is verplicht!',
        AchievementIsPassed: 'Catalogusitem behaald / voldaan',
        achievementRead: 'Ik heb de handleiding / het protocol gelezen',
        achievementStatus: `{status, select,
            aborted {Afgebroken}
            absent {Afwezig}
            canceled {Geannuleerd}
            completed {Voldaan}
            deleted {Verwijderd}
            expired {Verlopen}
            failed {Niet voldaan}
            faulted {Fout}
            not_registered {Niet ingeschreven}
            not_started {Niet gestart}
            passed {Voldaan}
            started {Gestart}
            registered {Ingeschreven}
            unregistered {Uitgeschreven}
            other {Onbekend}
        }`,
        achievementStatusForUserCourseResults: `{status, select,
            aborted {Afgebroken}
            absent {Afwezig}
            canceled {Geannuleerd}
            completed {Voldaan}
            deleted {Verwijderd}
            expired {Voldaan (verlopen)}
            failed {Niet voldaan}
            faulted {Fout}
            not_registered {Niet ingeschreven}
            not_started {Niet gestart}
            passed {Voldaan}
            started {Gestart}
            registered {Ingeschreven}
            unregistered {Uitgeschreven}
            other {Onbekend}
        }`,
        activate: 'Activeren',
        ActivateELearning: 'E-learning (de)activeren',
        activatePackage: 'Activeer pakket',
        active: 'Actief',
        Active: 'Actief',
        activities: 'Activiteiten',
        activity: 'Activiteit',
        activityName: 'Naam activiteit',
        add: 'Toevoegen',
        addAccreditation: 'Accreditatie toevoegen',
        AddAFavoriteFirst: 'Reset het filter en kies je eerste favoriete item!',
        addAnActivity: 'Voeg een activiteit toe',
        addAnswer: 'Antwoord toevoegen',
        addAssessment: 'Beoordeling toevoegen',
        addAssessors: 'Voeg gebruikers toe die anderen mogen toetsen',
        addAssets: 'Hulpmiddelen toevoegen',
        addAttachments: 'Bijlage(n) toevoegen',
        addBlock: 'Blok toevoegen',
        addCategory: 'Categorie toevoegen',
        addComment: 'Opmerking toevoegen',
        addCourse: 'Klassikale opleiding toevoegen',
        addEmployee: 'Medewerker toevoegen',
        addExemption: 'Vrijstelling toevoegen',
        addExternalCatalogItem: 'Externe content toevoegen',
        addFiles: {
            one: 'Selecteer bestand...',
            many: 'Selecteer bestanden...',
        },
        addForm: 'Formulier toevoegen',
        addGroup: 'Groep toevoegen',
        addIndividuals: 'Individuen toevoegen',
        Additional: 'Extra',
        addMailTemplate: 'E-mailsjabloon toevoegen',
        addNew: 'Nieuwe toevoegen',
        AddNewsItem: 'Nieuwsbericht toevoegen',
        addNewPrice: 'Nieuwe prijs toevoegen',
        addOption: 'Optie toevoegen',
        addPlanners: 'Voeg gebruikers toe aan wie u planner-rechten wilt geven aan afdelingen',
        addPlanning: 'Rooster toevoegen',
        AddPortalGroup: 'Afdeling toevoegen',
        addQuestion: 'Vraag toevoegen',
        address: 'Adres',
        addressGroup: 'Adresgegevens',
        addReservations: 'Reserveringen toevoegen',
        addReviewers:
            'Voeg hier gebruikers toe die "alleen lezen" rechten op de afdelingen moeten hebben',
        addSchedule: 'Sessie toevoegen',
        addSubcategory: 'Subcategorie toevoegen',
        addTeacher: 'Docent toevoegen',
        AddTextAndPressEnter: 'Voer een tekst in en druk op ENTER',
        addTextField: 'Tekstveld toevoegen',
        addTheorem: 'Stelling toevoegen',
        addToVirtualQueue: 'Ik heb interesse in deze training',
        addToVirtualQueueDialogHeader: 'Interesse kenbaar maken voor dit catalogusitem?',
        addToVirtualQueueDialogMessage:
            'Jouw interesse voor dit catalogusitem wordt vastgelegd. Bij voldoende interesse kan besloten worden om in de toekomst nieuwe sessies beschikbaar te stellen.',
        addTraining: 'Opleiding toevoegen',
        addUser: 'Gebruiker toevoegen',
        addUsers: 'Gebruikers toevoegen',
        administration: 'Beheer',
        administrators: 'Beheerders',
        administratorsAdd: 'Beheerders toevoegen',
        advancedFilters: 'Geavanceerde filters',
        advised: 'Geadviseerd',
        agree: 'Eens',
        all: 'Alle',
        allCategories: 'Alle categorieën',
        allAssignmentsAreDeleted: 'Alle toewijzingen zijn verwijderd',
        allMandatoryFieldsMustBeFilled: 'Alle verplichte velden moeten worden ingevuld',
        allReservationsDeleteWarning:
            'Let op! Alle reserveringen met betrekking tot deze dienstregeling worden verwijderd!',
        AlmostExpired: 'Bijna verlopen',
        allDepartmentsAndRolesDeleted: 'Alle afdelingen en functies verwijderd',
        Allignment: 'Uitlijning',
        allPresent: 'Allemaal aanwezig',
        allowedToFollow: 'Mag doen',
        allowMandatoryAssignments: 'Verplichte toewijzingen',
        allowMandatoryAssignmentsDescription:
            'Zet verplicht maken van catalogusitems applicatiebreed aan of uit',
        allowMultipleAnswers: 'Sta meerdere antwoorden toe',
        allowOnlyYourOwnNames: 'Alleen eigen benamingen toestaan',
        allowQueue: 'Wachtrij',
        AllowEnroll: 'Inschrijven toestaan',
        AllowUnenroll: 'Uitschrijven toestaan',
        allowVirtualQueue: 'Interesselijst',
        'allowVirtualQueue.explainer':
            'Gebruikers kunnen hun interesse kenbaar maken als er geen opleidingen gepland zijn',
        allAssignmentTypes: 'Alle soorten toewijzingen',
        allTypes: 'Alles',
        always: 'Altijd',
        answerText: 'Antwoord tekst',
        'apiMessages.saved': 'Opgeslagen',
        'apiMessages.error': 'Er is een fout opgetreden',
        applicationParts: 'Applicatie onderdelen',
        apply: 'Toepassen',
        appointment: 'afspraak',
        appointmentAt: 'Afspraak op',
        approved: 'Bekwaam',
        approvedDate: 'Bekwaam datum',
        aProblemHasOccuredContactTheAdministrator:
            'Er is een probleem opgetreden. Neem contact op met de beheerder',
        archive: 'Archief',
        AreYouSureYouWantToDeactivateThisPackage: 'Weet u zeker dat u dit pakket wilt deactiveren?',
        AreYouSureYouWantToDeleteThisPackage: 'Weet u zeker dat u dit pakket wilt verwijderen?',
        areYouSureYouWantToDelete_what_: `Weet u zeker dat u {what, select,
            role {deze rol}
            other {''{what}''}
        } wilt verwijderen?`,
        areYouSureYouWantToDeleteAllAssignmentsForThisAssessor:
            'Weet je zeker dat je alle toewijzingen voor deze beoordelaar wilt verwijderen?',
        areYouSureYouWantToDeleteThisAssessment:
            'Weet je zeker dat je deze beoordeling wilt verwijderen?',
        areYouSureYouWantToDeleteThisBlock: 'Weet je zeker dat je dit blok wilt verwijderen?',
        areYouSureYouWantToDeleteThisCategory:
            'Weet je zeker dat je deze categorie wilt verwijderen',
        areYouSureYouWantToDeleteThisComment:
            'Weet je zeker dat je dit commentaar wilt verwijderen?',
        areYouSureYouWantToDeleteThisConnection:
            'Weet je zeker dat je deze toewijzing wilt verwijderen',
        areYouSureYouWantToDeleteThisCourse:
            'Weet je zeker dat je deze klassikale opleiding wilt verwijderen?',
        areYouSureYouWantToDeleteTheseConnections:
            'Weet je zeker dat je deze toewijzingen wilt verwijderen',
        areYouSureYouWantToDeleteThisForm: 'Weet je zeker dat je dit formulier wilt verwijderen?',
        areYouSureYouWantToDeleteThisGroup: 'Weet je zeker dat je deze groep wilt verwijderen',
        areYouSureYouWantToDeleteThisIndividualSkill:
            'Weet je zeker dat je deze individuele bekwaamheid wilt verwijderen',
        areYouSureYouWantToDeleteThisMessage: 'Weet je zeker dat je dit bericht wilt verwijderen',
        areYouSureYouWantToDeleteThisQuestion: 'Weet je zeker dat je deze vraag wilt verwijderen',
        areYouSureYouWantToDeleteThisSection: 'Weet je zeker dat je dit blok wilt verwijderen',
        areYouSureYouWantToDeleteThisSkill:
            'Weet je zeker dat je deze bekwaamheid wilt verwijderen',
        areYouSureYouWantToDeleteThisTextField:
            'Weet je zeker dat je dit tekstveld wilt verwijderen',
        areYouSureYouWantToPublishThisSkillToCatalog:
            'Weet je zeker dat je deze bekwaamheid ({name}) naar de catalogus wilt publiceren?',
        areYouSureYouWantToUnassignEmployeeFromSkill:
            'Weet je zeker dat je {userName} wilt ontkoppelen van de bekwaamheid {skillName}?',
        areYouSureYouWantToUnsubscribe: 'Weet je zeker dat je zich uit wilt schrijven?',
        are_you_sure_you_want_to_delete_this_accreditation:
            'Weet je zeker dat je deze accreditatie wilt verwijderen?',
        are_you_sure_you_want_to_delete_this_location:
            'Weet je zeker dat je deze locatie wilt verwijderen?',
        are_you_sure_you_want_to_delete_this_schedule:
            'Weet je zeker dat je deze sessie wilt verwijderen?',
        are_you_sure_you_want_to_delete_this_tool:
            'Weet je zeker dat je dit hulpmiddel wilt verwijderen?',
        are_you_sure_you_want_to_remove_this_user_from_list:
            'Weet je zeker dat je deze gebruiker uit de lijst wilt verwijderen?',
        areYouSureYouWantToUnregister: 'Weet je zeker dat je zich wilt uitschrijven?',
        areYouSureYouWantToUnregisterThisStudent:
            'Weet je zeker dat je deze deelnemer wilt uitschrijven?',
        assessedOn: 'Beoordelingsdatum',
        assessEmployees: 'Medewerkers beoordelen',
        assessment: 'Beoordeling',
        assessmentAppointments: 'Toetsafspraken',
        assessmentName: 'Naam beoordelingsformulier',
        assessmentDescription: 'Beschrijving beoordeling',
        assessmentForm: 'Beoordelingsformulier',
        assessmentsForms: 'Beoordelingsformulieren',
        assessmentResult: 'Beoordelingsresultaat',
        assessments: 'Beoordelingen',
        assessmentIncomplete: 'Beoordeling is niet volledig ingevuld',
        assessmentMustContainAtLeastOneSection: 'Beoordeling moet tenminste één blok bevatten',
        assessmentSectionsMustContainAtLeastOneQuestion:
            'Blokken moeten tenminste één vraag bevatten',
        assessmentQuestionMustHaveYesNoOptions: 'Vraag moet ja/nee als opties hebben',
        assessor: 'Beoordelaar',
        assessors: 'Toetsers',
        assessorMoments: 'Toetsmomenten',
        assessorsManagement: 'Beoordelaarsbeheer',
        assessorsView: 'Beoordelaarsweergave',
        assessorsViewManageAssignments: 'Toewijzingen beheren (oude werkwijze)',
        assignment: 'Opdracht',
        assignmentsNumber: 'Aantal toewijzingen',
        assignmentType: 'Type toewijzing',
        examinerWithName: 'Toetser: {name}',
        examinerAppointments: 'Toetsafspraken',
        examinerAppointmentsOverview: 'Lijst van toetsafspraken',
        examinerFirstAvailableTimeSlot: 'Eerst beschikbare tijdstip',
        examinermanagement: 'Toetserbeheer',
        examinerNoLocation: 'Geen locatie gevonden!',
        assign: 'Toewijzen',
        'assignMatrix.title': `{type, select,
            department {Gehele afdeling}
            group {Gebruiker / groep}
            user {Gebruiker}
            function {Functie}
            other {{type}}
        }`,
        'assignMatrix.department.explainer': 'Ongeacht functie',
        assignCatalogItems: 'Catalogusitems toewijzen',
        assignCatalogItemsBulk: 'Welke catalogusitems wil je toewijzen?',
        assignCatalogItemsBulkChooseDomain: 'Kies een domein',
        assignCatalogItemsBulkChooseFunctions: 'En aan welke functies?',
        assignCatalogItemsBulkMandatory: 'Verplicht maken?',
        assignCatalogItemsBulkHowToAssign: 'Hoe wil je de catalogusitems toewijzen?',
        assignCatalogItemsBulkToDomainOrDepartment: 'Aan wie wil je toewijzen?',
        assignCatalogItemsBulkSelectAllFunctions: 'Alle functies selecteren',
        assignCatalogItemsBulkWithDepartments: 'Aan welke afdelingen wil je deze toewijzen?',
        assignCatalogItemTypes: 'Welk type catalogusitem wil je toewijzen?',
        assignCategoriesBulk: 'Welke categorieën wil je toewijzen?',
        assignCategoriesChooseCatalogItemsType:
            'Aan welk type catalogusitem wil je de categorieën toewijzen?',
        assignCategoriesChooseCatalogItems:
            'Aan welke catalogusitems wil je de categorieën toewijzen?',
        AssignCertificateToSelectedCatalogItems:
            'Wijs certificaat toe aan geselecteerde catalogusitems',
        assignDirectly: 'Direct toewijzen',
        assigned: 'Toegewezen',
        assignedCoursesBlockTypes: `{status, select,
            notCompleted {Niet voldaan / verlopen}
            expiring {Verloopt binnenkort}
            completed {Voldaan}
            other {{status}}
        }`,
        assignedTrainings: 'Toegewezen opleidingen',
        assignIndividual: 'Individu toewijzen',
        assignIndividuals: 'Individuen toewijzen',
        assignManagers: 'Toewijzen managers',
        assignments: 'Toewijzingen',
        'assignmentSource.individual': 'Individueel',
        'assignmentSource.department': 'Afdeling {department}',
        'assignmentSource.allDepartments': 'Alle afdelingen',
        'assignmentSource.departmentFunction': '{department} / {function}',
        'assignmentSource.function': 'Functie {function}',
        'assignmentSource.allFunctions': 'Alle functies',
        'assignmentSource.parentDepartment': '{department} (incl. onderliggende afdelingen)',
        'assignmentSource.parentDepartmentFunction':
            '{department} (incl. onderliggende afdelingen) / {function}',
        'assignmentSource.domain': 'Domein {name}',
        'assignmentSource.ssoGroup': 'Groep {name}',
        'assignmentSource.other': 'Overig',
        'userAssignments.source': 'Bron',
        'userAssignments.loadFailed': 'De toegewezen opleidingen konden niet worden geladen.',
        'userAssignments.forbidden':
            'Je hebt geen rechten om de toegewezen opleidingen van deze gebruiker te zien.',
        'userAssignments.sourceFilter': 'Bron',
        'userAssignments.sourceFilter.individual': 'Individueel',
        'userAssignments.sourceFilter.inherited': 'Overgeërfd',
        'userAssignments.sourceFilter.department': 'Afdeling',
        'userAssignments.sourceFilter.function': 'Functie',
        'userAssignments.sourceFilter.domainOrGroup': 'Domein of groep',
        assignedTo: 'Toegewezen aan',
        assignedUsers: 'Toegewezen gebruikers',
        assignToDepartmentFunction: 'Toewijzen aan afdeling / functie',
        asSoonAsAPlaceBecomesAvailableTheNextParticipantWillBeRegisteredAutomatically:
            'Als maximum aantal deelnemers is bereikt, kan een gebruiker zich inschrijven op de wachtrij om automatisch ingeschreven te worden zodra een plek vrij komt.',
        asSoonAsSpaceBecomesAvailableTheEntireQueueWillReceiveAnInvitation:
            'Zodra er plek vrijkomt krijgt de volledige wachtrij een uitnodiging',
        at: 'om',
        atLeastOneAssignmentMustBeSelected: 'Er moet tenminste één toewijzing geselecteerd worden.',
        atLeastOneFunctionMustBeSelected: 'Er moet tenminste een functie geselecteerd worden.',
        atLeastOneBlockMustAdded: 'Er moet tenminste een blok toegevoegd worden.',
        atLeastOneActivityMustAdded: `Er moet minimaal één activiteit aan het blok worden toegevoegd. In het geval van Basis/Vervolg moet zowel voor Basis als Vervolg tenminste een activiteit toegevoegd worden`,
        attachedCertificate: 'Gekoppeld certificaat',
        attachedUsers: 'Gekoppelde medewerker(s)',
        attachments: 'Bijlage(n)',
        attendanceList: 'Presentielijst',
        attendees: 'Aanwezigen',
        askAuthorizationToManager:
            'Er is toestemming nodig om deze e-learning te volgen, wil je deze aanvragen?',
        authorizationNeededByManager: 'Autorisatie vereist door manager',
        authorizationRequest: `{ number, select,
            1 {Beoordeel 1 verzoek}
            other {Beoordeel {number} verzoeken}
        }`,
        AuthorizationRequest: 'Autorisatieverzoek',
        AuthorizationRequests: 'Autorisatie',
        AvailableLabels: 'Beschikbare labels',
        AvailableVersions: 'Beschikbare versies',
        beginDate: 'Startdatum',
        beginTime: 'Starttijd',
        back: 'terug',
        Back: 'Terug',
        basic: 'Basis',
        belowYouSeeTheListWhereYouNeedToUpdateThePresence:
            'Hieronder zie je de lijst waarvan je de presentie moet bijwerken',
        belowYouSeeThePlanningOfTheLessonsForWhichYouAreRegistered:
            'Hieronder zie je het rooster van de lessen waarvoor je ingeschreven bent',
        betaHeadline: 'Benieuwd naar de nieuwe vormgeving? Probeer deze gerust uit!',
        bhpStatusEnrolled: 'Ingeschreven',
        bhpStatusAchieved: 'Behaald op',
        bhpValidity: 'Geldigheid',
        block: 'Blok',
        blockName: 'Naam blok',
        Bold: 'Vet',
        both: 'Beide',
        bulkAssignmentsSaved: 'Gelukt, catalogusitems zijn toegewezen',
        buy: 'Betalen',
        by: 'Door',
        calendar: 'Kalender',
        calculateSupportColors: 'Steunkleuren automatisch berekenen',
        cancel: 'Annuleren',
        cancelled: 'Geannuleerd',
        Cancelled: 'Geannuleerd',
        cancelPendingRequest: 'Wil je de lopende aanvraag intrekken?',
        cancelSchedule: 'Planning annuleren',
        canTest: 'Kan aftoetsen',
        capacity: 'Capaciteit',
        capacityReached: 'Rooster is vol',

        catalog: 'Catalogus',
        catalogCategories: 'Catalogus categorieën',
        'catalog.fab.course': 'Klassikale opleiding toevoegen',
        'catalog.fab.elearning': 'E‑learning (de)activeren',
        'catalog.participants.heading.lastAction': 'Laatste actie',
        'catalog.participants.filter.action': 'Actie',
        'catalog.participants.filter.name': 'Filter op medewerker',
        'catalog.participants.filter.dateFrom': 'Datum vanaf',
        'catalog.participants.filter.dateUntil': 'Datum t/m',
        'catalog.participants.heading.result': 'Resultaat',
        'catalog.participants.heading.bestResult': 'Beste resultaat',
        'catalog.participants.heading.expirationDate': 'Verloopdatum',
        'catalog.participants.heading.currentStatus': 'Huidige status',
        'catalog.participants.heading.date': 'Datum',
        catalogAssignmentWarning:
            'Alle geselecteerde catalogusitems worden definitief toegewezen op basis van de gemaakte keuzes.',
        catalogAssignmentWarning2: 'Dit kan alleen handmatig ongedaan gemaakt worden.',
        CatalogInterests: 'Interesselijst',
        CatalogInterestsDetails: 'Catalogusitems op jouw interesselijst',
        catalogItem: 'Catalogusitem',
        catalogItemCompleted: ' - laatst behaald op: ',
        catalogItemAboutToExpire: 'Catalogusitem verloopt binnenkort!',
        catalogItemExpired: 'Catalogusitem is verlopen!',
        catalogItemMandatory: 'Catalogusitem is verplicht!',
        catalogItemPassed: 'Catalogusitem behaald / voldaan',
        'catalogItem.status': `{status, select,
            disabled {[UITGESCHAKELD]}
            deleted {[VERWIJDERD]}
            other {}
        }`,
        catalogItems: 'Catalogusitems',
        'catalogItem.replaces': 'Deze cursus vervangt de volgende cursus(sen)',
        'catalogItem.replacedBy': 'Deze cursus is vervangen door de volgende cursus',
        'catalogEdit.general': 'Catalogusitem algemeen',
        'catalogEdit.sdbPlanning': 'SDB Planning',
        'catalogEdit.sdbPlanningIntro':
            'Deze instellingen bepalen wat het Leerplatform naar SDB Planning stuurt.',
        'catalogItem.detail.header.resultsAndHistory': 'Alle resultaten & historie',
        'catalogItem.detail.assignedTo.explainer':
            'Betreft alle gebruikers die op dit moment aan dit catalogusitem zijn toegewezen met hun status. Als er geen status is, heeft de betreffende gebruiker in de geselecteerde periode nog geen actie ondernomen.',
        'catalogItem.detail.participant.explainer':
            'Betreft alle behaalde resultaten, ongeacht of de gebruiker op dit moment is toegewezen aan dit catalogusitem.',
        catalogOf: 'Catalogus van',
        categories: 'Categorieën',
        categoriesAssignmentWarning:
            'Alle geselecteerde categorieën worden definitief toegewezen op basis van de gemaakte keuzes.',
        categoriesNotFound: 'Geen beschikbare categorieën gevonden',
        category: 'Categorie',
        categoryAdd: 'Categorie toevoegen',
        categoryDelete: 'Categorie verwijderen',
        categoryDeleteWarning: 'Weet je zeker dat je deze categorie wilt verwijderen?',
        categoryDeleted: 'Categorie verwijderd',
        categoryEdit: 'Categorie bewerken',
        categoryName: 'Categorienaam',
        Center: 'Centreren',
        'cert-all': 'Alles',
        'cert-yes': 'Alles met certificaat',
        'cert-no': 'Alles zonder certificaat',
        certificate: 'Certificaat',
        certificates: 'Certificaten',
        certificateApply1: `Het certificaat ''{certificaat}'' `,
        certificateApply2: 'wordt toegepast op {number} catalogusitem(s).',
        certificateAssign: 'Certificaten toewijzen',
        certificateDefinition: 'Certificaatdefinitie',
        certificateDefinitions: 'Certificaten',
        certificateDefinitions2: 'Certificaatdefinities',
        certificateDeleteConfirm: 'Weet u zeker dat u deze certificaat-definitie wilt verwijderen?',
        certificateDeleteWarning: 'Deze definitie wordt {number} keer gebruikt in catalogusitems!',
        certificateHide: 'Verberg items met certificaat:',
        certificateLabelDeleteHeader: 'Geselecteerde label verwijderen?',
        certificateLabelDelete: 'Wilt u dit label verwijderen?',
        certificateLabelNew: 'Nieuw leeg label',
        certificateLabelUsername: 'Label: gebruikersnaam',
        certificateLabelBirthdate: 'Label: Geboortedatum',
        certificateLabelCoursename: 'Label: Cursusnaam',
        certificateLabelResultdate: 'Label: Datum behaald',
        certificateLabelPoints: 'Label: Score',
        certificateAccreditationCode: 'Label: Accreditatie',
        certificateShow: 'Toon items met certificaat:',
        changeCategory: 'Categorie wijzigen',
        changeComment: 'Commentaar wijzigen',
        changed: 'aangepast',
        changeOrder: 'Volgorde wijzigen',
        changePassword: 'Wijzig wachtwoord',
        changeProfile: 'Wijzig profiel',
        changeYourPassword: 'Wijzig uw wachtwoord',
        changeRegistration: 'Inschrijving wijzigen',
        changeSsoAccount: 'Wijzig account',
        checkAppointments: 'Bestaande afspraken blijven staan!',
        checkPortfolioItems:
            'Controleer {number, plural, one {een dossieritem} other {# dossieritems}}',
        chosenDate: 'Gekozen datum',
        chosenTraining: 'Gekozen opleiding',
        chooseAnEvaluationForm: 'Kies een evaluatieformulier',
        chooseAnExaminer: 'Kies een toetser',
        chooseATimeslot: 'Kies een tijdstip',
        chooseASkillThatYouWantToLinkToThisDepartment:
            'Kies een bekwaamheid die je aan deze afdeling wilt koppelen.',
        chooseCertificate: 'Kies certificaat',
        chooseDateAndRegion: 'Kies datum en regio voor het inplannen van een toetsmoment',
        chooseDeleteToPreventThisUserFromReviewingAnySkill: `Kies voor ''VERWIJDEREN'' om te zorgen dat deze gebruiker nergens meer mag beoordelen.`,
        chooseFunctions: 'Kies functies',
        chooseImportToMakeThisUsersAnAssessorForTheSameActivitiesAsAnotherUser: `Kies voor ''IMPORTEREN'' om deze gebruiker beoordelaar te maken bij dezelfde activiteiten als een andere gebruiker.`,
        choosePortfolioDefinition: 'Kies een dossieritem definitie',
        ChooseWhichRolesYouWantToUncouple: 'Kies welke rollen u wilt ontkoppelen',
        city: 'Stad',
        class: 'Klas',
        classDeleted: 'Klas verwijderd',
        classes: 'Klassen',
        classical: 'Klassikaal',
        Classical: 'Klassikaal',
        classicalTheoryLesson: 'Klassikale theorieles',
        classroom: 'Klassikaal',
        Classroom: 'Klassikaal',
        'classroom.conflictMessage.maxCapacityLowerThanMinCapacity':
            'Max. aantal deelnemers is lager dan min. aantal deelnemers',
        'classroom.teacheroverviewfilter.all': 'Alles',
        'classroom.teacheroverviewfilter.active': 'Actief',
        'classroom.teacheroverviewfilter.cancelled': 'Geannuleerd',
        ClassroomActivities: 'Klassikale activiteiten',
        ClassroomActivity: 'Klassikale activiteit',
        ClassroomCancel: 'Klassikale opleiding annuleren',
        ClassroomDequeue: 'Uitschrijven van wachtrij',
        ClassroomEnroll: 'Inschrijven bij klassikale opleiding',
        ClassroomEnqueue: 'Inschrijven op wachtrij',
        ClassroomExaminerActivity: 'Klassikale- en toetsactiviteiten',
        ClassroomUnenroll: 'Uitschrijven bij klassikale opleiding',
        classroomTraining: 'Klassikale opleidingen',
        classroomTypes: 'Klassikaal',
        clear: 'Vrijmaken',
        ClearImage: 'Verwijder afbeelding',
        ClearList: 'Leeg lijst',
        clickOnRegisterToRegisterYourself: `Klik op ''INSCHRIJVEN'' om u zelf in te schrijven.`,
        close: 'Afsluiten',
        closeDown: 'Sluiten',
        closeRegistration: 'Inschrijving sluiten',
        code: 'code',
        Code: 'Code',
        combineSkillExams: 'Toetsmomenten combineren',
        colleague: 'Collega',
        color: 'Kleur',
        comment: 'Opmerking',
        commentDate: 'Datum van de opmerking',
        comments: 'Opmerkingen',
        communication: 'Communicatie',
        compatibility: 'Compatibiliteit',
        complete: 'Volledig',
        completeBefore: 'Uiterlijk afronden voor',
        completed: 'Voldaan',
        Completed: 'Afgehandeld',
        completedStatus: 'Voldaan',
        completionDate: 'Afrondingsdatum',
        'components.acaDepartmentSearch.label': 'Filter op (sub)afdeling',
        composition: 'e-Learning',
        compulsory: 'Verplicht',
        compulsoryNumber: 'Aantal verplicht',
        confirm: 'Bevestigen',
        confirmDelete: `Weet u zeker dat u ''{name}'' wilt verwijderen?`,
        ConfirmNewPassword: 'Bevestig nieuw wachtwoord',
        ConfirmUnenroll: 'Weet u zeker dat u wilt uitschrijven?',
        ConflictingEnrollmentFound: 'Er is een conflicterende inschrijving gevonden',
        ConflictingSchedule:
            'Kan schema niet aanmaken omdat deze conflicteert met een bestaand schema.',
        connect: 'Koppelen',
        connected: 'Gekoppeld',
        connectFunctions: 'Functies koppelen',
        contactGroup: 'Contact',
        contactInformation: 'Contactinformatie',
        contentEndDate: 'Deze cursus is vanaf datum {date} niet meer te starten!',
        contentExpired: 'Deze cursus is verlopen en kan daarom niet meer gestart worden!',
        contents: 'Inhoud',
        continue: 'Doorgaan',
        continueLearning: 'Doorgaan met leren',
        copied: 'Gekopieerd',
        copy: 'Kopiëren',
        copyAssignments: 'Toewijzingen kopiëren',
        copyAssignmentsToOtherUsers: 'Toewijzingen kopiëren naar andere gebruikers',
        copyNoun: 'Kopie',
        country: 'Land',
        course: 'Klassikale opleiding',
        courseHasBeenReplaced: 'Deze cursus is vervangen door',
        CourseProvider: 'Cursusaanbieder',
        courseResetTitle: 'Medewerker mag voortgang resetten',
        courseResetAllow: 'Mag altijd',
        courseResetDeny: 'Mag nooit',
        courseResetDefault: 'Afhankelijk van globale instelling',
        'courseResultsHistory.deleteAchievementDialog.body':
            'Weet u zeker dat u dit resultaat wilt verwijderen?',
        'courseResultsHistory.deleteAchievementDialog.title': 'Resultaat verwijderen',
        'courseResultsHistory.result.success': 'Resultaat succesvol verwijderd',
        'courseResultsHistory.result.error': 'Er is een fout opgetreden',
        courses: 'Klassikale opleidingen',
        courseSelected: 'opleiding geselecteerd',
        Costs: 'Kosten',
        created: 'Gestart',
        creationDate: 'Aanmaakdatum',
        createdBy: 'Aangemaakt door',
        createNewLearningPath: 'Maak nieuw leerpad',
        createNewAssessment: 'Maak nieuwe beoordeling',
        createNewForm: 'Maak nieuw formulier',
        current: 'Actueel',
        currentProgress: 'Huidige voortgang',
        currentRegistrations: 'Actuele inschrijvingen',
        CurrentPassword: 'Huidig wachtwoord',
        currentStartDates: 'Actuele startdata',
        currentStatus: 'Huidige status',
        dashboard: 'Dashboard',
        'dashboard.widgets.adminnotification.title': 'Klassikale opleidingen',
        'dashboard.widgets.adminnotification.subtitle':
            'Bekijk waarschuwingen voor de komende 3 maanden',
        'dashboard.widgets.notification.title': 'Mijn berichten',
        'dashboard.widgets.notification.subtitle': 'Bekijk ongelezen berichten',
        dashboardLinks: 'Dashboard links',
        dashboardTitle: 'Dashboard welkomsttekst',
        dashboardTile: 'Deze tekst wordt bovenaan het dashboard getoond',
        'dashboard.widget.hl.traject': 'Leertraject',
        'dashboard.widget.hl.community': 'Community',
        'dashboard.widget.hl.scan': 'Scan',
        'dashboard.widget.hl.box': 'Box',
        date: 'Datum',
        dateAndInfo: 'Datum & info',
        DateAndTime: 'Datum & tijd',
        dateAscending: 'Datum oplopend',
        dateDescending: 'Datum aflopend',
        dateIsNotKnown: 'Datum is niet bekend',
        dateOfAssessment: 'Beoordelingsdatum',
        dateOfBirth: 'Geboortedatum',
        dateOfExpiry: 'Verloopdatum',
        dateShownInterest: 'Interesse getoond op',
        dateStatusFrom: 'Datum status vanaf:',
        dateStatusTill: 'Datum status t/m:',
        dateToExpire: 'Gaat binnen {number} maanden verlopen',
        day: 'Dag',
        dayAbout: '{number} dag',
        dayAgo: '{number} dag geleden',
        dayClassroomTraining: 'daagse klassikale opleiding',
        dayParts: 'dagdelen',
        days: 'Dagen',
        daysAbout: '{number} dagen',
        daysAgo: '{number} dagen geleden',
        Deactivate: 'Deactiveer',
        DeactivatePackage: 'Deactiveer pakket',
        definitionAvailable: 'Beschikbaar',
        definitionReviewByTeacher: 'Beoordelen door docent',
        definitionReviewByManager: 'Beoordelen door manager',
        definitionAcceptByTeacher: 'Accepteren door docent',
        definitionAcceptByManager: 'Accepteren door manager',
        delete: 'Verwijderen',
        deleteAnswer: 'Antwoord verwijderen',
        deleteAllAssignments: 'Verwijder alle toewijzingen',
        deleteAllAssignmentsForThisExaminer: 'Alle toewijzingen voor deze beoordelaar verwijderen',
        deleteApprovalDate: 'Basisdatum opnieuw berekenen',
        delete_what_: `{what, select,
            role {Rol}
            other {Item}
        } verwijderen`,
        deleteAssessment: 'Beoordeling verwijderen',
        deleteAssessor: 'Beoordelaar verwijderen',
        deleteAssignments: 'Verwijderen',
        deleteCategory: 'Categorie verwijderen',
        deleteForm: 'Formulier verwijderen',
        deleted: 'Verwijderd',
        deletedBy: 'Verwijderd door',
        deleteConfirmationForAssignmentForCatalogItem: `Weet u zeker dat u de toewijzing voor de opleiding ''{catalogItemName}'' wilt verwijderen?`,
        deleteConfirmationForAllCatalogAssignments: `Weet u zeker dat je alle toewijzingen van dit catalogusitem wilt
                        verwijderen? Dat betekent dat dit catalogusitem aan geen enkele afdeling, functie,
                        groep of gebruiker meer toegewezen is. Geen enkele gebruiker kan dit
                        catalogusitem dan vinden in de catalogus (exclusief beheerder)`,
        deleteConfirmationForAllDepartmentsAndRoles:
            'Weet u zeker dat u de toewijzing voor alle afdelingen en functies wilt verwijderen?',
        deleteConfirmationForAssignmentForGroupAndFunction: `Weet u zeker dat u de toewijzing voor de afdeling ''{groupName}'' en functie ''{roleName}'' wilt verwijderen?`,
        deleteConfirmationForAssignmentForGroups: `Weet u zeker dat u de toewijzing voor de afdeling/klas ''{groupName}'' wilt verwijderen?`,
        deleteConfirmationForAssignmentForFunctions: `Weet u zeker dat u de toewijzing voor de functie ''{roleName}'' wilt verwijderen?`,
        deleteConfirmationForAssignmentForUsers: `Weet u zeker dat u de toewijzing voor de gebruiker/groep ''{displayName}'' wilt verwijderen?`,
        deleteConfirmationForAdmin: `Weet u zeker dat u de gebruiker/groep ''{displayName}'' wilt verwijderen uit beheerders?`,
        deleteConfirmationForAssessors: `Weet je zeker dat je ''{displayName}'' wilt verwijderen als toetser?`,
        deleteConfirmationForDepartmentReviewers: `Weet u zeker dat u de gebruiker/groep ''{displayName}'' wilt verwijderen uit afdelingsrapporteurs?`,
        deleteConfirmationForPlanners: `Weet u zeker dat u de gebruiker/groep ''{displayName}'' wilt verwijderen uit planners?`,
        deleteConfirmationForResult: `Weet je zeker dat je de datum van deze basis opnieuw wilt berekenen? Het kan zijn dat het resultaat van de basis daarmee komt te vervallen omdat de onderliggende activiteiten inmiddels verlopen zijn.`,
        deleteBasicApprovalDate: `Weet u zeker dat u de basisdatum van ''{groupName}'' opnieuw wilt berekenen?`,
        deleteDepartment: 'Afdeling verwijderen',
        deleteGroup: 'Groep verwijderen',
        DeleteNewsItem: `Weet u zeker dat u nieuwsbericht ''{newsItemTitle}'' wilt verwijderen?`,
        deleteConfirmationForLink: `Weet u zeker dat u deze link ''{link}'' wilt verwijderen?`,
        deleteCourse: 'Opleiding verwijderen',
        deleteCourseImpossible:
            'Het is op dit moment niet mogelijk om deze klassikale opleiding te verwijderen.',
        'deleteCourseImpossible.courseHasConnections': 'Deze opleiding is nog toegewezen',
        'deleteCourseImpossible.courseHasEnrollees':
            'Deze opleiding heeft deelnemers (actief en/of in archief)',
        'deleteCourseImpossible.courseHasPlannings':
            'Deze opleiding heeft roosters (actief en/of in archief)',
        'deleteCourseImpossible.courseAssignedToSkillAsActivity':
            'Deze opleiding is onderdeel van de volgende bekwaamheden:',
        deleteOption: 'Optie verwijderen',
        DeletePackage: 'Verwijder pakket',
        DeletePortalGroup: `Weet u zeker dat u afdeling ''{portalGroupName}'' wilt verwijderen?`,
        deletePortfolio: 'Weet u zeker dat u dit dossieritem wilt verwijderen?',
        deletePortfolioDefinition: 'Weet u zeker dat u deze dossierdefinitie wilt verwijderen?',
        deletePortfolioItem: 'Dossieritem verwijderen?',
        deletePortfolioItemText: 'Weet u zeker dat u deze dossieritem wilt verwijderen?',
        deletedPortfolioDefinition: 'Dossierdefinitie verwijderd',
        deleteQuestion: 'Vraag verwijderen',
        deleteSchedule: 'Sessie verwijderen',
        deleteSection: 'Blok verwijderen',
        deleteSkill: 'Bekwaamheid verwijderen',
        deleteSkillAssignment: 'Toewijzing verwijderen',
        deleteTextField: 'Tekstveld verwijderen',
        deleteMessage: 'Bericht verwijderen',
        deleteUser: 'Gebruiker verwijderen',
        department: 'Afdeling',
        departmentDeleted: 'Afdeling verwijderd',
        departmentRoleDeleted: 'Afdeling/functie deleted',
        departmentFunction: 'Afdeling / functie',
        departmentNoActiveMembers: 'De gekozen afdeling heeft geen (actieve) gebruikers',
        departments: 'Afdelingen',
        'departmentSaveMessage.added': 'Afdeling succesvol opgeslagen',
        'departmentSaveMessage.deleted': 'Afdeling succesvol verwijderd',
        'departmentSaveMessage.conflict': 'Er bestaat al een afdeling met dezelfde naam',
        'departmentSaveMessage.generalError':
            'Er is een probleem opgetreden. Neem contact op met de beheerder',
        departmentsSelectAll: 'Alle afdelingen selecteren',
        departmentReviewers: 'Afdelingsrapporteurs',
        dequeue: 'Uit wachtrij',
        description: 'Omschrijving',
        disagree: 'Oneens',
        DirectLink: 'Directe link',
        disable: 'Deactiveren',
        disabled: 'Uitgeschakeld',
        disableAccount: 'Account deactiveren',
        disabledAccount: 'Uitgeschakeld account',
        disableUserAccountDialog: 'Account deactiveren',
        disableUserAccountPerDate: 'Account deactiveren vanaf',
        discard: 'Verwijderen',
        discardChanges:
            'Je hebt wijzigingen gemaakt en deze nog niet opgeslagen. Als je dit scherm nu verlaat, gaan de wijzigingen verloren.',
        discardChangesShort: 'Niet opgeslagen wijzigingen gaan verloren.',
        discardChangesTitle: 'Wijzigingen verwijderen?',
        disconnectEmployee: 'Medewerker ontkoppelen',
        disconnectFunctions: 'Functies ontkoppelen',
        disconnectIndividual: 'Individu ontkoppelen',
        displayName: 'Volledige naam',
        displayFromDate: 'Weergave vanaf',
        displayUntilDate: 'Weergave tot',
        displaySettings: 'Weergave instellingen',
        documents: 'Documenten',
        documentDeleted: 'Document verwijderd',
        documentAlwaysVisible: 'Document altijd zichtbaar',
        documenttype: 'Document',
        documentVisibleAfterRegistration: 'Document zichtbaar na inschrijving',
        done: 'Klaar',
        DoNotShowThisVideoAnymore: 'Laat deze video niet meer zien',
        DoubleTeacher: 'Dubbele docent',
        DoubleLocation: 'Dubbele locatie',
        down: 'Omlaag',
        download: 'Downloaden',
        downloadCertificate: 'Download certificaat',
        downloadCertificates: 'Download certificaten',
        downloadCertificatesNoAttendance: 'Er zijn nog geen deelnemers aanwezig gemeld',
        downloadAttendanceList: 'Download presentielijst',
        downloadAttendanceListDescription:
            'Kies hieronder welke additionele informatie u aan het rapport wilt toevoegen',
        dragAndDrop: 'Slepen en neerzetten',
        duplicate: 'Dupliceren',
        duplicateAssessor: 'Beoordelaar dupliceren',
        duplicateBlock: 'Blok dupliceren',
        duplicatePlanning: 'Planning dupliceren',
        duplicateQuestion: 'Vraag dupliceren',
        duplicateTextField: 'Tekstveld dupliceren',
        duration: 'Looptijd',
        'duration.start': 'Looptijd start datum',
        'duration.end': 'Looptijd eind datum',
        edit: 'Bewerken',
        editAccreditation: 'Bewerk accreditatie',
        editApprovalDate: 'Basisdatum aanpassen',
        editAssessment: 'Beoordeling bewerken',
        editBlockTitle: 'Bloktitel bewerken',
        editCatalog: 'Bewerk catalogus',
        editCatalogItem: 'Catalogusitem bewerken',
        editCategory: 'Categorie bewerken',
        editContent: 'Inhoud bewerken',
        editCourse: 'Klassikale opleiding bewerken',
        editEvaluationForm: 'Evaluatieformulier bewerken',
        editForm: 'Formulier bewerken',
        editLearningPath: 'Leerpad bewerken',
        editLink: 'Link bewerken',
        editLocation: 'Locatie bewerken',
        EditNewsItem: 'Nieuwsbericht wijzigen',
        editOption: 'Optie bewerken',
        editPlanning: 'Rooster bewerken',
        EditPortalGroup: 'Afdeling bewerken',
        editQuestion: 'Vraag bewerken',
        editSectionTitle: 'Sectietitel bewerken',
        editSkill: 'Bekwaamheid bewerken',
        editTool: 'Hulpmiddel bewerken',
        elearning: 'E-learning',
        elearnings: 'E-learnings',
        elearningmanagement: 'E-learningbeheer',
        elearningReset: 'Reset e-learning & leerpad',
        enrollDepartmentUsers: 'Medewerkers van de afdeling inschrijven',
        Error404: 'Fout 404',
        email: 'E-mail',
        emailaddress: 'E-mailadres',
        emailWork: 'E-mail werk',
        emailNotification: 'E-mail notificatie',
        emailPrivate: 'Privé e-mail',
        employee: 'Medewerker',
        employeeAndRoleAreMandatory: 'Medewerker en rol zijn verplicht',
        employeeNumber: 'Personeelsnummer (gebruikersnaam)',
        employees: 'Medewerkers',
        enableAccount: 'Account activeren',
        end: 'Eind',
        endDate: 'Einddatum',
        endTime: 'Eindtijd',
        enqueue: 'In wachtrij',
        enroll: 'Inschrijven',
        enrollAnotherEmployeeAfterProcessing: 'Na verwerking nog een medewerker inschrijven',
        enrollEmployees: 'Medewerkers inschrijven',
        enrollment: 'Inschrijfbevestiging',
        enrollmentFailed: 'Inschrijving niet mogelijk',
        enrollmentSucceeded: 'Inschrijving geslaagd',
        Enrollments: 'Inschrijvingen',
        enrollmentDeadline: 'Inschrijftermijn',
        errorEnrolling:
            'Helaas ging er iets mis. De inschrijving is niet verwerkt. Probeer het later opnieuw.',
        enrollmentDeadlineInDays: 'Inschrijftermijn in dagen',
        enrollReservationError: `{ status, select,
            NotExists {Reserveringscode bestaat niet}
            Expired {Reserveringscode is verlopen}
            AlreadyUsed {Reserveringscode is al gebruikt}
            AlreadyEnrolled {Persoon die je probeert in te schrijvern is al ingeschreven}
            NoValidSchedule {Planning is ongeldig of is al geweest}
            other {{status}}
        }`,
        enterReviews: 'Beoordelingen',
        entire: 'Gehele',
        errorDownloadingFile: 'Fout bij downloaden! Melding:',
        errorMessageText: 'Melding',
        errorMessageTextHeadline: 'Algemene melding',
        errorMessageTextSubtitle: 'Opvallende melding bovenaan iedere pagina',
        errorMessageWarningTypeHeadline: 'Soort melding (kleur)',
        errorMessageWarningTypeSubtitle: 'Selecteer het soort melding met bijbehorende kleur',
        'message.settings.warningType.label': 'Soort melding',
        'message.settings.warningType.error': 'Fout / verstoring (rood)',
        'message.settings.warningType.warning': 'Waarschuwing (oranje)',
        'message.settings.warningType.success': 'Positief (groen)',
        'message.settings.warningType.inprogress': 'Neutraal (blauw)',
        errorNavigateToElearning: 'De e-learning kan niet gestart worden',
        evaluateTheCoursesThatYouHaveAccomplished: 'Evalueer de cursussen die u heeft gevolgd',
        evaluation: 'Evaluatie',
        evaluationFormName: 'Evaluatie formulier naam',
        evaluations: 'Evaluaties',
        evaluationForm: 'Evaluatieformulier',
        evaluationForms: 'Evaluatieformulieren',
        everyone: 'Iedereen',
        everyoneVisible: 'Iedereen zichtbaar',
        examUpdated: 'Toetsresultaat bijgewerkt',
        examiner: 'Beoordelaar',
        Examiner_not_found_in_activity: 'Toetser was niet gekoppeld aan deze activiteit',
        Examiner_region_description_address_required: 'Adres is verplicht',
        ExaminerNotFoundInActivity: 'Toetser was niet gekoppeld aan deze activiteit',
        examinerReview: 'Beoordelingsaanvraag',
        examinerReviews: 'Beoordelingsaanvragen',
        examiners: 'Toetsers',
        examinersCannotBeUsed:
            'Er zijn beoordelaars toegewezen aan activiteiten van deze bekwaamheid. Het is daarom niet mogelijk om de toetser functionaliteit te activeren. Verwijder eerst de beoordelaars.',
        examinersUserCanSelectTimeSlot: 'Gebruiker kan tijdslot kiezen',
        examinersUserCanSelectExaminer: 'Gebruiker kan toetser kiezen',
        examinersUserCanCombineExams: 'Gebruiker kan toetsmomenten combineren',
        examinersStandardDurationTimeSlot: 'Standaardduur toetsblok',
        examinersStandardDurationExam: 'Standaardduur toetsmoment',
        examinersRegionLocation: 'Regio / locatie',
        examinersRegionsLocations: 'Regios / locaties',
        examinersAddRegionLocation: 'Regio / locatie toevoegen',
        examinersDeleteRegionLocation: 'Regio / locatie "{location}" verwijderen?',
        examinersAddAvailability: 'Voeg beschikbaarheid toe',
        examinersEditAvailability: 'Beschikbaarheid bewerken',
        examinersAddSchedule: 'Voeg een schema toe',
        examinersScheduleDetails: 'Activiteiten op {date} - {timeslot}',
        examinersNoReservations: 'Geen reserveringen',
        examinersHasReservations: 'Wel reserveringen',
        examinersDeleteCurrentSchedule: 'Huidig schema verwijderen?',
        examinersPlannedExams: 'Ingeplande toetsmomenten',
        examinersAvailability: 'Beschikbaarheid',
        examinerScheduleMandatoryStartEndDate: 'Vul een begin en eind datum/tijd in',
        examinerScheduleSameStartEndTime: 'Start en eindtijd mogen niet gelijk zijn',
        examinerScheduleStartEndDateNotTheSame: 'Start en einddatum moeten gelijk zijn',
        endDateBeforeStartDateError: 'Einddatum mag niet voor begindatum liggen',
        examinerScheduleNoRegion: 'Regio is verplicht',
        examinerAvailableSpace:
            'Er is tijd vrij bij een eerder gepland toetsmoment, wil je toetsen combineren?',
        examinerValidResult:
            'Je hebt nog een resultaat wat geldig is tot {date}. Toch een nieuwe afspraak inplannen?',
        examinerCombineTest: 'Toetsmoment combineren?',
        examinerCombineTestYes: 'Ja, combineer toetsen',
        examinerCombineTestNo: 'Nee, nieuw toetsmoment inplannen',
        examinerDurationOfTheExam: 'Duur van het toetsmoment (minuten)',
        examinerNewAppointment: 'Nieuwe afspraak',
        examinerCombineToWhichAppointment: 'Aan welk toetsmoment wil je deze toevoegen?',
        'examiner.appointment.activity': 'Wil je de activiteit ',
        'examiner.appointment.combine': 'combineren met het onderstaande toetsmoment?',
        'examiner.appointment.examiner': 'Toetser: ',
        'examiner.appointment.dateTime': 'Datum en tijd: ',
        'examiner.appointment.regionLocation': 'Regio / locatie: ',
        examinerNoAppointmentsTitle: 'Ingeplande toetsmomenten',
        examinerNoAppointmentsDescription: 'Er zijn geen ingeplande toetsmomenten gevonden',
        examinerDeleteAppointment: 'Toetsmoment verwijderen?',
        exceededRegistrationPeriod: 'Het is niet meer mogelijk je in te schrijven.',
        exceededUnRegistrationPeriod:
            'Je wilt een deelnemer uitschrijven of overschrijven maar de uitschrijf termijn is bereikt. "Je kan een deelnemer niet meer uitschrijven. Neem contact op met de opleiders."',
        exceededUnRegistrationPeriodSelf:
            'Je wilt jezelf uitschrijven of overschrijven maar de uitschrijf termijn is bereikt. "Je kan niet meer jezelf uitschrijven. Neem contact op met de opleiders."',
        exception: 'Uitzondering',
        'exception.add': 'Uitzondering toevoegen',
        'exception.remove': 'Uitzondering verwijderen',
        'exception.remove.areYouSure':
            'Weet u zeker dat u de uitzondering voor deze training ({name}) wilt verwijderen?',
        exceptions: 'Uitzonderingen',
        exemption: 'Vrijstelling',
        exemptionEdit: 'Vrijstelling geven',
        exemptionExpired: 'Vrijstelling verlopen',
        exemptionsHaveBeenGranted:
            'Vrijstellingen zijn verleend. Let op, het kan enkele minuten duren voordat dit zichtbaar is in het bekwaamheidspaspoort',
        exemptionStatusDescription: `De bekwaamheid wordt als 'voldaan' gemarkeerd tot aan de ingestelde datum. Dat betekent dat de medewerker tot aan deze datum geen actie hoeft te ondernemen.`,
        exemptionUntil_date_: 'Vrijstelling tot {date}',
        exemptionValidTill: 'Vrijstelling tot',
        expertise: 'Dossieritem',
        expertiseDeleted: 'Expertise verwijderd',
        expertiseTodoTasks: 'Taken:',
        Expertises_authorize: 'Dossieritems autoriseren',
        Expertises_review: 'Dossieritems beoordelen',
        Expertises_updated_status: 'Dossiertaken bijgewerkt',
        expirationDate: 'Verloopdatum',
        expirationDateEditInfo:
            'Bij een wijziging wordt de nieuw berekende verloopdatum na enkele minuten toegepast op alle (reeds behaalde) resultaten.',
        expirationPeriod: 'Verloopperiode',
        existingAssignments: 'Bestaande toewijzingen',
        individualAssignmentValidityInfo:
            'Geldigheid in maanden voor deze medewerkers. Daarna per medewerker aan te passen.',
        ExpirationPeriod: 'Verloopperiode',
        expires: 'Verloopt',
        expiresOn: 'Verloopt op',
        expiresOn_date_: 'Verloopt op {date}',
        expired: 'Verlopen',
        expiredOn_date_: 'Verlopen op {date}',
        explanationOrquestion: 'Toelichting/vraag',
        export: 'Exporteren',
        exportContent: 'Inhoud exporteren',
        exportContentNothingToExport: 'Er is niets om te exporteren',
        exportCurrentState: 'Actuele stand van zaken',
        exportFailed: 'Exporteren mislukt',
        exportFailedTryAgain: 'Exporteren mislukt, probeer het opnieuw',
        exportOptions: 'Export opties',
        exportPDF: 'PDF exporteren',
        exportSpecificPeriod: 'Specifieke periode',
        exportSpecificPeriodWarning: `Een export van een specifieke periode toont alleen bekwaamheden en activiteiten die in de geselecteerde periode zijn behaald. Medewerkers die bekwaam zijn, maar dit in een eerdere periode hebben behaald, staan niet in deze export.`,
        extendExpirationDate: 'Verloopdatum verlengen',
        ExternalRegistrationNumber: '{name}-nummer',
        ExtraOptions: 'Extra opties',
        ExternalCost: 'Externe kosten',
        failed: 'Gezakt',
        Failed: 'Gezakt',
        false: 'nee',
        favoriteTrainings: 'Favorieten',
        fullCatalog: 'Volledige catalogus',
        FavoriteWidgetInfo: 'Bekijk jouw favoriete catalogusitems',
        FailedAlreadyRegistered: 'Al ingeschreven',
        FailedAlreadyRegisteredOnThisPlanning: 'De persoon is al ingeschreven op dit rooster.',
        FailedCapacityReachedPlanningIsFull:
            'De persoon kan niet worden ingeschreven op dit rooster, want dit rooster is al vol.',
        FailedConflictingEnrollmentOnOtherCourse: 'Al ingeschreven op een andere cursus.',
        FailedMaxNumRegistrationsReachedOnCourse:
            'De persoon kan niet worden ingeschreven op dit rooster, want het maximaal aantal inschrijvingen van de cursus is bereikt.',
        fileUploadRequired: 'Bestandsupload vereist',
        filterByDate: 'Filter op datum',
        filterOnCatalogName: 'Filter op catalogusnaam',
        filterOnCategory: 'Filter categorie',
        filterOnCategories: 'Filter op categorieën',
        filterOnCategoryOrSkill: 'Filter op categorie of bekwaamheid',
        filterOnCluster: 'Filter cluster',
        filterOnDepartment: 'Filter op afdeling',
        filterOnDepartmentName: 'Filter op afdelingsnaam',
        filterOnEmployee: 'Filter op medewerker',
        filterOnFunction: 'Filter op functie',
        filterOnName: 'Filter op naam',
        filterOnDescription: 'Filter op naam dossieritem',
        filterOnSkill: 'Filter bekwaamheid',
        filter: 'Filter',
        filters: 'Filters',
        findUnderlyingDepartment: 'Zoek onderliggende afdeling',
        finished: 'afgerond',
        firstName: 'Voornaam',
        fivePointLikertScale: '5-Punts Likertschaal',
        Float: 'Richting',
        font: 'Lettertype',
        'forecastPlanningReport.available': 'Vrije plekken',
        'forecastPlanningReport.forecast': 'Vooruitblik',
        'forecastPlanningReport.training': 'Training',
        'forecastPlanningReport.isAlmostExpired': 'Gaan verlopen',
        'forecastPlanningReport.isRed': 'Niet voldaan / verlopen',
        'forecastPlanningReport.months': `{ month, select,
            january {Januari}
            february {Februari}
            march {Maart}
            april {April}
            may {Mei}
            june {Juni}
            july {Juli}
            august {Augustus}
            september {September}
            october {Oktober}
            november {November}
            december {December}
            other {{month}}
        }`,
        'forecastPlanningReport.from': 'van',
        'forecastPlanningReport.disclaimer.reportInfo': 'Rapport toelichting',
        'forecastPlanningReport.disclaimer.title':
            'Dit rapport is een prognose van het aantal benodigde plekken op basis van verloopdatums en toewijzingen. Het geeft geen inzicht in medewerkergegevens of resultaten.',
        'forecastPlanningReport.disclaimer.info': 'Kolom toelichting',
        'forecastPlanningReport.disclaimer.training': 'Training',
        'forecastPlanningReport.disclaimer.trainingInfo':
            'Naam van training. Bij te weinig plekken (t.o.v. minimum) wordt een oranje balk getoond.',
        'forecastPlanningReport.disclaimer.seats': 'Vrije plekken',
        'forecastPlanningReport.disclaimer.seatsInfo':
            'Aantal beschikbare plekken (en totale capaciteit) voor deze training in deze maand.',
        'forecastPlanningReport.disclaimer.willExpire': 'Gaan verlopen',
        'forecastPlanningReport.disclaimer.willExpireInfo':
            'Prognose op basis van verloopdatums: min. (verplicht) en max. (verplicht + aanbevolen/optioneel) voor deze maand.',
        'forecastPlanningReport.disclaimer.minimum': 'Min.',
        'forecastPlanningReport.disclaimer.minimumInfo':
            'Aantal medewerkers voor wie deze training verplicht is met een verlopend resultaat (oranje) in deze maand.',
        'forecastPlanningReport.disclaimer.maximum': 'Max.',
        'forecastPlanningReport.disclaimer.maximumInfo': `Aantal medewerkers voor wie deze training aanbevolen of optioneel is met een verlopend resultaat (oranje) in deze maand.`,
        'forecastPlanningReport.disclaimer.redCount': 'Niet voldaan / verlopen',
        'forecastPlanningReport.disclaimer.redCountInfo':
            'Actueel aantal medewerkers voor wie deze training verplicht is, zonder geldig resultaat (rood).',
        'forecastPlanningReport.conclusion': `Let op: Dit is een prognose. De organisatie bepaalt zelf het definitieve aantal plekken.`,
        forbidden: 'Geen toegang',
        forbiddenDepartment: 'U bent niet bevoegd om deze afdeling in te zien.',
        forms: 'Formulieren',
        formIncomplete: 'Formulier is niet volledig ingevuld',
        formName: 'Naam formulier',
        formDescription: 'Beschrijving formulier',
        formMustContainAtLeastOneSection: 'Formulier moet minstens 1 blok bevatten',
        formSectionsMustContainAtLeastOneQuestion: 'Blokken moeten minstens 1 vraag bevatten',
        freeChoice: 'Vrije keuze',
        freeSpace: 'Vrije ruimte',
        from: 'van',
        fromMax: 'van max.',
        fromNow: 'Vanaf nu',
        fromTime: 'Vanaf',
        Full: 'Uitvullen',
        fullProfile: 'Volledig profiel',
        function: 'Functie',
        functions: 'Functies',
        functionsManagement: 'Functies beheren',
        fromLeft: 'Vanaf links',
        fromTop: 'Vanaf bovenkant',
        future: 'Toekomstig',
        general: 'Algemeen',
        generateAndDownloadExportFile:
            'Genereer en download een Excelbestand met alle behaalde resultaten van e-learnings en klassikale opleidingen in het geselecteerde jaar.',
        generateAndDownloadExportFileTitle: 'E-learnings & opleidingen',
        generateAndDownloadExportFileLearningPaths:
            'Genereer en download een Excelbestand met alle behaalde resultaten van leertrajecten in het geselecteerde jaar.',
        generateAndDownloadExportFileLearningPathsTitle: 'Leerpaden',
        generateAndDownloadExportFileSkills:
            'Genereer en download een Excelbestand met alle aangetoonde bekwaamheden en afgeronde activiteiten in het geselecteerde jaar.',
        generateAndDownloadExportFileSkillsTitle: 'Bekwaamheden',
        getPwa: 'Installeer app',
        getContactIfQuestion: 'Neem bij vragen contact op met de beheerder',
        giveManagersRightsToSubDepartments: 'Geef managers ook rechten op onderliggende afdelingen',
        gotoCatalogitem: 'Naar catalogusitem',
        gotoChildLevel: 'Ga naar onderliggend niveau',
        gotoCommunity: 'Ga naar community',
        gotoReport: 'Naar rapport',
        group: 'Groep',
        groupName: 'Groepsnaam',
        groups: 'Groepen',
        groupEnrollmentTitle:
            'Kies op welk rooster je de medewerkers van de geselecteerde afdeling in wilt schrijven',
        groupEnrollmentEmptyPlanning: 'Nog geen deelnemers ingeschreven',
        HasTaggedRegistration: 'HasTaggedRegistration',
        Headings: 'Kopteksten',
        headingColor: 'Titelkleur',
        Hello: 'Hallo',
        Help: 'Ondersteuning',
        hideNoActionNotAssigned: 'Verberg niets gedaan / niet toegewezen',
        hideNotAssigned: 'Verberg niet toegewezen',
        hidden: 'Verborgen',
        hlapps: 'Werk- & leervormen',
        'hlapps.back': 'Terug naar Werk- & Leervormen',
        'hlapps.back.mobile': 'Werk- & Leervormen',
        'hlapps.name': `{id, select,
            1 {Community}
            2 {Scan}
            12 {Box}
            13 {Kracht- & Ontwikkelpunten}
            17 {Leertraject}
            other {Werk- & Leervorm}
        }`,
        'hlapps.subtitle': `{id, select,
            1 {Ontmoet elkaar online}
            2 {Maak ontwikkeling zichtbaar}
            12 {Raadpleeg broninformatie}
            13 {Ga voor persoonlijke groei}
            17 {Bekijk jouw opleidingsoverzicht}
            other {''{id}''}
        }`,
        'hlapps.rib': 'Dagstart & Reflectie',
        'hlapps.rib.sub': 'Deel praktijksituaties',
        'hlapps.obs': 'Online Beeldsessie',
        'hlapps.obs.sub': 'Ga in gesprek',
        'hlapps.userman': 'Gebruikersbeheer',
        'hlapps.userman.sub': 'Wie doen er mee?',
        'hlapps.productman': 'Productbeheer',
        'hlapps.productman.sub': 'Wat gaan we doen?',
        helpAndFeedback: 'Hulp en feedback',
        hereYouFindAnOverviewOfAllAvailableElearningTrainingsExpertiseItemsAndClassActivities:
            'Hier vindt u een overzicht van alle beschikbare e-learning opleidingen, expertise items en klassikale activiteiten',
        hereYouFindAnOverviewOfAllAvailableDepartments:
            'Hier vindt u een overzicht van alle beschikbare afdelingen',
        hereYouFindAnOverviewOfAllAvailableFunctions: 'Alle beschikbare functies',
        hereYouFindAnOverviewOfAllAvailableTrainings:
            'Hier vindt u een overzicht van de beschikbare formele opleidingen, e-learning en klassikaal.',
        hereYouFindAnOverviewOfTheDepartmentsWhereYouAreAManager:
            'Hier vindt u een overzicht van de afdelingen waar u manager van bent',
        hereYouFindAnOverviewOfTheDepartmentsWhereYouWork:
            'Hier vindt u een overzicht van de afdelingen waar u werkt',
        hereBelowYouCanUpdateTheAttendanceOfTheParticipants:
            'Hieronder kunt u de presentie van de deelnemers bijwerken.',
        hiddenAt: 'Verborgen op {date}',
        hour: 'Uur',
        hourAbout: '{number} uur',
        hourAgo: '{number} uur geleden',
        hours: 'Uren',
        hoursAbout: '{number} uur',
        hoursAgo: '{number} uren geleden',
        hundredPercentVisibleInProportion: '100% zichtbaar, in verhouding',
        hundredVisibleStretched: '100% zichtbaar, opgerekt',
        ifTheMaximumNumberOfParticipantsIsReachedRegistrationWillClose:
            'Indien maximum aantal deelnemers is bereikt, sluit inschrijving',
        ignore: 'Negeren',
        ignoreChanges: 'Wijzigingen negeren?',
        insufficientRightsText: 'Je hebt niet genoeg rechten voor deze pagina.',
        insufficientRightsTitle: 'Niet genoeg rechten',
        Image: 'Afbeelding',
        'importmanagement.catalogItemResult': 'Catalogusitem resultaten',
        'importmanagement.catalogItemResult.catalog.header':
            'Voeg direct een resultaat van dit catalogusitem toe in het portfolio van een gewenste medewerker. <br/><br/> Selecteer de medewerker en stel een resultaatdatum in.',
        'importmanagement.catalogItemResult.portfolio.header':
            'Voeg direct een resultaat toe in het portfolio van {username}. Selecteer het betreffende catalogusitem en stel een resultaatdatum in',
        'importmanagement.catalogItemResult.portfolio.extraInfo':
            'Na het importeren van het resultaat moet u mogelijk de pagina verversen om het geïmporteerde resultaat weer te geven.',
        'importmanagement.classroomResults': 'Klassikale resultaten',
        'importmanagement.confirm.beware': 'LET OP!',
        'importmanagement.confirm.areYouSure':
            'Weet je zeker dat je het zojuist gekozen bestand wilt importeren?',
        'importmanagement.confirm.overwrite':
            'Reeds bestaande data (met bijv. een andere geldigheid) kan mogelijk overgeschreven worden door deze import.',
        'importmanagement.confirm.lost':
            'Dat betekent dat eventuele voortgang en resultaten verloren kunnen gaan.',
        'importmanagement.confirm.noReturn': 'Dit kan NIET ongedaan gemaakt worden!',
        'importmanagement.confirm.startImport': 'Ik weet het zeker, start import',
        'importmanagement.details': 'Details',
        'importmanagement.disclaimer':
            'Ik neem volledige verantwoordelijkheid voor de data die ik importeer en de daaruit voortvloeiende gevolgen',
        'importmanagement.dossierItems': 'Dossieritems',
        'importmanagement.downloadTemplate': 'Download template',
        'importmanagement.elearningResults': 'E-learning / Leerpad resultaten',
        'importmanagement.error': 'Fout',
        'importmanagement.exemptions': 'Vrijstellingen Bekwaamheden',
        'importmanagement.importFailed': 'Import mislukt',
        'importmanagement.importSuccessful': 'Import succesvol',
        'importmanagement.fileImport': 'Importeer bestand',
        'importmanagement.fileUpload': 'Upload importbestand (.csv)',
        'importmanagement.heading.date': 'Datum',
        'importmanagement.heading.result': 'Resultaat',
        'importmanagement.heading.type': 'Import type',
        'importmanagement.newImport': 'Nieuwe import',
        'importmanagement.notImported': 'NIET geïmporteerd',
        'importmanagement.optionsByTemplate': 'Opties op basis van de geselecteerde template',
        'importmanagement.portfolioItemResult': 'Dossier resultaten',
        'importmanagement.provider': 'Aanbieder',
        'importmanagement.publishDirectly': 'Items direct te publiceren in de catalogus',
        'importmanagement.result': 'Resultaat importeren',
        'importmanagement.selectProvider': 'Aanbieder selecteren',
        'importmanagement.selectTemplate': 'Selecteer template',
        'importmanagement.skillOrLearningPathResult': 'Bekwaamheid / Leerpad activiteit resultaten',
        'importmanagement.skillActivityResults': 'Bekwaamheden resultaten',
        'importmanagement.template.catalogItemResult': 'Resultaten voor catalogusitem',
        'importmanagement.template.exemptions': 'Vrijstellingen voor bekwaamheid',
        'importmanagement.template.noActivitiesToImportWarningMessage':
            'Deze bekwaamheid bevat geen activiteiten waarop een import mogelijk is via deze importroute',
        'importmanagement.template.numberOfActivitiesInTheReportInfoMessage':
            '{number} activiteit(en) wordt/worden in deze template opgenomen',
        'importmanagement.template.portfolioItemResult': 'Resultaten voor dossieritem',
        'importmanagement.template.skillActivityResults':
            'Resultaten voor activiteiten in bekwaamheid / leerpad (excl. catalogusitems)',
        'importmanagement.template.skillActivityResultsWarningMessage':
            'Deze template bevat alle activiteiten van de geselecteerde bekwaamheid, behalve catalogusitems (deze hebben een eigen importroute via "Resultaten voor catalogusitem")',
        'importmanagement.whatDomain': 'In welk domein wil je importeren?',
        'importmanagement.whatToImport': 'Wat wil je importeren?',
        'importmanagement.errorCode': `{error, select,
            ERR0 {bestandsstructuur niet juist}
            ERR1 {niet bestaande medewerkers geconstateerd}
            ERR2 {niet bestaande bekwaamheden geconstateerd}
            ERR3 {niet gekoppelde bekwaamheden geconstateerd}
            ERR4 {academyInfo niet gevonden}
            ERR6 {niet bestaande catalogusitems geconstateerd}
            ERR7 {niet bestaande dossier definities geconstateerd}
            ERR8 {compleet met fouten}
            ERR9 {onverwerkte uitzondering}
            other {{error}}
        }`,
        'importmanagement.status': `{statusId, select,
            0 {Importbestand geüpload}
            1 {Bestand wordt gecontroleerd...}
            2 {Gebruikers bestaan}
            3 {Bekwaamheden bestaan}
            4 {Bekwaamheden toegewezen aan gebruikers}
            5 {Import mislukt}
            6 {Import bezig...}
            7 {Import gelukt}
            8 {Geïmporteerd met fouten}
            other {{statusId}}
        }`,
        'importmanagement.type': `{typeId, select,
            0 {E-learning resultaten}
            1 {Vrijstellingen Bekwaamheden}
            2 {Bekwaamheid / Leerpad activiteit resultaten}
            3 {Klassikaal}
            4 {Klassikale resultaten}
            5 {Dossier resultaten}
            6 {LTI-items}
            other {{typeId}}
        }`,
        import: 'Importeren',
        imported: 'import',
        Inactive: 'Inactief',
        inapplicable: 'Deze bekwaamheid is niet van toepassing',
        inapplicable2: 'Niet van toepassing',
        includeChildDepartments: 'Incl onderliggend',
        includeAllSubdepartments: 'Inclusief alle subafdelingen',
        Indent: 'Inspringing vergroten',
        individual: 'Individu',
        individual2: 'Individueel',
        individuals: 'Individuen',
        information: 'Information',
        informationCancelPlanning:
            'Weet u zeker dat u deze planning wilt annuleren? U zult de deelnemers van deze planning moeten uitschrijven of overplaatsen naar een andere planning.',
        informationForYou: 'Meer informatie voor jou',
        inheritAssignments: 'Toewijzingen overnemen',
        inheritAssignmentsFromOtherUsers: 'Toewijzingen overnemen van andere gebruikers',
        initials: 'Initialen',
        inShort: 'In het kort',
        institution: 'Instelling',
        Intake: 'Intake',
        InternalCost: 'Interne kosten',
        introductionVideo: 'Introductievideo SDB Leerplatform',
        invalidDate: 'Ongeldige datum',
        invalidUrl: 'Ongeldige URL',
        isExemptFromPayment: 'Hoeft niet af te rekenen',
        isGoingToExpire: 'Gaat verlopen',
        IsSkill: 'Toegewezen als bekwaamheid',
        Italic: 'Cursief',
        Justify: 'Uitvullen',
        keepOpen: 'Open houden',
        lastLoginDate: 'Laatste inlogdatum',
        lastName: 'Achternaam',
        lastNamePrefix: 'Voorvoegsel',
        lastResult: 'Laatste resultaat',
        lastReviewDate: 'Laatste beoordelingsdatum',
        lastSuccessfulMark: 'Laatste succesvolle beoordeling',
        learningpath: 'Leerpad',
        LearningPath: 'Leerpad',
        latestAction: 'Laatste actie',
        learningPath: 'Leerpad',
        learningPaths: 'Leerpaden',
        learningPathsAndSkills: 'Leerpaden & bekwaamheden',
        learningPathOrSkill: 'Leerpad / Bekwaamheid',
        learningPathProgressWarning:
            'Deze weergave toont de huidige voortgang per activiteit. Let op: de geldigheid van het leerpad staat los van deze status. Een leerpad kan "groen" blijven terwijl onderliggende activiteiten verlopen.',
        learningplan: 'E-learning',
        Learningplan: 'e-Learning',
        LearningPoints: 'Leerpunten',
        learningplanTypes: 'e-Learning',
        learningProgram: 'Leerprogramma',
        Left: 'Links',
        lesson: 'les',
        lessons: 'lessen',
        likert: 'Likert-schaal',
        likertInfo:
            'Gebruikers kunnen hun mening op bijv. een stelling geven via een Likert-schaal. Deze bestaat uit 5 opties, van "Helemaal oneens" tot "Helemaal eens". Voeg eenvoudig meerdere vragen toe om een groep te creeren.',
        limitMaxNumberOfEnrollmentsPerParticipant: 'Beperk aantal inschrijvingen per deelnemer',
        Link: 'Hyperlink',
        linkMustBeginWith: 'Link moet beginnen met http:// of https://',
        listOfInterestedUsers: 'Geïnteresseerde gebruikers',
        listOfInterestedUsersInCourse: 'Geïnteresseerde gebruikers in cursus',
        location: 'Locatie',
        locationDeleted: 'Locatie verwijderd',
        locations: 'Locaties',
        login: 'Inloggen',
        loginSetting: 'Heet de gebruiker welkom op het loginscherm',
        loginDescription: 'Deze uitlegtekst voor de inlog is per portaal instelbaar',
        mailLogOverview: 'E-mail logging',
        mailTemplates: 'E-mailsjablonen',
        MailTemplateType: `{type, select,
            ClassroomEnqueue {Inschrijfbevestiging (Wachtrij)}
            ClassroomDequeue {Uitschrijfbevestiging (Wachtrij)}
            ClassroomEnroll {Inschrijfbevestiging}
            ClassroomUnenroll {Uitschrijfbevestiging}
            ClassroomTransfer {Overschrijfbevestiging}
            ClassroomCancel {Annuleringsbevestiging}
            ClassroomReminder {Herinneringsmail}
            other {{type}}
        }`,
        makeAppointment: 'Klik om een afspraak te maken',
        makeAChoice: 'Maak een keuze',
        manageUsers: 'Gebruikers beheren',
        managerGroups: 'afdelingen',
        managersAreAllowedToAssignCatalogItems: 'Managers mogen catalogusitems toewijzen',
        managersMayNotAssign: 'Managers mogen niet toewijzen',
        manageAssignments: 'Toewijzingen beheren',
        manageSkills: 'Bekwaamheden beheren',
        mandatory: 'Verplicht',
        mandatoryAndRecommendedTrainings: 'Verplichte en aanbevolen opleidingen',
        mandatoryOrRecommended: 'Verplicht & aanbevolen',
        mandatoryFieldsMustBeCompleted: 'Verplichte velden moeten ingevuld worden',
        mandatoryFrom: 'Verplicht vanaf',
        mandatoryFromSkillExpiry: 'Pas verplicht zodra de bekwaamheid verloopt',
        mandatoryNotMandatory: 'Verplicht / niet verplicht',
        mandatoryTrainings: 'Verplichte opleidingen',
        mandatoryTrainingsShort: 'Verpl. opleidingen',
        MandatoryTrainingsSubtitle: 'Begin er op tijd aan!',
        manual: 'Handleiding',
        markAsRead: 'Mark as unread',
        markAsUnread: 'Markeren als ongelezen',
        maxAmount: 'Maximum aantal',
        maxAttachmentFileSize: 'De totale grootte van de bestanden mag niet groter zijn dan 50 MB',
        maxCapacity: 'Maximum aantal deelnemers',
        maxCapacityMustBeHigherThanMinCapacity:
            'Maximum aantal is verplicht en moet hoger zijn dan minimum aantal',
        maximum: 'maximaal',
        maxNumberOfEnrollmentsPerParticipant: 'Maximum aantal inschrijvingen per deelnemer',
        maxNumberOfEnrollmentsPerParticipantIncorrect:
            'Waarde moet groter zijn dan 0 en maximaal 10',
        MaxNumberOfParticipantsReached: 'Max. aantal deelnemers bereikt',
        Message: 'Bericht',
        'message.header': `{ created, select,
            undefined {}
            other {{created} - }
        }{ sender, select,
            undefined {Systeembericht}
            other {{sender}}
        }{ autoGenerated, select,
            true { (automatisch verzonden)}
            other {}
        }`,
        'message.to': `Aan: {recipients}`,
        'message.subjectElearningNotificationMessage': 'Cursus afgerond',
        'message.achievementMessagePassed': `''{identityDisplayName} ({identityLogOnName})'' is geslaagd voor ''{catalogItemName}''`,
        'message.achievementMessageFinished': `''{identityDisplayName} ({identityLogOnName})'' heeft ''{catalogItemName}'' succesvol afgerond`,
        'message.assessorAppointmentMade': `Er is een afspraak gemaakt voor ''{studentDisplayName}'' op ''{dateTime}'' om de volgende activiteit af te laten toetsen: ''{activityDescription}''`,
        'message.assessorAppointmentRejected': `Het beoordelingsverzoek voor activiteit ''{activityDescription}'' op ''{dateTime}'' is afgewezen door ''{assessorDisplayName}''`,
        'message.assessorAppointmentRemoved': `De afspraak van gebruiker ''{studentDisplayName}'' op ''{dateTime}'' voor activiteit ''{activityDescription}'' is verwijderd`,
        'message.assessorAppointmentMadeSubject': `Toetsafspraak gemaakt`,
        'message.assessorAppointmentRemovedSubject': `Toetsfspraak verwijderd`,
        'message.catalogAuthRequestPermissionSubjectLearningplan':
            '{studentDisplayName} heeft een aanvraag voor e-learning {displayName} gedaan.',
        'message.catalogAuthRequestPermissionSubjectClassroom':
            '{studentDisplayName} heeft een aanvraag voor de klassikale opleiding {displayName} die start op {planningStart} gedaan.',
        'message.catalogAuthRequestPermissionBody': `Ga op het dashboard naar ''Autorisatie aanvragen'' om de aanvraag af te handelen.`,
        'message.catalogAuthRequestBodyLearningPlanAccepted': `Je aanvraag om e-learning ''{displayName}'' te volgen is geaccepteerd`,
        'message.catalogAuthRequestBodyLearningPlanAcceptedRemark': `Je aanvraag om e-learning ''{displayName}'' te volgen is geaccepteerd. Je manager heeft de volgende opmerking toevoegd: {managerRemark}`,
        'message.catalogAuthRequestBodyLearningPlanRejected': `Je aanvraag om e-learning ''{displayName}'' te volgen is geweigerd`,
        'message.catalogAuthRequestBodyLearningPlanRejectedRemark': `Je aanvraag om e-learning ''{displayName}'' te volgen is geweigerd. Je manager heeft de volgende opmerking toevoegd: {managerRemark}`,
        'message.catalogAuthRequestBodyLearningPlanDeleted': `Je aanvraag om e-learning ''{displayName}'' te volgen is verwijderd`,
        'message.catalogAuthRequestBodyLearningPlanDeletedRemark': `Je aanvraag om e-learning ''{displayName}'' te volgen is verwijderd. Je manager heeft de volgende opmerking toevoegd: {managerRemark}`,
        'message.catalogAuthRequestBodyLearningPlanUnknown': `Je aanvraag om e-learning ''{displayName}'' te volgen is status onbekend`,
        'message.catalogAuthRequestBodyLearningPlanUnknownRemark': `Je aanvraag om e-learning ''{displayName}'' te volgen is status onbekend. Je manager heeft de volgende opmerking toevoegd: {managerRemark}`,
        'message.catalogAuthRequestPermissionRevoked': `De aanvrager heeft de autorisatie voor ''{displayName}'' ingetrokken.`,
        'message.catalogAuthRequestBodyClassroomAccepted': `Je aanvraag om klassikale training ''{displayName}'' die start op {planningStart} te volgen is geaccepteerd`,
        'message.catalogAuthRequestBodyClassroomAcceptedRemark': `Je aanvraag om klassikale training ''{displayName}'' die start op {planningStart} te volgen is geaccepteerd. Je manager heeft de volgende opmerking toevoegd: {managerRemark}`,
        'message.catalogAuthRequestBodyClassroomRejected': `Je aanvraag om klassikale training ''{displayName}'' die start op {planningStart} te volgen is geweigerd`,
        'message.catalogAuthRequestBodyClassroomRejectedRemark': `Je aanvraag om klassikale training ''{displayName}'' die start op {planningStart} te volgen is geweigerd. Je manager heeft de volgende opmerking toevoegd: {managerRemark}`,
        'message.catalogAuthRequestBodyClassroomDeleted': `Je aanvraag om klassikale training ''{displayName}'' die start op {planningStart} te volgen is verwijderd`,
        'message.catalogAuthRequestBodyClassroomDeletedRemark': `Je aanvraag om klassikale training ''{displayName}'' die start op {planningStart} te volgen is verwijderd. Je manager heeft de volgende opmerking toevoegd: {managerRemark}`,
        'message.catalogAuthRequestBodyClassroomUnknown': `Je aanvraag om klassikale training ''{displayName}'' die start op {planningStart} te volgen is status onbekend`,
        'message.catalogAuthRequestBodyClassroomUnknownRemark': `Je aanvraag om klassikale training ''{displayName}'' die start op {planningStart} te volgen is status onbekend. Je manager heeft de volgende opmerking toevoegd: {managerRemark}`,
        'message.catalogAuthRequestPermissionAccepted': `Aanvraag voor ''{displayName}'' is geaccepteerd.`,
        'message.catalogAuthRequestPermissionRejected': `Aanvraag voor ''{displayName}'' is geweigerd.`,
        'message.catalogAuthRequestPermissionDeleted': `Aanvraag voor ''{displayName}'' is verwijderd.`,
        'message.catalogAuthRequestPermissionUnknown': `Aanvraag voor ''{displayName}'' is onbekend.`,
        'message.catalogAuthRequestBodyRevokedByUser': `Gebruiker ''{studentDisplayName}'' heeft de autorisatieaanvraag voor ''{displayName}'' ingetrokken.`,
        messageBodyIsRequired: 'Bericht is verplicht',
        messageSent: 'Bericht verzonden',
        'message.new': 'Bericht aan gebruiker',
        'message.newClass': 'Bericht aan cursusgroep',
        'message.newDepartment': 'Bericht aan afdeling',
        'message.filterByMessage': 'Filteren op bericht',
        'message.searchSubject': 'Zoek op onderwerp',
        'message.filterByReceiver': 'Filteren op ontvanger',
        'message.filterBySender': 'Filteren op afzender',
        'message.originalMessageInfo': 'Op {date} heeft {sender} het volgende geschreven:',
        'message.Received': 'Ontvangen',
        'message.Sent': 'Verzonden',
        'message.Settings': 'Instellingen',
        'message.settings.sendEmailForInternalMessage': `{key, select,
            title {Berichtenbox doorsturen naar e-mail}
            subtitle {Nieuwe berichten in de berichtenbox ook naar het e-mailadres versturen}
            label {Doorsturen}
            other {{key}}
        }`,
        'message.settings.sendSkillExpirationsMail': `{key, select,
            title {Activiteiten e-mail}
            subtitle {Periodieke e-mailnotificatie over bekwaamheden, leerpaden en catalogusitems versturen}
            label {Doorsturen}
            other {{key}}
        }`,
        'message.settings.sendSummaryEmailTimeInterval': `{key, select,
            title {E-mailnotificaties aantal ongelezen berichten}
            subtitle {Notificaties over het aantal ongelezen berichten per e-mail versturen}
            label {Frequentie}
            other {{key}}
        }`,
        'message.settings.sendUnprocessedAttendanceTimeInterval': `{key, select,
            title {E-mailnotificatie aantal onverwerkte presentielijsten (trainers)}
            subtitle {Notificaties over het aantal onverwerkte presentielijsten per e-mail versturen}
            label {Frequentie}
            other {{key}}
        }`,
        'message.settings.organisationDefault': 'Organisatie standaard',
        'message.settings.OnOffOptions': `{ option, select,
            on {Aan}
            off {Uit}
            other {{option}}
        }`,
        'message.settings.IntervalOptions': `{ option, select,
            none {Nooit}
            daily {Dagelijks}
            weekly {Wekelijks}
            biWeekly {Tweewekelijks}
            monthly {Maandelijks}
            other {{option}}
        }`,
        'message.settings.admin.title': 'Berichtenbox instellingen',
        'message.settings.admin.description':
            'Stel hieronder de standaard berichtenbox instellingen in voor alle medewerkers. De ingestelde standaard wordt voor iedereen gehanteerd, behalve voor medewerkers die hun persoonlijke instellingen hebben aangepast in hun eigen berichtenbox.',
        'message.settings.title': 'Mijn berichtenbox instellingen',
        'message.settings.emailNotification.senderName': 'E-mail afzendernaam',
        'message.settings.emailNotification.senderName.description':
            'Stel een naam in die wordt weergegeven als afzender van alle e-mails (Standaard is "SDB Leerplatform")',
        'message.settings.emailNotification.name': 'Afzendernaam',
        'message.skills.expirationNotification.subject': `Bekwaamheden update`,
        'message.skills.expirationNotification.body': `Beste deelnemer,\n
            { expired, select,
                0 {}
                other {Op dit moment {expired, select, 1 {is er 1 bekwaamheid} other {zijn er {expired} bekwaamheden}} verlopen.}
            }
            { expiring, select,
                0 {}
                other {In de periode tot {until} {expiring, select, 1 {gaat er nog 1 bekwaamheid} other {gaan er nog {expiring} bekwaamheden}} verlopen.}
            }
            { new, select,
                0 {}
                other {Sinds de laatste update {new, select, 1 {is er 1 bekwaamheid} other {zijn er {new} bekwaamheden}} aan jou toegewezen.}
            }

            Je kunt jouw bekwaamheden bekijken in je portfolio.
        `,
        mayBeRedoneAgain: 'Mag opnieuw',
        media: 'Media',
        min0max100: 'Min. 0 en Max. 100',
        minAmount: 'Minimum aantal',
        minCapacity: 'Minimum aantal deelnemers',
        minCapacityMustBeLowerThanMaxCapacity:
            'Minimum aantal is verplicht en moet lager zijn dan maximum aantal',
        minMaxCapacity: 'Minimum/maximum capaciteit',
        minuteAbout: '{number} minuut',
        minuteAgo: '{number} minuut geleden',
        minutes: 'Minuten',
        minutesAbout: '{number} minuten',
        minutesAgo: '{number} minuten geleden',
        mobilePhone: 'Mobiele telefoon',
        modifyEnrollment: 'Wijzig inschrijving',
        'modules.accessmanagement.activatedRights': 'Geactiveerde rechten',
        'modules.accessmanagement.applicationPart': 'Applicatie onderdeel',
        'modules.accessManagement.descriptions': `{key, select,
            roles_and_rights {Rollen en rechten}
            roles_and_rights_manage_roles {Beheer rollen}
            roles_and_rights_manage_assignments {Beheer toewijzingen}
            classroom {Classroom}
            classroom_manage_courses {Beheer opleidingen}
            classroom_manage_schedules {Beheer planningen}
            classroom_manage_enrollments {Beheer inschrijvingen}
            classroom_manage_presence {Beheer presentie}
            classroom_manage_evaluations {Beheer evaluaties}
            classroom_manage_plannings {Beheer planningen}
            classroom_manage_reservations {Beheer reserveringen}
            other {{key}}
        }`,
        'modules.accessmanagement.errors': `{error, select,
            duplicate_name {Er is al een rol met deze naam}
            no_name_provided {Er is geen rolnaam opgegeven}
            other {Er is een fout opgetreden}
        }`,
        'modules.accessManagement.rights_count_': `Rechten: {count}`,
        'modules.accessManagement.roleName': 'Rolnaam',
        'modules.admin.classroom.presence.NumberOfResults': 'Totaal aantal resultaten:',
        'modules.adminMenu.labels': `{label, select,
            settings {Instellingen}
            catalog {Catalogus}
            categories {Categorieën}
            compositionmanagement {E-learning beheer}
            scormmanagement {Scorm management}
            elearningmanagement {E-learningbeheer}
            evaluations {Evaluaties}
            definities {Dossieritems}
            classroom {Klassikaal}
            skills {Bekwaamheden}
            certificates {Certificaten}
            usermanagement {Gebruikersbeheer}
            examinermanagement {Toetserbeheer}
            importmanagement {Importbeheer}
            exportmanagement {Exportbeheer}
            maillogoverview {E-mail logging}
            other {{label}}
        }`,
        'modules.catalog.assign.description': 'Selecteer hoe u het catalogusitem wilt toewijzen',
        'modules.catalog.assign.allDepartmentAndFunctionsAssignments':
            'Alle afdelingen & functies toewijzingen',
        'modules.catalog.assign.departmentAssignments': 'Afdeling toewijzingen',
        'modules.catalog.assign.departmentRoleAssignments':
            'Afdeling / functie combinatie toewijzingen',
        'modules.catalog.assign.roleAssignments': 'Functie toewijzingen',
        'modules.catalog.assign.identityAssignments': 'Individuele toewijzingen',
        'modules.catalog.assign.domainAssignments': 'Domein toewijzingen',
        'modules.catalog.assignmentType.description': `{value, select,
            departmentrole {De catalogusitem wordt toegewezen aan alle medewerkers met specifiek geselecteerde functie(s) en geselecteerde afdeling(en).}
            department {De catalogusitem wordt toegewezen aan alle medewerkers op deze afdeling(en), ongeacht hun functie.}
            role {De catalogusitem wordt toegewezen aan alle medewerkers met deze functie(s), ongeacht op welke afdeling zij werken.}
            all {De catalogusitem wordt toegewezen aan iedereen die met een functie op een afdeling werkt.}
            user {De catalogusitem wordt toegewezen aan specifiek geselecteerde medewerkers.}
            domains {De catalogusitem wordt toegewezen aan alle medewerkers binnen de geselecteerde domein(en).}
            other {{value}}
        }`,
        'modules.catalog.assignmentType.value': `{value, select,
            departmentrole {Specifieke Afdeling / Functie combinatie}
            department {Afdeling (ongeacht functie)}
            role {Functie (ongeacht afdeling)}
            all {Alle afdelingen & functies}
            user {Individueel}
            domains {Domeinen}
            other {{value}}
        }`,
        'modules.catalog.authorizationStatus': `{status, select,
            pending {Aanvraag loopt}
            rejected {Aanvraag afgewezen}
            other {Toestemming aanvragen}
        }`,
        'modules.catalog.course.authorization.noManagersNotPossibleToAuthorize':
            'Er is geen manager gevonden om het autorisatieverzoek bij in te dienen.',
        'modules.catalog.course.ParticipantOverviewExportName': 'Deelnemeroverzicht',
        'modules.catalog.statusType': `{statusType, select,
            all {Alles}
            completed {Voldaan}
            notcompleted {Niet voldaan}
            started {Gestart / Ingeschreven}
            other {{statusType}}
        }`,
        'modules.catalog.areYouSureYouWantToResetAll':
            'Weet u zeker dat u alle gebruikers wilt resetten?',
        'modules.catalog.resetAll': 'Reset alle voortgang',
        'modules.catalog.resetAllMessage':
            'De voortgang van alle gebruikers van alle versies van dit leerplan zullen worden gereset.',
        'modules.catalog.resetAllSuccess': 'Alle voortgang is gereset',
        'modules.classroom.exportPresence': 'Download resultatenrapportage',
        'modules.classroom.participants.resultValue': `{value, select,
            passed {Voldaan}
            failed {Niet voldaan}
            other {Niet ingevuld}
        }`,
        'modules.classroom.presenceListFileNamePart': 'presentielijst',
        'modules.classroom.presenceValue': `{value, select,
            all {Alles}
            present {Aanwezig}
            absent {Afwezig}
            other {Niet ingevuld}
        }`,
        'modules.classroom.presenceAbsentValue.none': 'Geen',
        'modules.classroom.presenceAbsentValue.Absent': 'Afwezig',
        'modules.classroom.presenceAbsentValue.AbsentWithExcuse': 'Afwezig met excuus',
        'modules.classroom.presenceAbsentValue.AbsentWithoutExcuse': 'Afwezig zonder excuus',
        'modules.classroom.queueEnabledAndAuthorizationRequiredWarning': `De opties 'Autorisatie vereist door manager' en 'Wachtrij' kunnen niet gelijktijdig aan staan.`,
        'modules.classroom.queueEnabledAndPlanningIntegrationWarning': `De opties 'Opleidingsuren verwerken in SDB Planning' en 'Wachtrij' kunnen niet gelijktijdig aan staan.`,
        'modules.classroom.registrations': `Ingeschreven {enrollmentCount} — Max. {maxCapacity}`,
        'modules.classroom.resultReportFileNamePart': 'resultaatrapportage',
        'modules.classroom.upcomingplanninglist.details': `details`,
        'modules.classroom.upcomingplanninglist.unsubscribe': `uitschrijven`,
        'modules.classroomNotifications.enrollment.value': `{value, select,
            both {Inschrijfbevestiging en agendaverzoeken}
            confirmation {Alleen inschrijfbevestiging}
            none {Geen}
            other {{value}}
        }`,
        'modules.classroomNotifications.sendConfirmation': 'Verstuur inschrijfbevestiging:',
        'modules.classroomNotifications.teachersReceiveUnenrollNotifications':
            'Notificaties voor docenten bij uitschrijvingen van hun klassikale opleidingen',
        'modules.classroomNotifications.unenrollNotificationsList':
            'Onderstaande gebruikers ontvangen notificaties bij iedere uitschrijving van een klassikale opleiding',
        'modules.classroomNotifications.teacherNotifications': 'Notificaties voor docenten',
        'modules.department.assignmentType.value': `{value, select,
            department {Afdeling (ongeacht functie)}
            role {Specifieke functie binnen de afdeling}
            individual {Individueel}
            other {{value}}
        }`,
        'modules.department.level': 'Niveau',
        'modules.department.currentProgress': 'Huidige selectie met voortgang',
        'modules.department.departmentName': 'Afdelingsnaam',
        'modules.department.numberOfEmployees': 'Aantal medewerkers',
        'modules.department.downLoadDepartmentsListReport': 'Afdelingsrapport downloaden',
        'modules.department.totalExport': 'Totaalexport afdelingen zonder voortgang',
        'modules.elearningmanagement.tabs': `{tab, select,
            lti {LTI 1.1}
            ltiadvantage {LTI 1.3}
            drafts {Arrangementen}
            os {Microlearnings}
            scorm {SCORM}
            youtube {YouTube}
            vimeo {Vimeo}
            other {{tab}}
        }`,
        'modules.maillog.EmailLogging': 'E-mail logging',
        'modules.maillog.EmailReceiver': 'E-mail ontvanger',
        'modules.maillog.events': `{event, select,
            Deferred {uitgesteld}
            Bounce {aflevering mislukt}
            Delivered {afgeleverd}
            Dropped {niet verwerkt}
            Blocked {aflevering geblokkeerd}
            other {{event}}
        }`,
        'modules.maillog.selectEvent': 'Selecteer status',
        'modules.mailtemplates.deleteMailTemplate.title': 'Verwijder mailtemplate',
        'modules.mailtemplates.deleteMailTemplate.message': `Weet je zeker dat je de mailtemplate wilt verwijderen?
            Na verwijdering wordt de standaard mailtemplate weer gebruikt.`,
        'modules.mailtemplates.labels': `{label, select,
            cursist {[cursist]}
            opleiding {[opleiding]}
            planning {[planning]}
            start {[start]}
            eind {[eind]}
            locatie {[locatie]}
            docent {[docent]}
            roosteritems {[roosteritems]}
            roosteritems2 {{roosteritems}}
            other {{label}}
        }`,
        'modules.mailtemplates.labels.roosteritems.usage': 'Deze wordt als volgt gebruikt',
        'modules.mailtemplates.labels.roosteritems.content':
            'roosteritems "Sessie [sessieNaam] met omschrijving [sessieOmschrijving]: van [start] tot [eind] in [locatie] door [docent]."',
        'modules.mainMenu.labels': `{label, select,
            start {Start}
            catalog {Catalogus}
            departments {Afdelingen}
            skills {Bekwaamheden}
            hlapps {Werk- & leervormen}
            myMinerva {Portfolio}
            search {Zoeken}
            administration {Beheer}
            other {{label}}
        }`,
        'modules.messages.markReadAllButton': `markeer alles als gelezen`,
        'modules.packages.areYouSureYouWantToResetThisPackage':
            'Weet u zeker dat u dit pakket wilt resetten?',
        'modules.packages.deletePackageMessage': `{numberOfParticipants, select,
    1 {Er is op dit moment {numberOfParticipants} gebruiker die nog bezig is met een leerplan uit dit pakket.}
    other {Er zijn op dit moment {numberOfParticipants} gebruikers die nog bezig zijn met een leerplan uit dit pakket.}
} Als u deze versie verwijdert, worden deze leerplannen gereset.`,
        'modules.packages.sendMailToUsers': 'Verstuur een e-mail naar de gebruikers',
        'modules.packages.resetPackage': 'Reset pakket',
        'modules.packages.resetPackageMessage':
            'Er zijn op dit moment gebruikers gekoppeld aan deze versie van het pakket. Als u deze versie reset, is de voortgang bij deze koppelingen verloren.',
        'modules.reports.filename': `{ shortid, select,
                rJeCvDtQU {{department} - Overzicht opleidingen - {date}}
                JOMB63Bg {{department} - Overzicht opleidingen - {date}}
                BJvunt {{skillName} - Bekwaamhedenrapport - {date}}
                HypXvdb3Y {{skillName} - Bekwaamhedenrapport - {date}}
                BJ55OI8yB {Overzicht afdelingen - {date}}
                ryig1muL {Overzicht afdelingen - {date}}
                8ckLsHAlV {Overzicht afdelingen - {date}}
                ByXnzmK7U {{departmentName} - Overzicht bekwaamheden - {date}}
                rJETt6bQF {{departmentName} - Overzicht bekwaamheden - {date}}
                rk8WuxqkS {{departmentName} - Overzicht medewerkers - {date}}
                Sy2YFJEQD {{departmentName} - Overzicht medewerkers - {date}}
                SygyTwlht {Bekwaamhedenrapport - {date}}
                r1K1tdg3t {Bekwaamhedenrapport - {date}}
                rkhUeslMq {Bekwaamhedenrapport - Totaal inclusief afdeling & functie - {date}}
                3B6kKWccg {Bekwaamhedenrapport - Historie - {selectedUser} - {selectedDate}}
                e5tXcT9ns {Bekwaamhedenrapport - Historie - {selectedUser} - {selectedDate}}
                HMDwn6lX {Bekwaamhedenrapport - Historie - {selectedDate}}
                XiWMm2YEx {Bekwaamhedenrapport - Historie - {selectedDate}}
                Af1MbWQs3 {Bekwaamhedenrapport - Historie - {skillName} - {selectedDate}}
                LFTryvYyB {Bekwaamhedenrapport - Historie - {skillName} - {selectedDate}}
                RTzrTESs {Bekwaamheidspaspoort - {nameUser} - {date}}
                Ax1lS9bO9 {Bekwaamheidspaspoort - {nameUser} - {date}}
                Bk56ndo2I {Toegewezen opleidingen - {nameUser} - {date}}
                SkEMJXxpE {Resultaten - {nameUser} - {date}}
                BJHAIQOB {Deelnemers - {catalogItemName} - {date}}
                SyNfMGOmd {Deelnemers - {catalogItemName} - {date}}
                Sk6F3QoI {Resultaatrapportage - {catalogItemName} - {date}}
                HkRoZWO {Resultaatrapportage - {catalogItemName} - {date}}
                ByHs3jRnS {Presentielijst - {catalogItemName} - {sessionDate}}
                vhkxJeLKH {Weekoverzicht klassikale opleidingen - {period}}
                hUw7gJKlO {Weekoverzicht klassikale opleidingen - {period}}
                knXgMInu {{nameUser} - {skillName} - {date}}
                NM9SkSjW {Klassikale presentie - {date}}
                O8rHIenBK {Historierapport - {customer}}
                NJq4r8R3J {{department} - Inschrijvingen - {date}}
                GwjVxmq_q {{department} - Presentie - {date}}
                other {{shortid}}
        }`,
        'modules.skills.achievedOn': 'Afgerond op {date}',
        'modules.skills.activity.status': `{status, select,
            exemption {vrijstelling}
            red {verlopen / nog te doen}
            yellow {gaat verlopen}
            green {behaald}
            other {{status}}
        }`,
        'modules.skills.activityGroup.subtitle': `{groupType, select,
            compulsory {Alles verplicht}
            optional {Verplicht met keuze}
            recommended {Geadviseerd}
            other {{groupType}}
        } - {activities} {activities, select,
            1 {activiteit}
            other {activiteiten}
        } {groupType, select,
            optional {waarvan {required} verplicht}
            other {}
        } {notApplicable, select,
            0 {}
            other {({notApplicable} uitgeschakeld)}
        }`,
        'modules.skills.activityGroupType': `{type, select,
            standard {Standaard}
            basicWithRefresher {Basis/Vervolg}
            other {{type}}
        }`,
        'modules.skills.activityLockedDialog.title': 'Nog niet toegankelijk',
        'modules.skills.activityLockedDialog.message': 'Rond eerst de voorgaande activiteiten af.',
        'modules.skills.activityType': `{type, select,
            document {Documenten (document, protocol, handleiding)}
            documenttype {Document}
            protocol {Protocol}
            manual {Handleiding}
            catalog {Catalogus (leerpad, e-learning, klassikaal)}
            learningpath {Leerpad}
            elearning {E-learning}
            classroom {Klassikale opleiding}
            assessment {Beoordeling (praktijk, schriftelijk, zelfbeoordeling)}
            classical {Klassikale training}
            skillslabtraining {Skillslab beoordeling}
            trainingonthejob {Training on the job}
            writtentest {Schriftelijke beoordeling}
            skillslabtest {Skillslab beoordeling}
            practical {Praktijk beoordeling}
            peerassessment {Peer assessment}
            selfassessment {Zelfbeoordeling}
            expertiseActivity {Dossieritem}
            groupActivity {Subblok}
            other {{type}}
        }`,
        'modules.skills.activityCurrentStatus': `{ status, select,
            elearning_created { Gestart }
            classical_registered { Ingeschreven }
            classical_unregistered { Uitgeschreven }
            other {}
        }`,
        'modules.skills.activityExpirationStatus': `{ status, select,
            achieved {Behaald}
            expires {Verloopt op {date}}
            never_expires {Verloopt niet}
            exemption {Vrijstelling tot {date}}
            effective_from {Uiterlijk afronden voor {date}}
            expired {Verlopen op {date}}
            other {}
        }`,
        'modules.skills.activityValidity.title': 'Geldigheidsduur',
        'modules.skills.activityValidity.value': `{value, select,
            default {Standaard}
            custom {Aangepast}
            oneoff {Eenmalig}
            other {{value}}
        }`,
        'modules.skills.activityValidity.months': `{ months, select,
            1 {Maand}
            other {Maanden}
        }`,
        'modules.skills.activityValidity.validityPeriodWarning':
            'Let op: bij een geldigheidsduur van 3 maanden of korter blijft de bekwaamheid oranje.',
        'modules.skills.assignToUser': 'Bekwaamheden toewijzen aan {name}',
        'modules.skills.assignmentDialog.title': 'Selecteer afdelingen en functies',
        'modules.skills.assignmentDialog.noSelectionInfo':
            'Selecteer ten minste één afdeling en functie',
        'modules.skills.assignmentDialog.departments': `Afdelingen`,
        'modules.skills.assignmentDialog.roles': `Functies`,
        'modules.skills.assignmentDialog.selected': `geselecteerd`,
        'modules.skills.assignmentName.header': 'Toewijzing',
        'modules.skills.bulkValidity.title': 'Geldigheid aanpassen',
        'modules.skills.bulkValidity.description':
            'Geldt voor de {count} geselecteerde toewijzingen.',
        'modules.skills.assignmentType.header': 'Soort toewijzing',
        'modules.skills.assignmentType': `{ type, select,
            individual {Individueel}
            department {Afdeling}
            role {Functie}
            departmentrole {Afdeling | Functie}
            all {Alle}
            everyone {Iedereen in organisatie}
            other {}
        }`,
        'modules.skills.assignmentType.value': `{value, select,
            departmentrole {Specifieke Afdeling / Functie combinatie}
            department {Afdeling (ongeacht functie)}
            role {Functie (ongeacht afdeling)}
            all {Alle afdelingen & functies}
            individual {Individueel}
            everyone {Iedereen in organisatie}
            other {{value}}
        }`,
        'modules.skills.assignmentType.toggleLabel': `{value, select,
            learningplan {Alle e-learnings}
            classroom {Alle klassikale opleidingen}
            learningpath {Alle leerpaden}
            all {Alle catalogusitems}
            other {{value}}
        }`,
        'modules.skills.assignmentType.description': `{value, select,
            departmentrole {De bekwaamheid wordt toegewezen aan alle medewerkers met specifiek geselecteerde functie(s) en geselecteerde afdeling(en).}
            department {De bekwaamheid wordt toegewezen aan alle medewerkers op deze afdeling(en), ongeacht hun functie.}
            role {De bekwaamheid wordt toegewezen aan alle medewerkers met deze functie(s), ongeacht op welke afdeling zij werken.}
            all {De bekwaamheid wordt toegewezen aan iedereen die met een functie op een afdeling werkt.}
            individual {De bekwaamheid wordt toegewezen aan de geselecteerde medewerkers, los van hun afdeling of functie.}
            other {{value}}
        }`,
        'modules.skills.assignments.headline': `Aantal toegewezen: {assigned}, waarvan {notApplicable} niet van toepassing`,
        'modules.skills.assignSkill': 'Bekwaamheid toewijzen',
        'modules.skills.basicWithRefresher': 'Basis - Vervolg',
        'modules.skills.basicWithRefresher.basicValidity': 'Vervolg van toepassing na...',
        'modules.skills.basicWithRefresherHelpMonths':
            'Bepaal na hoeveel maanden het vervolg van toepassing is na het initieel behalen van de basis.',
        'modules.skills.basicWithRefresher.basicOneOff': 'Basis eenmalig',
        'modules.skills.basicWithRefresher.basicOneOffHelp':
            'Schakel in om in te stellen dat de basis slechts eenmalig gedaan moet worden.',
        'modules.skills.basicWithRefresherHelpGracePeriod':
            'Bepaal hoeveel extra maanden een medewerker krijgt om het vervolg af te ronden voordat de basis opnieuw van toepassing is.',

        'modules.skills.basicWithRefresher.summaryTitle': 'Samenvatting',
        'modules.skills.basicWithRefresher.summary': `Na het initieel behalen van de basis wordt het vervolg na {basicValidity}
        { basicValidity, select,
            1 {maand}
            other {maanden}
        } leidend.
        { gracePeriod, select,
            null {De basis hoeft slechts eenmalig behaald te worden en komt dus niet te vervallen, ongeacht of het vervolg tijdig wordt behaald.}
            0 {Indien het vervolg niet tijdig wordt behaald, wordt de basis opnieuw van toepassing na {basicValidity}
            { basicValidity, select,
                1 {maand}
                other {maanden}
            }. De medewerker heeft geen uitstelperiode.}
            other {Indien het vervolg niet tijdig wordt behaald, wordt de basis opnieuw van toepassing voor de bekwaamheidsberekening. De medewerker heeft hiervoor na {basicValidity}
            { basicValidity, select,
                1 {maand}
                other {maanden}
            } nog {gracePeriod} extra
            { gracePeriod, select,
                1 {maand}
                other {maanden}
            } de tijd.}
        }`,

        'modules.skills.editor.assign': 'Toewijzen',
        'modules.skills.editor.assign.description':
            'Selecteer hoe je de bekwaamheid wilt toewijzen',
        'modules.skills.editor.general': 'Algemeen',
        'modules.skills.editor.content': 'Inhoud bekwaamheid',
        'modules.skills.editor.validity': 'Standaard geldigheidsduur',
        'modules.skills.editor.validity.description':
            'Standaard geldigheidsduur voor alle activiteiten (per activiteit kan een aangepaste geldigheidsduur worden ingesteld).',
        'modules.skills.editor.months': 'Maanden',
        'modules.skills.editor.moveActivities': 'Activiteiten verplaatsen',
        'modules.skills.editor.moveActivities.description':
            'Verplaats activiteiten naar een ander blok met behoud van resultaten',
        'modules.skills.editor.moveFrom': 'Verplaatsen van',
        'modules.skills.editor.moveTo': 'Verplaatsen naar',
        'modules.skills.editor.assignRights': 'Rechten',
        'modules.skills.editor.allCatalogItems': 'Alle catalogus items',
        'modules.skills.editor.selectCatalogItems': 'Selecteer catalogus items',
        'modules.skills.editor.allDepartments': 'Alle afdelingen',
        'modules.skills.editor.allRoles': 'Alle functies',
        'modules.skills.editor.allowedToCustomizeBlocks': 'Blokken en/of activiteiten aanpassen',
        'modules.skills.editor.allowedToCustomizeBlocksInfo':
            'Bij het toewijzen van de bekwaamheid kunnen onderdelen in-/uitgeschakeld worden.',
        'modules.skills.editor.allowedToExtendTheValidity': 'Geldigheidsduur ook verlengen',
        'modules.skills.editor.allowedToExtendTheValidityInfo':
            'Bij het toewijzen van de bekwaamheid kan de standaard geldigheidsduur altijd worden ingekort. Door het inschakelen van deze instelling kan deze ook worden verlengd.',
        'modules.skills.editor.allowOwnerToModifyExemption': 'Zelf vrijstellen',
        'modules.skills.editor.allowOwnerToModifyExemptionDiscontinuedInfo': `De optie 'Zelf vrijstellen' is vervallen. Gebruik voortaan de activiteit 'Zelfbeoordeling'. Let op: als je deze optie uitschakelt, kan deze daarna niet meer ingeschakeld worden voor deze bekwaamheid.`,
        'modules.skills.editor.activitiesAre': 'Activiteiten zijn',
        'modules.skills.editor.persistOrder': 'Volgorde aanhouden',
        'modules.skills.editor.removeBlock': 'Blok verwijderen',
        'modules.skills.editor.removeBlockCheck':
            'Weet je zeker dat je dit blok met alle onderliggende activiteiten wilt verwijderen?',
        'modules.skills.editor.removeGroup': 'Subblok verwijderen',
        'modules.skills.editor.removeGroupCheck':
            'Weet je zeker dat je dit subblok met alle onderliggende activiteiten wilt verwijderen?',
        'modules.skills.editor.selectActivities': 'Selecteer activiteiten',
        'modules.skills.editor.selectDepartments': 'Selecteer afdeling(en)',
        'modules.skills.editor.selectAllCurrentDepartments': 'Selecteer alle huidige afdelingen',
        'modules.skills.editor.allCurrentDepartmentsWarningMessage':
            'Let op! Met deze selectie worden nieuwe afdelingen in de toekomst niet automatisch meegenomen. Wil je dat wel? Wijs dan toe aan "Functie (ongeacht afdeling)".',
        'modules.skills.editor.selectDepartmentsWarning':
            'Let op! Bij het selecteren van meer dan 1 afdeling tegelijk kunnen er toewijzingen worden aangemaakt voor afdeling/functie-combinaties die (nog) niet bestaan.',
        'modules.skills.editor.selectIndividuals': 'Selecteer individu(en)',
        'modules.skills.editor.selectRoles': 'Selecteer functie(s)',
        'modules.skills.editor.warningRecommended':
            'Geen enkele activiteit in dit blok telt mee voor de berekening van het eindresultaat',
        'modules.skills.editor.noBlockYet': 'Nog geen blok toegevoegd, voeg eerst een blok toe.',
        'modules.skills.editor.noActivityYet':
            'Nog geen activiteit toegevoegd, voeg eerst een activiteit toe.',
        'modules.skills.editor.addActivity': 'Activiteit toevoegen',
        'modules.skills.editor.removeActivity': 'Activiteit verwijderen',
        'modules.skills.editor.assessmentForm': 'Beoordelingsformulier',
        'modules.skills.editor.examinerFunctionality': 'Toetsfunctionaliteit',
        'modules.skills.editor.combineExams': 'Toetsmomenten combineren',
        'modules.skills.editor.examDuration': 'Duur van toetsmoment (minuten)',
        'modules.skills.editor.advancedSettings': 'Geavanceerde instellingen',
        'modules.skills.editor.advancedValidityInfo':
            'Hoe lang telt het resultaat van deze activiteit mee binnen deze bekwaamheid nadat de medewerker de activiteit heeft afgerond?',
        'modules.skills.editor.mandatory': 'Verplichting',
        'modules.skills.editor.mandatoryInfo':
            'Vanaf wanneer moet een medewerker deze activiteit afronden?',
        'modules.skills.editor.mandatoryOption': `{option, select,
            now {Direct}
            date {Vanaf een vaste datum}
            expiry {Zodra de bekwaamheid van de medewerker verloopt}
            other {{option}}
        }`,
        'modules.skills.editor.mandatoryOptionInfo': `{option, select,
            now {Voor alle medewerkers zodra de bekwaamheid is opgeslagen.}
            date {Specifieke datum voor alle medewerkers, bijvoorbeeld bij nieuw beleid dat per kwartaal ingaat.}
            expiry {Wie nu bekwaam is, hoeft deze activiteit pas af te ronden na de eigen verloopdatum. Het moment verschilt dus per medewerker.}
            other {}
        }`,
        'modules.skills.editor.mandatoryResultTitle': 'Wat medewerkers ervaren',
        'modules.skills.editor.mandatoryResult.now':
            'Alle medewerkers met deze bekwaamheid moeten de activiteit direct afronden.',
        'modules.skills.editor.mandatoryResult.date':
            'Alle medewerkers met deze bekwaamheid moeten deze activiteit vóór {date} afronden. Doen zij dat niet, dan verloopt hun bekwaamheid per {date}.',
        'modules.skills.editor.mandatoryResult.noDate':
            'Kies een datum. Zonder datum is de activiteit direct verplicht.',
        'modules.skills.editor.mandatoryResult.expiryApproved':
            'Bekwame medewerkers: verplicht vanaf de verloopdatum die zij hebben op het moment dat deze bekwaamheid wordt opgeslagen. Verlengen zij daarna, dan schuift die datum niet mee.',
        'modules.skills.editor.mandatoryResult.expiryNotApproved':
            'Niet-bekwame medewerkers: direct verplicht.',
        'modules.skills.editor.mandatoryResult.expiryNeverExpires':
            'Medewerkers met een bekwaamheid die nooit verloopt, krijgen de activiteit niet.',
        'modules.skills.editor.examinerFunctionalityInfo':
            'Medewerkers schrijven zich in voor een toetsmoment bij een beoordelaar.',
        'modules.skills.editor.useExaminerFunctionality':
            'Toetsfunctionaliteit gebruiken voor deze activiteit',
        'modules.skills.editor.advancedChip': `{chip, select,
            validityDefault {Standaard geldigheid}
            validityOneoff {Eenmalig geldig}
            mandatoryNow {Direct verplicht}
            mandatoryExpiry {Verplicht zodra bekwaamheid verloopt}
            mandatoryDateMissing {Verplicht vanaf: datum ontbreekt}
            examinerOn {Toetsfunctionaliteit aan}
            examinerOff {Geen toetsfunctionaliteit}
            other {{chip}}
        }`,
        'modules.skills.editor.advancedChipValidity': `Geldig {months, plural,
            =1 {# maand}
            other {# maanden}
        }`,
        'modules.skills.editor.advancedChipMandatoryFrom': 'Verplicht vanaf {date}',
        'modules.skills.editor.advancedChipExamDuration': 'Toetsmoment {minutes} min',
        'modules.skills.editor.catalogitem': 'Catalogusitem',
        'modules.skills.editor.expertiseitem': 'Dossieritem',
        'modules.skills.editor.numberOfAssessors': `{assessors, select,
            1 {1 beoordelaar}
            other {{assessors} beoordelaars}
        }`,
        'modules.skills.editor.gracePeriod': 'Uitstelperiode',
        'modules.skills.editor.alsoShowRolesOutsideTheSelectedDepartments':
            'Toon ook functies buiten geselecteerde afdelingen',
        'modules.skills.errors.errorOnSavingChanges':
            'Er is iets mis gegaan bij het opslaan van de wijzigingen',
        'modules.skills.errors.errorOnSavingSomeOfItems':
            'Er is iets misgegaan bij het opslaan van enkele wijzigingen',
        'modules.skills.expirationInfo': `{date, select,
            null {{approved, select,
                true {Verloopt niet}
                false {Nog niet afgerond}
                other {{approved}}
            }}
            other {{date}}
        }`,
        'modules.skills.groupType': `{groupType, select,
            compulsory {Alles verplicht}
            optional {Verplicht met keuze}
            recommended {Geadviseerd}
            other {{value}}
        }`,
        'modules.skills.warningRecommendedUser':
            'Geadviseerd, deze activiteiten tellen niet mee voor het eindresultaat',
        'modules.skills.historyReportDisclaimer':
            'In dit overzicht staan alle in het verleden aangetoonde bekwaamheden, ongeacht of deze op dit moment nog zijn toegewezen.',
        'modules.skills.managerSettings.allowManageAssignments.headline': 'Bekwaamheden toewijzen',
        'modules.skills.managerSettings.allowManageAssignments.description':
            'Managers mogen bekwaamheden toewijzen',
        'modules.skills.managerSettings.assessmentByManagers.headline': 'Activiteiten beoordelen',
        'modules.skills.managerSettings.assessmentByManagers.description':
            'Selecteer op welk niveau managers mogen beoordelen',
        'modules.skills.managerSettings.assessmentByManagers.options': 'Opties',
        'modules.skills.managerSettings.assessmentByManagers.all': 'Alle medewerkers',
        'modules.skills.managerSettings.assessmentByManagers.whereManager':
            'Alleen medewerkers van eigen afdeling',
        'modules.skills.messages.assignedToAllAvailableFunctions':
            'De bekwaamheid is toegewezen aan alle beschikbare functies',
        'modules.skills.messages.errorCategoryNotEmpty':
            'De categorie bevat nog één of meerdere bekwaamheden',
        'modules.skills.modifySearchFilter':
            'Geen beoordelaars gevonden die aan je zoekfilter voldoen...',
        'modules.skills.noLearningPathAssignmentsFound':
            '({userName}) is nog niet gestart met ({learningPathName}).',
        'modules.skills.noSkillAssignmentsFound': '{userName} is niet toegewezen aan {skillName}',
        'modules.skills.noExpirationDate': 'Geen verloopdatum',
        'modules.skills.noLongerAssigned': 'niet meer toegewezen',
        'modules.skills.noResults.noAssignments.title': 'Nog niet toegewezen',
        'modules.skills.noResults.noAssignments.text': 'De bekwaamheid is nog niet toegewezen',
        'modules.skills.notApplicableReason': 'Reden niet van toepassing',
        'modules.skills.resultDeletedOn': 'Resultaat verwijderd op {date}',
        'modules.skills.resultValidUntil': 'Resultaat geldig tot {date}',
        'modules.skills.requestAssessment': 'Beoordeling aanvragen',
        'modules.skills.requestAssessmentFor': 'Beoordeling aanvragen voor',
        'modules.skills.revokedBy': `{ revokedBy, select,
            null {Verwijderd}
            other {Verwijderd door {revokedBy}}
        }`,
        'modules.skills.optionalBlockName': 'Naam blok',
        'modules.skills.subBlock': 'Subblok',
        'modules.skills.subBlockName': 'Naam subblok',
        'modules.skills.overallProgress.status': `{status, select,
            notApproved {Niet bekwaam / verlopen}
            expiring {Verloopt binnenkort}
            approved {Bekwaam / vrijstelling}
            notApplicable {Niet van toepassing}
            other {{status}}
        }`,
        'modules.skills.overallProgress.title': 'Algehele voortgang',
        'modules.skills.persistActivityOrder': 'Activiteitvolgorde aanhouden',
        'modules.skills.persistActivityGroupOrder': 'Blokvolgorde aanhouden',
        'modules.skills.persistActivityGroupOrderInfo':
            'Gebruiker kan blokken alleen in volgorde openen',
        'modules.skills.selectReviewer': `{ current, select,
            null {Selecteer een beoordelaar bij wie je de beoordeling wilt aanvragen. }
            other {{current} is ingesteld als beoordelaar. Kies een andere andere beoordelaar of trek de aanvraag in.}
        }`,
        'modules.skills.skillCard.assignmentInfo': `{assignment, select,
            individual {Individueel}
            other {{assignment}}
        }`,
        'modules.skills.settings.skillsMatrixToggleLabel': 'Matrixweergave',
        'modules.skills.status': `{status, select,
            grey {Niet van toepassing}
            red {Niet bekwaam / verlopen}
            orange {Verloopt binnenkort}
            green {Bekwaam / vrijstelling}
            other {{Status}}
        }`,
        'modules.trainings.status': `{status, select,
            grey {Niets gedaan / niet toegewezen}
            red {Niet voldaan / verlopen (verplicht)}
            blue {Ingeschreven / gestart}
            orange {Verloopt}
            green {Voldaan}
            purple {Niet voldaan / verlopen (aanbevolen)}
            brown {Uitzondering}
            other {{Status}}
        }`,
        'modules.uservoice.emailWarning': 'E-mailadres ontbreekt',
        'modules.uservoice.noValidEmail':
            'Jouw profiel bevat helaas geen (geldig) e-mailadres. Voer hieronder eenmalig jouw e-mailadres in en sla deze op.',

        'modules.planningIntegration.always':
            'Aan | bij overlappende dienst blokkeren (geen inschrijving mogelijk)',
        'modules.planningIntegration.alwaysAllowOverlap':
            'Aan | bij overlappende dienst wegschrijven als registratie-uren (naast dienst)',
        'modules.planningIntegration.cancelAndTransfer': 'Annuleren en verplaatsen is onmogelijk',
        'modules.planningIntegration.forCancelPlanning': 'Voor planning annuleren',
        'modules.planningIntegration.forTransfer': 'Voor verplaatsen',
        'modules.planningIntegration.functionalityCantBeUsedInCombination': `"Deze functionaliteit kan momenteel niet gebruikt worden in
                    combinatie met SDB Planning integratie"`,
        'modules.planningIntegration.planningCantBeCanced': `"Deze planning kan
                    niet geannuleerd worden. Eerst moeten alle gebruikers uitgeschreven worden"`,
        'modules.planningIntegration.toggleText': 'Opleidingsuren verwerken in SDB Planning',
        'modules.planningIntegration.text':
            'Bepaalt of de uren van een bijeenkomst in de dienst van de medewerker terechtkomen.',
        'modules.planningIntegration.never':
            'Uit | uren alleen in SDB Leerplatform (niet wegschrijven naar Planning)',
        'modules.planningIntegration.nominalDuty.toggleText':
            'Studiebelasting verwerken in SDB Planning',
        'modules.planningIntegration.nominalDuty.text':
            'Schrijft de studiebelasting van {minutes} minuten als nominale uren naar SDB Planning.',
        'modules.planningIntegration.nominalDuty.noStudyLoad':
            'Vul eerst de studiebelasting in bij Catalogusitem algemeen.',
        'modules.planningIntegration.nominalDutyActivityCode': 'Code nominale uren',
        'modules.planningIntegration.dropdownLabel': 'Dienstverband',
        'modules.planningIntegration.qualificationSync.toggleText':
            'Na voltooiing resultaat als kwalificatie doorsturen naar SDB Planning',
        'modules.planningIntegration.qualificationSync.text':
            'Het behaalde resultaat wordt elke nacht als kwalificatie naar SDB Planning gestuurd.',
        'modules.planningIntegration.qualificationSync.turningOn':
            'Resultaten gaan mee vanaf de volgende nachtelijke synchronisatie. Alles wat al eerder is behaald komt daarbij eenmalig mee.',
        'modules.planningIntegration.qualificationSync.turningOff':
            'Er worden geen nieuwe resultaten meer doorgestuurd. Wat al in SDB Planning staat blijft daar staan.',

        month: 'Maand',
        monthAbout: '{number} maand',
        monthsAbout: '{number} maanden',
        monthAgo: '{number} maand geleden',
        months: 'Maanden',
        monthsAgo: '{number} maanden geleden',
        multiChoice: 'Meerkeuze vraag',
        multiChoiceInfo: 'Minimaal 2 antwoordopties waarbij slechts 1 antwoord gekozen kan worden.',
        multiChoiceWithMultipleAnswersInfo:
            'Minimaal 2 antwoordopties waarbij meerdere antwoorden gekozen kunnen worden.',
        multipleEntries: 'Meerdere aanvragen',
        allCatalogItems: 'Alle catalogusitems',
        myDepartments: 'Mijn afdelingen',
        myMessages: 'Mijn berichten',
        myMessagesAndNotifications: 'Mijn berichten en notificaties',
        myMinerva: 'Portfolio',
        myProgress: 'Mijn voortgang',
        overallProgress: 'Totale voortgang',
        progressSummaryCompleted:
            'Goed bezig: je hebt <b>{done}</b> van de <b>{total}</b> onderdelen succesvol afgerond. Hieronder zie je wat je nog moet doen. Succes!',
        itemsLeftToDo: 'te doen',
        mySelf: 'Mijzelf',
        name: 'Naam',
        nameBlock: 'Naam block',
        nameActivity: 'Naam activiteit',
        nameAscending: 'Naam oplopend',
        nameDescending: 'Naam aflopend',
        nameGroup: 'Naam',
        navigateToClassroom: 'Wil je de opleidingspagina openen?',
        navigateToEnroll: 'Navigeren naar inschrijvingspagina?',
        navigateToElearning: 'Wil je de e-learningpagina openen?',
        navigateToElearningPage: 'Klik om de e-learningpagina te openen',
        navigateToFavorites: 'Bekijk de lijst met favorieten.',
        neutral: 'Neutraal',
        never: 'Nooit',
        NewAndConfirmPasswordsDoNotMatch: 'Wachtwoorden komen niet overeen',
        newDashboard: 'Nieuw dashboard',
        newDashboardDescription:
            'Je gebruikt momenteel het nieuwe dashboard. Schakel deze optie uit om terug te keren naar het huidige dashboard.',
        newExternalCatalogItem: 'Externe Content',
        newestFirst: 'Nieuwste eerst',
        newEvaluationForm: 'Nieuw evaluatieformulier',
        newParticipant: 'Nieuwe deelnemer',
        NewPassword: 'Nieuw wachtwoord',
        newPlanning: 'Rooster toevoegen',
        newsItems: 'Nieuws',
        NewsItemsWidgetInfo: 'Mis niks van wat er in jouw organisatie gebeurt',
        newsMessage: 'Nieuwsbericht',
        newTool: 'Nieuwe hulpmiddel',
        newLink: 'Nieuwe link',
        newLocation: 'Nieuwe locatie',
        newMessage: 'Nieuw bericht',
        newVersion:
            'Er is een nieuwe versie van deze applicatie beschikbaar. Ververs om te upgraden naar de laatste versie',
        next: 'volgende',
        nextSessionDateTime: 'De volgende sessie is op {date} om {time}',
        no: 'Nee',
        noAccreditationFoundTitle: 'Geen accreditaties gevonden',
        noAccreditationInfoFoundTitle: 'Geen accreditatie instellingen ',
        noAccreditationInfoFoundText: 'Er zijn geen accreditatie instellingen voor deze cursus',
        noAssignments: 'Geen toewijzingen',
        noAssignmentFoundTitle: 'Geen toegekende opleidingen gevonden',
        noAssignmentFoundText: 'Ken een opleiding toe',
        noCatalogItemsFoundTitle: 'Geen catalogusitems gevonden',
        noCatalogItemsFoundText: 'Pas eventueel de filterinstellingen aan.',
        NoCatalogItemInterestsFoundText:
            'U heeft nog niet aangegeven dat u heeft interesse heeft in een catalogusitem',
        NoCatalogItemInterestsFoundTitle: 'Geen catalogusitem-interesses gevonden',
        noCertificate: 'Geen certificaat',
        noComment: 'Geen opmerking',
        noCompetencyPassportFound: 'Geen bekwaamheidspaspoort gevonden',
        noCurrentClassroomActivities: 'Er zijn geen actuele klassikale activiteiten',
        noCoursesFoundTitle: 'Geen cursussen gevonden',
        noDashBoardLinksTitle: 'Nog geen dashboard links',
        noDashBoardLinksText:
            'Er zijn nog geen dashboard links. Voeg eventueel een dashboard link toe.',
        noDeadline: 'Geen termijn',
        noDefinitionFoundTitle: 'Geen dossier-items gevonden',
        noDefinitionFoundText: 'Voeg een nieuw dossier-item toe',
        noDepartmentsTitle: 'Geen afdelingen gevonden',
        noDepartmentsText: 'Pas eventueel de filter-instellingen aan.',
        noEmail: 'Geen e-mail',
        noEmployeesFound: 'Geen medewerkers gevonden',
        noEnrollmentsYet: 'Nog geen inschrijvingen.',
        noEvaluationsFound: 'Geen evaluaties gevonden',
        noEvaluationFormReports: 'Er zijn geen evaluatieformulieren rapportages gevonden',
        noExemption: 'Geen vrijstelling',
        noExpertiseText: 'Ervaring of extra kennis opgedaan? Voer het op in je portfolio!',
        noExpertiseTitle: 'Geen dossier-items',
        NoFavorites: 'Geen favorieten',
        noFavoritesButNavigateToAdd:
            'Nog geen favorieten. Ga naar de catalogus en klik op <3 om favorieten toe te voegen.',
        noExaminers:
            'Voor deze activiteit kan (nog) geen beoordelaar worden gekozen. Voor meer informatie neem contact op met de beheerder.',
        noHlApps: 'Geen Werk- & leervormen gevonden',
        notAvailableAnymore: 'niet meer beschikbaar',
        notification: 'Notificatie',
        notifications: 'Notificaties',
        notifyUserAfterCompletion: 'Na voltooiing notificatie naar gebruiker sturen',
        None: 'Geen',
        noLesson: 'Geen les',
        noLink: 'Er is geen gekoppelde link!',
        NoLocation: 'Geen locatie',
        NoLocationOrDoubleLocation: 'Geen locatie of de locatie is dubbel ingepland',
        noLocationFoundTitle: 'Geen locaties gevonden',
        noLocationFoundText: 'Voeg een nieuwe locatie toe.',
        noLocationSelected: 'Geen locatie geselecteerd.',
        noPublicHlApps: 'Er zijn geen openbare Werk- & Leervormen',
        noParticipantsCatalog: 'Start een zoekactie in het filterpaneel rechts.',
        noPlannings: 'Geen roosters gevonden',
        noRelevantTrainingFoundText:
            'Geen relevante opleiding gevonden in jouw persoonlijk leeraanbod',
        noEmployeesSelectedYet: 'Nog geen medewerkers gekozen. Zoek hierboven op naam.',
        noReportDataFound: 'Geen rapportgegevens gevonden',
        noResultsFound: 'Geen resultaten gevonden.',
        noResultsFoundTitle: 'Geen resultaten gevonden',
        noResultsFoundText: 'Pas eventueel de filterinstellingen aan',
        noRevocation: 'Geen herroeping',
        noRolesExistForThisDepartment: 'Er bestaan geen functies voor deze afdeling',
        noSchedulesAddedYet: 'Nog geen sessies toegevoegd.',
        noSchedules: 'U moet minimaal één sessie koppelen',
        noSeatsAvailable: 'Er zijn op dit moment geen plaatsen beschikbaar.',
        noSkillsAndMandatoryAssigned: 'Geen bekwaamheden of verplichte opleidingen gekoppeld',
        noSsoGroupsFound: 'Geen sso groepen gevonden',
        notAchieved: 'Niet behaald',
        notAssigned: 'Niet toegewezen',
        NotAuthorized: 'Niet geautoriseerd',
        notAvailable: 'nvt',
        NoTeacherOrDoubleTeacher: 'Geen docent of er is een docent dubbel ingepland',
        noteThisIsAMultiDayPlanningAllDaysWillBeCancelled:
            'Let op: dit betreft een meerdaagse planning. Alle dagen zullen worden geannuleerd.',
        noTrainingFoundTitle: 'Geen opleiding gevonden',
        noTrainingFoundText:
            'Er zijn geen opleidingen beschikbaar of gebruik andere zoekinstellingen',
        noTrainingFoundTextAlt: 'Er zijn geen opleidingen gevonden',
        notRequired: 'Niet verplicht',
        noEnrollmentsFound: 'Geen inschrijvingen gevonden',
        noEnrollmentsHeader: 'Nergens voor ingeschreven',
        noEnrollmentsText: 'Geen probleem, je kunt je via de catalogus inschrijven',
        notVisibleAnymore: 'Niet meer zichtbaar',
        notYetVisible: 'Nog niet zichtbaar',
        notApproved: 'Niet bekwaam',
        notComplete: 'Onvolledig',
        notCompletedStatus: 'Niet voldaan',
        NotEnoughParticipants: 'Onvoldoende deelnemers',
        notRead: 'Niet gelezen',
        noReviewers: 'Geen beoordelaar geselecteerd.',
        NoTeacher: 'Geen docent',
        noTeachers: 'Geen docent geselecteerd.',
        NotEnoughRightsForAccreditations:
            'Je hebt niet genoeg rechten om deze accreditaties te mogen zien.',
        notEnrolledEnrollFirst: 'Nog niet ingeschreven. Ga naar de catalogus om in te schrijven.',
        notKnown: 'Niet bekend',
        notMandatory: 'Mag overslaan',
        notMandatoryOrRecommended: 'Toegewezen (Niet vereist of aanbevolen)',
        notOnAllPresent: 'bij een bijeenkomst niet aanwezig geweest',
        NotOnAllPresentAndNotOnAllNotPresent: 'presentie niet volledig ingevuld',
        notPassed: 'Niet voldaan',
        notRegistered: 'Niet ingeschreven',
        NotSatisfied: 'Niet voldaan',
        NotStarted: 'Niet gestart',
        noPlanningsFoundTitle: 'Geen planningen gevonden',
        noPlanningsFoundText: 'Probeer om de filters aan te passen.',
        noReservationsFoundTitle: 'Geen reserveringen gevonden',
        notApplicableStatusDescription: `Indien ingesteld, vervalt de verplichting van deze bekwaamheid en wordt deze standaard verborgen in het bekwaamheidspaspoort.`,
        noTool: 'Geen hulpmiddel geselecteerd.',
        noToolFoundTitle: 'Geen hulpmiddelen gevonden',
        noToolFoundText: 'Voeg een nieuw hulpmiddel toe',
        notSet: 'Niet ingesteld',
        notVisible: 'Niet zichtbaar',
        notYetDone: 'Nog niet klaar',
        notYetFinalized: 'Nog niet afgerond',
        notYetKnown: 'Nog niet bekend',
        notYetStarted: 'Nog niet gestart',
        noUnrollNotificationsFoundTitle: 'Geen notificaties gevonden',
        noUsersFoundTitle: 'Geen gebruikers gevonden',
        noUsersFoundText: 'Vul het correcte domein in en zoek op gebruikersnaam',
        noTeachersFoundTitle: 'Geen leraren gevonden',
        noTeachersFoundText: 'Er zijn nog geen toegekende leraren',
        SkillsReportViewers: 'Bekwaamhedenrapporteurs',
        'skillsReportViewers.AllSkills': 'Alle bekwaamheden',
        'skillsReportViewers.ConfigureSkillsReportViewers': 'Bekwaamhedenrapporteurs instellen',
        'skillsReportViewers.ConfirmDeleteAllSkillsReportViewerAssignments':
            "Weet je zeker dat je ''{displayName}'' als bekwaamhedenrapporteur wilt verwijderen?",
        'skillsReportViewers.ConfirmDeleteSkillsReportViewerWithContextAssignment':
            "Weet je zeker dat je de inzage in bekwaamheid ''{context}'' voor ''{displayName}'' wilt verwijderen?",
        'skillsReportViewers.ConfirmDeleteSkillsReportViewerWithoutContextAssignment':
            "Weet je zeker dat je de inzage in alle bekwaamheden voor ''{displayName}'' wilt verwijderen?",
        'skillsReportViewers.Explainer':
            'Bekwaamhedenrapporteurs hebben toegang tot de bekwaamhedenrapportage en inzicht in de voortgang van geselecteerde bekwaamheden, zowel op afdelingsniveau als op individueel niveau.',
        'skillsReportViewers.NoSkillsReportViewersFoundTitle':
            'Geen bekwaamhedenrapporteurs gevonden',
        'skillsReportViewers.NoSkillsReportViewersFoundText':
            'Er zijn nog geen bekwaamhedenrapporteurs toegekend',
        'skillsReportViewers.SelectEmployee': 'Selecteer medewerker',
        'skillsReportViewers.SelectSkillsReportViewer': 'Bekwaamhedenrapporteur',
        'skillsReportViewers.SelectSkill': 'Bekwaamheid',
        'skillsReportViewers.SelectSkills': 'Selecteer bekwaamheden',
        number: 'Aantal',
        numberApproved: 'Aantal bekwaam',
        numberCatalogItems: 'Aantal catalogusitems',
        numberdays: 'Aantal dagen',
        numberhours: 'Aantal uren',
        numberminutes: 'Aantal minuten',
        numberOfCompletedEvaluations: 'Aantal ingevulde formulieren',
        numberOfUnCompletedEvaluations: 'Aantal niet-voltooide evaluaties',
        numberOfPlacesAvailable: 'Aantal plekken vrij',
        numberOfPoints: 'Aantal punten',
        numberOfPointsAchieved: 'Behaalde punten',
        numberOfRegisteredParticipants: 'Aantal geregistreerde deelnemers',
        numberOfReservations: 'Aantal reserveringen',
        numberOfSelectedItems: 'aantal items geselecteerd',
        numberOfSkills: '{numberOfSkills} bekwaamheden',
        numberOfSkillsInTotal: '{numberOfSkills} bekwaamheden in totaal',
        numberparticipants: 'Aantal deelnemers',
        numberrecipients: 'Aantal deelnemers',
        ofAssessmentsCarriedOutByYou: 'Beoordeel een collega',
        off: 'Uit',
        ofWhichMandatory: 'Waarvan verplicht',
        ok: 'OK',
        oldestFirst: 'Oudste eerst',
        on: 'Aan',
        On2: 'Op',
        on2: 'op',
        onAllPresent: 'bij elke bijeenkomst aanwezig geweest',
        one: 'een',
        oneOfTheScheduleIsNotFilledInWell: 'Een van de sessies is niet goed ingevuld',
        onlyActiveAccounts: 'Alleen actieve accounts',
        onlyAssignableByAdmins: 'Alleen toe te wijzen door beheerders',
        onlyAssignableByAdminsSkills: 'Bekwaamheid alleen toe te wijzen door beheerders',
        onlyAssignableByAdminsSkillsInfo:
            'Dit geldt alleen voor bekwaamheden. Toewijsbeperkingen voor leerpaden kunnen worden ingesteld in het catalogusitem.',
        onlyDisabledAccounts: 'Alleen uitgeschakelde accounts',
        onlyWithSkills: 'Verberg afdelingen zonder bekwaamheden',
        onlyWithWarnings: 'Alleen met waarschuwingen',
        onlyQualifiedAssessorsAllowed: 'Je bent niet bekwaam om dit item te toetsen',
        oops: 'Oeps',
        open: 'Openen',
        openApplications: 'Openstaande aanvragen',
        openCatalogItem: 'Open catalogusitem',
        openElearningDialogInFullscreenText: 'Open e-learning dialoog in volledig scherm',
        openInANewWindow: 'Openen in een nieuw scherm',
        openQuestion: 'Open vraag',
        openQuestionInfo:
            'Gebruikers kunnen via een open invulveld een aantal steekwoorden opgeven. Er worden geen antwoordopties bij deze vraag opgeven.',
        openScormInNewWindow: 'Open SCORM pakket(ten) in nieuw scherm',
        openScormInNewWindowDetail:
            'Wanneer dit catalogusitem SCORM pakketten bevat, openen deze in een nieuw scherm. Alleen gebruiken wanneer starten in hetzelfde scherm problemen oplevert, omdat openen in een nieuw scherm problemen met popupblockers op zou kunnen leveren. Deze instelling heeft geen functie wanneer er geen SCORM pakketten in dit catalogusitem zitten.',
        openScormInNewWindowDontClose:
            'Deze content is geopend in een nieuwe scherm. Sluit dit scherm of tab niet af.',
        optional: 'Optioneel',
        options: 'Opties',
        optionText: 'Tekst optie',
        optionQuestion: 'Optie vraag',
        order: 'Volgorde',
        'Ordered List': 'Nummering',
        orEnterAssessmentsByName: 'Beoordeel een collega',
        Outdent: 'Inspringing verkleinen',
        overrideTheMasterDescription:
            'Gebruik een eigen tekst in plaats van de standaard omschrijving',
        overrideTheMasterSummary: 'Gebruik een eigen tekst in plaats van de standaard samenvatting',
        overview: 'Overzicht',
        ownName: 'Eigen benaming',
        Package: 'Pakket',
        PackagesActive: 'Pakketten actief',
        PackagesInactive: 'Pakketten inactief',
        PageNotFound: 'De pagina kon niet worden gevonden...',
        pageIsUnavailableTitle: 'Pagina niet beschikbaar',
        pageIsUnavailable: 'Deze pagina is niet beschikbaar of buiten werking gesteld.',
        payAttention: 'Let op',
        parentPortalGroup: 'Bovenliggende afdeling',
        participant: 'Deelnemer',
        participantAdded: 'Deelnemer toegevoegd',
        ParticipantEntersTheQueue: 'Deelnemer komt op wachtrij',
        participantIsNotSelected: 'Deelnemer is niet geselecteerd',
        participantRegistered: 'deelnemer ingeschreven',
        participants: 'Deelnemers',
        participantsRegistered: 'deelnemers ingeschreven',
        participantUnRegistered: 'Deelnemer uitgeschreven',
        passed: 'Voldaan',
        Passed: 'Voldaan',
        PassedAndExpired: 'Voldaan, maar verlopen',
        past: 'Verleden',
        pathToImage: 'Pad naar afbeelding',
        paymentHeading: 'Afrekenen',
        'pe.externalPersonId': 'PE-online Gebruiker ID',
        'pe.courseId': 'PE-online Cursus ID',
        'pe.editionId': 'PE-online Editie ID',
        'pe.moduleId': 'PE-online Module ID',
        'pe.organization': 'Beroepsorganisatie',
        'nonpe.code': 'Code',
        peerassessment: 'Peer assessment',
        peerAssessment: 'Peer assessment',
        percentageApproved: 'Percentage bekwaam',
        'percentageApproved%': '% bekwaam',
        period: 'Periode',
        Periods: 'Termijnen',
        periodsInDays: 'In- & uitschrijftermijn',
        permalink: 'Permanente link',
        permissionRequestHasFailed: 'Toestemmingsverzoek is mislukt',
        personalGroup: 'Persoonlijk',
        phasedOut: 'Uitgefaseerd',
        phasedOutOn: 'Uitgefaseerd per {date}',
        phasingOutOn: 'Uitgefaseerd per {date}',
        phaseout: 'Uitfaseren',
        phaseOutBy: 'Uitgefaseerd op {date}',
        phaseOutDate: 'Uitfaseerdatum',
        phaseOutDateContent: 'vanaf {date} niet meer beschikbaar',
        phaseOutDateContentSkills: 'Vanaf {date} niet meer beschikbaar',
        phone: 'Telefoon',
        placeOfBirth: 'Geboorteplaats',
        plannedActivities: 'Geplande activiteiten',
        plannedSessions: 'Geplande sessies',
        planners: 'Planners',
        'planners.ConfirmDeletePlannerAssignmentWithContextAssignment':
            "Weet je zeker dat je de toegang tot catalogusitem ''{context}'' voor ''{displayName}'' wilt verwijderen?",
        planning: 'Rooster',
        planningIsInPast: 'Rooster is in het verleden',
        plannings: 'Roosters',
        planningInformation: 'Rooster informatie',
        planningOverlap:
            'Er is overlap met jouw dienst / verlof. Inschrijven is niet mogelijk. Controleer jouw planning.',
        planningOverlapGeneral:
            'Er is overlap met jouw dienst / verlof. Inschrijven is niet mogelijk. Controleer jouw planning.',
        planningErrorAbsenceOverlap:
            'Inschrijven is niet mogelijk: de training overlapt met verlof in jouw rooster. Controleer jouw planning.',
        planningErrorUnknown:
            'De inschrijving is door de planning geweigerd (code: {code}). Neem contact op met de planning of de beheerder.',
        planningErrorRejected:
            'De inschrijving is door de planning geweigerd. Neem contact op met de planning of de beheerder.',
        planningErrorNotConfigured:
            'De planningskoppeling is niet ingericht voor dit portaal. Neem contact op met de beheerder.',
        planningSelectContract: 'Selecteer een actief dienstverband.',
        planningOverlapButton: 'Overlap in diensten',
        planningOverlapFictitiousHours:
            'Er is overlap met jouw rooster in Planning. Indien mogelijk worden trainingsuren na inschrijving naast jouw diensten weggeschreven.',
        pleaseChooseTheDesiredDateAndClickEnrollToRegisterForTheNewSchedule:
            'Kies hieronder de gewenste datum en klik op "Inschrijven" om in te schrijven op de nieuwe planning',
        Process: 'Verwerken',
        point_s: 'punt',
        points: 'Punten',
        points_s: 'punten',
        portfolio: 'Portfolio',
        PortfolioDefinitions: 'Dossieritems',
        PortfolioInstance: 'Dossieritem',
        PortfolioTasks: 'Dossier',
        PortfolioTasksAuthorize: 'Dossiertaken - autoriseren',
        PortfolioTasksName: 'Dossiernaam',
        PortfolioTasksReview: 'Dossiertaken - beoordelen',
        PortfolioTasksAccept: 'Dossiertaken - accepteren',
        PortfolioAccept: 'Accepteren',
        PortfolioReject: 'Afwijzen',
        'portfolioTask.accepted': 'Geaccepteerd',
        'portfolioTask.rejected': 'Afgewezen',
        'portfolioTaskOptions.active.name': 'Dossieritem is actief',
        'portfolioTaskOptions.active.description':
            'Gebruiker kan een Dossieritem van dit type toevoegen',
        'portfolioTaskOptions.fileUploadRequired.description':
            'De gebruiker moet ondersteunende documenten bijvoegen',
        'portfolioTaskOptions.multipleInstances.name': 'Meerdere aanvragen mogelijk',
        'portfolioTaskOptions.multipleInstances.description':
            'Gebruiker kan meerdere Dossieritems van dit type toevoegen',
        'portfolioTaskOptions.review.name': 'Beoordelen',
        'portfolioTaskOptions.review.description': 'Schakel de beoordelingsoptie in',
        'portfolioTaskOptions.reviewByManager.name': 'Manager',
        'portfolioTaskOptions.reviewByManager.description':
            'Dit type Dossieritem moet door een manager beoordeeld worden',
        'portfolioTaskOptions.reviewByAssignedUsers.name': 'Toegewezen gebruikers',
        'portfolioTaskOptions.reviewByAssignedUsers.description':
            'U moet gebruikers toewijzen om dit Dossieritem te beoordelen',
        'portfolioTaskOptions.reviewBySkillReviewer.name': 'Toetsers',
        'portfolioTaskOptions.reviewBySkillReviewer.description':
            'Dit dossieritem wordt beoordeeld door toetsers (Beheer -> Toetsers)',
        PortfolioRemoveMarking: 'Opnieuw instellen',
        'portfolio.mandatory.heading.mandatoryTraining': 'Verplichte opleiding',
        'portfolio.mandatory.heading.bestResult': 'Beste resultaat',
        'portfolio.mandatory.heading.certificate': 'Certificaat',
        'portfolio.results.heading.course': 'Opleiding',
        'portfolio.results.heading.lastAction': 'Laatste actie',
        'portfolio.results.heading.bestResult': 'Beste resultaat',
        'portfolio.results.heading.certificate': 'Certificaat',
        practical: 'Praktijk',
        preference: 'Voorkeur',
        presence: 'Presentie',
        presenceProcessing: 'Presentieverwerking',
        presenceOfTheDaysBefore: 'Presentie van de dagen hiervoor',
        presenceNotFullyUpdated: 'Presentie niet volledig bijgewerkt',
        present: 'Aanwezig',
        presentOn: 'Aanwezig op',
        presentParticipants: 'Aanwezige deelnemers',
        previousElearning: 'Vorige e-learning(s)',
        previousStep: 'Vorige stap',
        primaryBackgroundColor: 'Primaire achtergrondkleur',
        primaryBackgroundColorDark: 'Primaire donkere achtergrondkleur',
        primaryBackgroundColorLight: 'Primaire lichte achtergrondkleur',
        price: 'Prijs',
        Price: 'Prijs',
        PaymentValidity: 'Geldigheidsduur (dagen)',
        Lumpsum: 'Centraal gefinancieerd',
        PaymentInfo: 'Betalingsinformatie',
        VATPercentage: 'BTW',
        DomainSpecificPrice: 'Domein specifieke kosten',
        Platform: 'Platform',
        PlatformSettings: 'Platforminstellingen',
        PlatformSpecificPrice: 'platformgroep specifieke kosten',
        PortalSpecificPrice: 'portaalgroep specifieke kosten',
        PlatformText: 'Platformtekst',
        profile: 'Profiel',
        ProfileOf: 'Profiel van',
        profileImage: 'Profielfoto',
        profileSaved: 'profiel opgeslagen',
        progress: 'Voortgang',
        protocol: 'Protocol',
        public: 'Openbaar',
        publishedToCatalog: 'Gepubliceerd in catalogus',
        publishToCatalog: 'Publiceren in catalogus',
        question: 'Vraag',
        questionText: 'Vraagtekst',
        questionType: 'Vraagtype',
        queue: 'Wachtrij',
        queued: 'U zit in de wachtrij',
        Queued: 'In de wachtrij',
        QueuedAlreadyOnAPlanning: 'De persoon staat al in een wachtrij op een planning.',
        queueThenAutomaticRegistration: 'Wachtrij, daarna automatisch inschrijving',
        queueThenSendInvitation: 'Wachtrij daarna uitnodiging sturen',
        QueuedWhenFull: 'Wachtrij indien vol',
        read: 'Gelezen',
        readyForYou: 'Dit staat voor jou klaar',
        readDocumenttype: 'Heeft u het document gelezen?',
        readProtocol: 'Heeft u het protocol gelezen?',
        readManual: 'Heeft u de handleiding gelezen?',
        readless: 'Lees minder',
        readmore: 'Lees meer',
        reason: 'Reden',
        recalculate: 'opnieuw berekenen',
        receivedMessages: 'Ontvangen berichten',
        receivedOn: 'Ontvangen op',
        receiverDomain: 'Ontvanger domein',
        recipients: 'Ontvangers',
        recommended: 'Geadviseerd',
        recommended_label: 'Aanbevolen',
        redo: 'Opnieuw doen',
        Redo: 'Opnieuw doen',
        referenceDate: 'Referentiedatum',
        refresh: 'Verversen',
        refreshThePage: 'Ververs de pagina',
        register: 'Registreren',
        registered: 'Ingeschreven',
        Registered: 'Ingeschreven',
        registeredBy: 'Ingeschreven door',
        registerFrom: 'Per {date}',
        registeredOn: 'Ingeschreven per',
        registeredFrom: 'Ingeschreven vanaf',
        registeredParticipants: 'Ingeschreven deelnemers',
        registeredTill: 'Ingeschreven t/m',
        registerMe: 'Schrijf mij in',
        registration: 'Registratie',
        registrationClosed: 'Inschrijving gesloten',
        registrationNumbers: 'Registratienummers',
        registrationNumbersSaved: 'Registratienummers opgeslagen',
        registrationPeriodHasExpired: 'Inschrijftermijn verstreken',
        registrationFailedTheAllowedNumberOfRegistrationsHasBeenReached:
            'Inschrijven is mislukt. Het toegestane aantal inschrijvingen is bereikt',
        registrationTransferPeriodExceededTitle: 'Overschrijftermijn verstreken',
        registrationTransferPeriodExceeded:
            'Je wilt overschrijven naar een andere sessie. Dit is niet mogelijk omdat de uitschrijftermijn van de huidige sessie is verstreken.',
        'registrationNumbers.notAllowed': 'Het is niet mogelijk om registratienummers op te geven.',
        relatedDocuments: 'Gerelateerde documenten',
        relatedDocumentsText:
            'Documenten zijn standaard voor iedereen zichtbaar. Wilt u ze pas zichtbaar maken nadat iemand zich heeft ingeschreven? Zet dan de schakelaar voor het document aan.',
        relevantCourses: 'Relevante trainingen',
        removedRole: '[verwijderde functie]',
        ReservationRevoked: 'Ingetrokken',
        reservationCode: 'Reserveringscode (optioneel)',
        reservationCodeIsAlreadyUsed: 'De reserveringscode is al gebruikt',
        reservationExpired: 'Verlopen',
        'reservation.status.revoked': 'De reserveringcode is ingetrokken',
        reservation: 'Reservering',
        reinstatedCancelledPlanning: 'Planning weer actief',
        reinstatePlanning: 'Opnieuw activeren',
        deleteCancelledPlanning: 'Planning verwijderd',
        RegionAlreadyExists: 'Er bestaat al een regio / locatie met deze naam!',
        regionLocation: 'Regio / locatie',
        Region_still_in_use:
            'Deze regio is gekoppeld aan een of meerdere tijdsloten en kan daarom niet verwijderd worden',
        reject: 'Afwijzen',
        Rejected: 'Afgewezen',
        rejectedPortfolioItems:
            'Er {number, plural, one {is één dossieritem} other {zijn # dossieritems}} afgewezen',
        rejectRequest: 'Verzoek afwijzen',
        remarkUser: 'Opmerking deelnemer:',
        removeAppointment: 'U heeft al een afspraak staan, wilt u deze verwijderen?',
        removeAllUsersFromVirtualQueueHeader:
            'Alle gebruikers verwijderen van deze interesselijst?',
        removeAllUsersFromVirtualQueueMessage:
            'Alle getoonde interesse voor dit catalogusitem komt hiermee te vervallen',
        removeFunctionUserDepartment:
            'Gebruiker {username} heeft onderstaande functies op deze afdeling. Heeft deze gebruiker een bepaalde functie niet meer, vink deze dan uit.',
        removeFunctionUserDepartment2ndLine:
            'Let op, sommige functies zijn verkregen door een automatische import en kunnen daarom niet gewijzigd worden',
        removeFromList: 'Verwijder van lijst',
        removeFromVirtualQueue: 'Verwijderen van de interesselijst',
        removeFromVirtualQueueDialogHeader: 'Interesse laten vervallen?',
        removeFromVirtualQueueDialogMessage:
            'Weet je zeker dat je jezelf van de interesselijst wilt verwijderen?',
        removeFromVirtualQueueUserDialogHeader: '{displayName} van interesselijst verwijderen?',
        removeFromVirtualQueueUserDialogMessage:
            'De interesse van {displayName} voor dit catalogusitem komt hiermee te vervallen',
        removePlanningPermanently: 'Planning definitief verwijderen?',
        replacement: 'Vervanging',
        reply: 'Beantwoorden',
        reporting: 'Rapportage',
        reports: 'Rapporten',
        'reports.department.mandatoryUsers.currentStatus': 'Huidige status',
        request: 'Aanvraag',
        requestRejectionConfirmation:
            'Weet u zeker dat u de beoordelingsaanvraag van "{employeeName}" voor de activiteit "{activityName}" wilt afwijzen?',
        requests: 'Aanvragen',
        required: 'Verplicht',
        RequiredTrainingsWidgetInfo: 'Altijd inzicht in jouw voortgang',
        'required and must be higher than zero': 'Verplicht en moet hoger dan nul zijn',
        requiredAndMustNotBeGreaterThan: 'Verplicht en mag niet groter dan {number} maanden zijn',
        requiredAndMustNotBeGreaterThan1200: 'Verplicht en mag niet groter dan 1200 maanden zijn',
        requiresTeacher: 'Docent verplicht',
        'requiresTeacher.explainer':
            'Een docent moet verplicht worden ingepland op iedere sessie (van rooster)',
        reset: 'Reset',
        resetLearningPlan: 'Opnieuw maken',
        resetProgress: 'Reset voortgang',
        revocation: 'Herroeping',
        revocationEdit: 'Herroeping bewerken',
        revocationDate: 'Datum van herroeping',
        recovationAtDate: 'Herroeping op {date}',
        revocationStatusDescription: `De status van alle ondernomen activiteiten wordt genegeerd tot aan de ingestelde datum. Dat betekent dat de medewerker na deze datum (opnieuw) de vereiste activiteiten moet afronden om bekwaamheid aan te tonen.`,
        revoked: 'Ingetrokken',
        retry: 'Probeer opnieuw',
        remove: 'verwijder',
        RemoveCatalogInterestConfirm: `Weet u zeker dat u ''{displayName}'' als een interesse wilt verwijderen?`,
        reregister: 'Opnieuw inschrijven',
        reservations: 'Reserveringen',
        reserved: 'Gereserveerd',
        resetCourseTitle: 'Voortgang resetten?',
        resetCourseFor:
            'Het is mogelijk om de voortgang van e-learning "{catalogName}" te resetten omdat deze dreigt te verlopen, al verlopen is of omdat de e-learning niet is behaald door "{displayName}". Alle huidige voortgang van "{displayName}" gaat dan verloren. Het heeft geen invloed op eerder behaalde resultaten.',
        resetCourseWarning: 'Weet je zeker dat je de voortgang voor "{displayName}" wilt resetten?',
        resetFilter: 'reset filter',
        resetCatalogSettingHeader:
            'Resetten van e-learningmodules (hier is per e-learning weer vanaf te wijken)',
        resetCatalogSettingYes: 'Aan: cursisten kunnen zelf e-learning modules resetten',
        resetCatalogSettingNo: 'Uit: cursisten kunnen niet zelf e-learning modules resetten',
        resource: 'Middel',
        resources: 'Middelen',
        resubmit: 'Opnieuw indienen',
        result: 'Resultaat',
        resultDate: 'Resultaatdatum',
        resultFinal: 'Eindresultaat',
        results: 'Resultaten',
        resultsOf: 'Resultaten van',
        resultUnknown: 'Resultaat onbekend',
        Review: 'Ter controle',
        reviewer: 'Beoordelaar',
        reviewers: 'Beoordelaars',
        revoke: 'Intrekken',
        revokeReservation: 'Reservering intrekken',
        revokeConfirmation: 'Weet je zeker dat je deze reservering wilt intrekken?',
        right: 'Rechts',
        Right: 'Rechts',
        Rights: 'Rechten',
        RightsDescription: 'Overige instellingen',
        Role: 'Rol',
        roles: 'Rollen',
        Satisfied: 'Voldaan',
        save: 'Opslaan',
        saveAndContinue: 'Opslaan en doorgaan',
        saved: 'Opgeslagen',
        schedule: 'Sessie',
        scheduleDetail: 'Sessie details',
        scheduleDuration: 'Sessieduur',
        scheduleFull: 'Inschrijven niet mogelijk. Er zijn geen beschikbare plaatsen meer.',
        schedules: 'Sessies',
        scheduleMissesDuration: 'Sessie mist sessieduur',
        Schedule_not_found: 'Schema niet gevonden!',
        schedulesOverlap: 'De sessies overlappen',
        scheduleStartTimeEndTimeConflict: 'Sessie starttijd en eindtijd conflict',
        scheduleTimeTooLong: 'Sessieduur is te lang',
        scorm: 'SCORM',
        seeAll: 'Bekijk alles',
        sendMailMinimumParticipantsNotYetReached: 'Stuur e-mail over minimum deelnemers',
        'sendMailMinimumParticipantsNotYetReached.explainer':
            'Stuur een e-mail naar de docent als het minimum aantal deelnemers niet is bereikt',
        sendClassroomReminderMail: 'Stuur herinneringse-mail',
        'sendClassroomReminderMail.explainer':
            'Stuur deelnemers voorafgaand aan de opleiding een e-mail ter herinnering',
        sendClassroomReminderMailNumberOfDays: 'Aantal dagen voor de klassikale opleiding',
        sendMailMinimumParticipantsNotYetReachedNumberOfDays:
            'Aantal dagen voor de klassikale opleiding (min. 1)',
        'settings.lookAndFeel': 'Huisstijl',
        'settings.lookAndFeel.uploadLogo': 'Upload logo',
        'settings.lookAndFeel.uploadHeroHeader': 'Upload headerfoto',
        'settings.lookAndFeel.heroheader': 'Toon headerfoto op dashboard',
        'settings.lookAndFeel.heroheader.description':
            'Toon een eigen foto als visuele introductie bovenaan de dashboardpagina',
        'settings.featurePreview.title': 'Nieuwe (beta) functionaliteiten',
        'settings.featurePreview.setting': `{value, select,
            off {Uit}
            admin {Beheerders}
            everyone {Iedereen}
            other {{value}}
        }`,
        setApprovalDate: 'Stel datum basis in',
        setBy: 'Ingesteld door',
        setAutomatically: 'Geautomatiseerd ingesteld',
        skillCategories: 'Bekwaamheidscategorieën',
        skillDeleted: 'Bekwaamheid verwijderd',
        skillDetails: 'Details bekwaamheid',
        skillsDeleted: 'Bekwaamheden verwijderd',
        bulkAssignmentsPartiallyFailed:
            '{failed} van de {total} geselecteerde toewijzingen konden niet worden verwerkt.',
        skillslabtest: 'Skillslab',
        skillslabtraining: 'Skillslab',
        score: 'Score',
        'sdb/uriECD': 'Naar SDB ECD',
        'sdb/uriHr': 'Naar SDB HR',
        'sdb/uriPayroll': 'Naar SDB Salaris',
        'sdb/uriPlanning': 'Naar SDB Planning',
        'sdb-add-examiner-appointment-dialog.button': `{ button, select,
            previous_step {Vorige stap}
            schedule_new_appointment {Nieuw toetsmoment inplannen}
            schedule_appointment {Toetsmoment inplannen}
            other {}
        }`,
        'sdb-add-examiner-appointment-dialog.errors': `{ error, select,
            no_time_slots_available {Het is op dit moment niet mogelijk een toetsmoment in te plannen omdat er geen tijdsloten beschikbaar zijn.}
            time_slot_already_reserved {Deze afspraak conflicteert met een andere gemaakte afspraak. Ga terug en selecteer een ander tijdstip of dag.}
            examiner_not_qualified {De toetser is op dit moment niet bekwaam en mag deze activiteit niet aftoetsen.}
            activity_already_present {Er is inmiddels al een afspraak voor deze activiteit gemaakt.}
            other {Er is een onbekende fout opgetreden. [{error}]}
        }`,
        'sdb-add-examiner-appointment-dialog.headline': `{ step, select,
            1 {Toetsmoment combineren of nieuw toetsmoment inplannen}
            2 {Datum en locatie kiezen}
            3 {Toetsmoment op { date_and_location }}
            4 {Toetsmoment inplannen}
            other {}
        }`,
        'sdb-add-examiner-appointment-dialog.description': `{ step, select,
            1 {Er is tijd beschikbaar bij een eerder gepland toetsmoment. Kies hieronder een toetsmoment om de afspraak te combineren of plan een nieuw toetsmoment in.}
            2 {Kies een datum en locatie voor het inplannen van een toetsmoment.}
            3 {Kies het gewenste tijdslot.}
            4 {Wil je het onderstaande toetsmoment inplannen?}
            other {}
        }`,
        'sdb-continue-elearning-widget.widgetInfo': `Ga verder waar je gebleven was`,
        'sdb-time-slot-details.activities-to-assess': `{activities, select,
            1 {Te beoordelen activiteit}
            other {Te beoordelen activiteiten}
        }`,
        search: 'Zoeken',
        searchAClassroomTraining: 'Zoek een klassikale opleiding',
        searchAssignments: 'Zoeken toewijzingen',
        searchByDate: 'Zoek op datum',
        searchByLocation: 'Zoeken op locatie',
        searchByName: 'Zoek op naam',
        searchByNameDepartmentOrJobTitle: 'Zoek op naam, afdeling of functienaam',
        searchByReceiverName: 'Zoek op ontvanger naam',
        filterBySender: 'Filter op afzender',
        searchBySenderName: 'Zoek op naam afzender',
        searchByTeacher: 'Zoek op docent',
        searchAClassroomCourse: 'Zoek klassikale opleiding',
        searchDepartment: 'Zoek afdeling',
        searchElearning: 'E-learning zoeken',
        searchForAMessageOrNotification: 'Zoek een bericht / notificatie',
        searchForAUserWithSkills: 'Zoek naar een gebruiker met bekwaamheden',
        searchFunctions: 'Zoek functies',
        searchLocation: 'Zoek locatie',
        searchInFullCatalog: 'Zoek in de volledige catalogus',
        searchInMyCatalog: 'Zoek in mijn catalogus',
        searchOn: 'Zoek op',
        searchOnCatalogName: 'Zoek op catalogusnaam',
        searchOnDepartmentName: 'Zoek op afdelingsnaam',
        searchOnEmployeeName: 'Zoek op medewerkersnaam',
        searchOnRoleName: 'Zoek op functienaam',
        searchRecipients: 'Zoek ontvangers',
        searchRole: 'Role zoeken',
        searchPackage: 'Pakket zoeken',
        searchSkill: 'Bekwaamheid zoeken',
        searchTool: 'Zoek hulpmiddel',
        secondAbout: '{number} second',
        secondaryBackgroundColor: 'Secundaire achtergrondkleur',
        secondaryBackgroundColorDark: 'Secundaire donkere achtergrondkleur',
        secondaryBackgroundColorLight: 'Secundaire lichte achtergrondkleur',
        secondAgo: '{number} seconde geleden',
        secondsAbout: '{number} seconden',
        secondsAgo: '{number} seconden geleden',
        selectACatalogItemToAssignAcertificateTo: 'Selecteer catalogusitems om aan toe te wijzen',
        SelectACertificate: 'Selecteer een certificaat',
        selectAll: 'Alles selecteren',
        selectAnActivity: 'Selecteer een activiteit',
        selectAPeriod: 'Selecteer een periode',
        selectAPlanning: 'Selecteer een planning',
        SelectASkillToChangeAssignments: 'Selecteer een bekwaamheid om toewijzingen aan te passen',
        selectATrainingToAdd: 'Selecteer een training om aan toe te wijzen',
        selectAssigned: 'Selecteer toegewezen',
        selectAssignmentOption: 'Selecteer doelgroep:',
        selectCategory: 'Selecteer categorie',
        selectCategories: 'Selecteer categorieën',
        selectCompetenceAndFunctions: 'Selecteer bekwaamheid en functies',
        selectDepartment: 'Selecteer afdeling',
        selectDomain: 'Selecteer domein',
        selectDownloadType: 'Selecteer download type',
        selectedEmployees: 'Geselecteerde medewerkers',
        selectedForReview: 'Geselecteerde gebruiker voor beoordeling',
        selectEmployee: 'Selecteer een medewerker',
        selectExportToMakeAnotherUserAssessorForTheSameActivitiesAsThisUser: `Kies voor ''EXPORTEREN'' om een andere gebruiker beoordelaar te maken bij dezelfde activiteiten als deze gebruiker.`,
        SelectExternalLearningPlan: 'Selecteer externe leerplan(nen)',
        selectFile: 'Bestand selecteren',
        selectFunctions: 'Selecteer functies',
        selectImportType: 'Selecteer import type',
        SelectPhoto: 'Foto selecteren',
        SelectManagerCatalogAuthorization: 'Selecteer een manager om de aanvraag bij in te dienen',
        selectOption: 'Selecteer optie',
        selectPortfolioItem: 'Selecteer dossieritem',
        selectReviewer: 'Selecteer de collega die u gaat beoordelen',
        selectReviewerForPortfolioItem: 'Selecteer een beoordelaar voor dit dossieritem',
        selectScormItem: 'Selecteer scorm item',
        selectStatus: 'Selecteer status',
        selectTargetType: 'Selecteer type',
        selectTeacher: 'Selecteer docent',
        selectType: 'Selecteer type',
        selectReportType: 'Selecteer type rapport',
        selectVisibility: 'Selecteer zichtbaarheid',
        selfassessment: 'Zelfbeoordeling',
        send: 'Verzenden',
        sendAMessage: 'Stuur een bericht',
        sendMessage: 'Stuur bericht',
        senderDomain: 'Afzender domein',
        sendUserConfirmationMail: 'Stuur een bevestiging per e-mail',
        sentMessages: 'Verzonden berichten',
        sentFromCommunity: 'Verstuurd vanuit Community (werkvormen)',
        sentToPortfolioItems: 'Verzonden naar dossier',
        session: 'Sessie',
        sessionName: 'Sessienaam',
        sessions: 'sessies',
        settings: 'Instellingen',
        skill: 'Bekwaamheid',
        skillCanBeUnlinkedOnlyByAdmins:
            'Deze bekwaamheid kan alleen door beheerders worden ontkoppeld',
        skillOnlyAssignableByAdmin: 'Deze bekwaamheid kan alleen door beheerders worden toegewezen',
        skills: 'Bekwaamheden',
        skillsReport: 'Bekwaamheden rapport',
        skillStatusPerEmployee: 'Status per medewerker',
        skillsReportWidgetInfo: 'Monitor de voortgang van bekwaamheden',
        skillsAlmostExpired: 'bijna verlopen',
        skillsExpired: 'verlopen',
        skillsPassport: 'Bekwaamheidspaspoort',
        skillsPassportOf: 'Bekwaamheidspaspoort van',
        'SkillsReport.WhatToExport': 'Welke gegevens wil je exporteren?',
        'SkillsReport.SummaryExport': 'Samenvatting van bekwaamheden (huidige selectie)',
        'SkillsReport.TotalExport': 'Totaaloverzicht van bekwaamheden op afdeling/functie niveau',
        'SkillsReport.Present': 'Actueel',
        'SkillsReport.DisplayProvenSkills': 'Toon aangetoonde bekwaamheden op...',
        'SkillsReport.History': 'Historie',
        'SkillsReport.HistoryConflictNoDate': 'Selecteer een datum',
        'SkillsReport.HistoryConflictNoType': 'Selecteer het soort data',
        'SkillsReport.HistoryConflictNoUser': 'Selecteer een gebruiker',
        'SkillsReport.HistoryConflictMessage': 'Selecteer een datum en de gewenste historie',
        'SkillsReport.PresentOverview': 'Actueel overzicht ',
        'SkillsReport.HistoryOverview': 'Historie overzicht',
        'SkillsReport.SelectUser': 'Selecteer een gebruiker',
        'SkillsReport.ShowHistory': 'Toon historie van...',
        'SkillsReport.SpecificUser': 'Specifieke gebruiker',
        'SkillsReport.ProvenSkills': 'Aangetoonde bekwaamheden',
        showAdvancedFilters: 'Toon geavanceerde filters',
        showAll: 'Toon alles',
        showLess: 'Minder tonen',
        showMore: 'Meer tonen',
        showAlsoExpiredAndFutureCatalogItems: 'Toon ook verlopen / toekomstige items',
        showAssessment: 'Toon assessment',
        showDepartments: 'Toon afdelingen',
        showDisabledAccounts: 'Toon uitgeschakelde accounts',
        showEmptyValues: 'Toon lege waarden',
        showExpiredSchedules: 'Toon verlopen roosters',
        showForm: 'Toon formulier',
        showStandardFilters: 'Toon standaard filters',
        signIn: 'Inloggen',
        signInToUse: 'Log in om van SDB Leerplatform gebruik te kunnen maken',
        show: 'Inhoud bekijken',
        showOnly: 'Toon alleen',
        showOverview: 'Overzicht weergeven',
        signOut: 'Uitloggen',
        size: 'Grootte',
        someoneElse: 'Iemand anders',
        sortBy: 'Sorteer op',
        sortByDate: 'Sorteer op datum',
        sortedByDate: 'Gesorteerd op datum',
        spaceFillingProportionalStandard: 'Ruimtevullend, in verhouding (standaard)',
        ssosearch: 'Gebruiker zoeken',
        ssoUserInformation: 'Gebruikersaccount',
        ssoUserOrGroup: 'Gebruiker / groep',
        start: 'Starten',
        startDate: 'Begindatum',
        startDates: 'Planning',
        started: 'Gestart',
        Started: 'Gestart',
        startedCourses: 'Gestart trainingen',
        startedOn: 'Begonnen op',
        StartTime: 'Starttijd',
        statusAll: 'Alles',
        statusAccept: 'Ter acceptatie',
        startedStatus: 'Gestart',
        statusReview: 'Ter controle',
        statusReject: 'Afgewezen',
        Status: 'Status',
        statusCompleted: 'Afgehandeld',
        stillToDo: 'nog te doen',
        Strikethrough: 'Doorhalen',
        stronglyAgree: 'Sterk mee eens',
        stronglyDisagree: 'Sterk mee oneens',
        studyLoad: 'Studiebelasting',
        studyLoadInMinutes: 'Studiebelasting in minuten',
        style: 'Stijl',
        subDepartment: 'Subafdeling',
        subDepartments: 'Subafdeling(en)',
        subject: 'Onderwerp',
        submit: 'Indienen',
        submitAssessment: 'Beoordeling indienen',
        submitForm: 'Formulier indienen',
        submitRequest: 'Aanvraag indienen',
        submitCatalogAuthorizationRequest:
            'Je gaat een aanvraag indienen bij je manager om deze training te kunnen volgen. Dit zijn de gegevens:',
        subtitle: 'Subtitel',
        SuccesRegistrationIsPossible: 'De persoon kan op dit rooster worden ingeschreven.',
        Summary: 'Samenvatting',
        switchToNewDashboard: 'Nieuw dashboard uitproberen',
        switchToNewDashboardDescription:
            'Probeer alvast onze vernieuwde dashboardervaring. Je kunt altijd terugschakelen.',
        tabDetails: 'Details',
        tabBijlagen: 'Bijlagen',
        tabComments: 'Opmerkingen',
        'targetType.all': 'Alles',
        'targetType.learningplan': 'E-learning',
        'targetType.composition': 'E-learning',
        'targetType.classroom': 'Klassikaal',
        'targetType.expertise': 'Dossieritems',
        'targetType.learningpath': 'Leerpad',
        'targetType.microlearning': 'Micro Learning',
        'targetType.scorm': 'Scorm',
        'targetType.lti': 'LTI',

        'targetType.microlearning.video': 'Video',
        'targetType.microlearning.movie': 'Video',
        'targetType.microlearning.audio': 'Audio',
        'targetType.microlearning.animation': 'Animatie',
        'targetType.microlearning.infographic': 'Infographic',
        'targetType.microlearning.exercise': 'Oefenen',
        'targetType.microlearning.microcourse': 'Microcursus',
        'targetType.microlearning.text': 'Tekst',
        'targetType.microlearning.test': 'Toets',
        'targetType.microlearning.pretest': 'Test jezelf',
        'targetType.microlearning.complete': 'E-learning',
        'targetType.microlearning.elearning': 'E-learning',
        tcgPasswordStrength: {
            Label: 'Sterkte',
            None: 'geen',
            VeryWeak: 'erg zwak',
            Weak: 'zwak',
            Medium: 'gemiddeld',
            Strong: 'sterk',
            VeryStrong: 'zeer sterk',
        },
        Taught: 'Lesgegeven',
        tcgUpload: {
            dropFiles: {
                one: 'Sleep bestand hierheen',
                many: 'Sleep bestanden hierheen',
            },
            addFiles: {
                one: 'Selecteer bestand...',
                many: 'Selecteer bestanden...',
            },
            cancel: 'Annuleren',
            error: {
                tooManyFiles: 'Te veel bestanden.',
                fileIsTooBig: 'Bestand is te groot.',
                incorrectFileType: 'Incorrect bestandstype.',
            },
            uploading: {
                status: {
                    connecting: 'Verbinden...',
                    stalled: 'Vastgelopen.',
                    processing: 'Bestanden verwerken...',
                    held: 'De bestanden worden geupload na verwerking.',
                },
                remainingTime: {
                    prefix: 'resterende tijd: ',
                    unknown: 'resterende tijd onbekend',
                },
                error: {
                    serverUnavailable: 'Server niet bereikbaar',
                    unexpectedServerError: 'Onverwachte serverfout',
                    forbidden: 'Geweigerd',
                },
            },
            units: {
                size: ['B', 'kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
                sizeBase: 1000,
            },
        },
        tasksTitle: 'Taken',
        tasksLoading: 'Taken worden geladen',
        noTasksOpenTitle: 'Geen openstaande taken',
        noTasksOpenText: 'Zodra er iets op jouw actie wacht, verschijnt het hier.',
        teacher: 'Docent',
        teacherArchive: 'Docent archief',
        teacherOverviewDescription: 'Overzicht docenten',
        teachers: 'Docenten',
        teacherIsMandatory: 'Docent is verplicht',
        Temporary: 'Tijdelijk',
        TemporaryEnrollmentComments: 'Opmerkingen voorlopige inschrijving',
        temporaryParticipants: 'Voorlopig ingeschreven deelnemers',
        temporaryParticipantsTab: 'Voorlopige inschrijvingen',
        template: 'Sjabloon',
        tertiaryBackgroundColor: 'Tertiaire achtergrondkleur',
        testResult: 'Resultaat',
        text: 'Tekst',
        textField: 'Tekstveld',
        textFieldInfo:
            'Tekst voor een toelichting of instructie. Dit is geen vraag. De medewerker kan hier niets invullen.',
        theBlockMustAtleastContainAquestion: 'De blok moet tenminste één vraag bevatten',
        theActivityIsNoLongerAvailable: 'De activiteit is niet meer beschikbaar',
        theAllowedNumberOfRegistrationsHasBeenReached:
            'Het toegestane aantal inschrijvingen voor deze gebruiker is bereikt',
        theAllowedNumberOfRegistrationsForMyselfHasBeenReached:
            'U heeft uw maximaal aantal inschrijvingen voor deze opleiding bereikt',
        theAllowedNumberOfRegistrationsForThisUserHasBeenReached:
            'Het toegestane aantal inschrijvingen voor deze gebruiker is bereikt',
        theColleagueWhoWillAssessYou: 'De collega die jou gaat beoordelen',
        theFirstBeginsOn: 'de eerste begint op ',
        theFollowingParticipantsAreStillRegisteredOnTheSchedule:
            'De volgende deelnemers zijn nog ingeschreven op de planning:',
        TheLearningPlansThatWillGetActivated: 'De leerplannen die geactiveerd gaan worden',
        themeColors: 'Themakleuren',
        themeColorPrimary: 'Primaire kleur',
        themeColorSecondary: 'Secundaire kleur',
        themeColorTertiary: 'Tertiare kleur',
        themeColorButton: 'Knop kleur',
        themeColorProgress: 'Voortgangsbalk kleur',
        themeColorProgress100: 'Voortgangsbalk 100% kleur',
        themeDescription:
            'Stel eenvoudig 2 themakleuren in. De tekstkleur en de ondersteunende kleuren worden automatisch berekend. Niet helemaal naar wens? Bepaal dan zelf de lichte en donkere variant van de basiskleuren!',
        theMinimumNumberOfMandatoryActivitiesIs:
            'Het minimum aantal verplichte activiteiten is {number}',
        theNextOneIsOn: 'de volgende is op',
        theNextActivityStarts: 'Volgende activiteit:',
        theNextLessonStarts: 'Volgende activiteit:',
        thereAreEvaluationRequests: 'Evalueer jouw trainingen',
        thereAreListsThatNeedToBeUpdated: 'Verwerk openstaande presentielijsten',
        thereAreNoAssessmentsFound: 'Er zijn geen beoordelingen gevonden',
        thereAreNoAssessmentsFoundTitle: 'Geen beoordelingen',
        ThereArenoAssignmentsFound: 'Er zijn geen beoordelingen gevonden',
        thereAreNoDepartmentsFound: 'Er zijn geen afdelingen gevonden',
        thereAreNoDocuments: 'Er zijn geen documenten.',
        thereAreNoFormsFound: 'Er zijn geen formulieren gevonden',
        thereAreNoFormsFoundTitle: 'Geen formulieren',
        thereAreNoFunctionsLinkedToThisSkill:
            'Er zijn geen functies meer gekoppeld aan deze bekwaamheid',
        thereAreNoFuturePlannedLessons: 'Er zijn geen toekomstige geplande lessen',
        thereAreNoListsToUpdate: 'Er zijn geen lijsten om bij te werken',
        thereAreNoMessageFound: 'Er zijn geen berichten gevonden',
        thereAreNoMessageTitle: 'Geen berichten gevonden',
        thereAreNoOpenAssessmentRequests: 'Er zijn geen openstaande beoordelingsaanvragen',
        thereAreNoPastPlannedLessons: 'Er zijn geen verlopen lessen gevonden',
        thereAreNoParticipantsConnectedToThisSchedule:
            'Er zijn geen deelnemers gekoppeld aan deze planning',
        thereAreNoParticipantsFound: 'Er zijn geen deelnemers gevonden',
        thereAreNoRequiredTrainings: 'Er zijn geen verplichte opleidingen',
        thereAreNoRequiredTrainingsFound: 'Er zijn geen verplichte opleidingen gevonden',
        thereAreNoRequiredTrainingsAssigned: 'Geen verplichte opleidingen gekoppeld',
        thereAreNoSkillsCategoriesFoundTitle: 'Geen bekwaamheden categorieën gevonden',
        thereAreNoSkillsCategoriesFoundText:
            'Voeg een bekwaamheid-categorie toe of reset the filters',
        thereAreNoSkillsFound: 'Er zijn geen bekwaamheden gevonden',
        thereAreNoSkillsFoundTitle: 'Geen bekwaamheden gevonden',
        thereAreNoSkillsLinked: 'Er zijn geen bekwaamheden gekoppeld',
        thereAreNoSkillsFoundText: 'Pas eventueel de filterinstellingen aan',
        thereAreOpenAssessmentRequests: 'Er zijn openstaande beoordelingsaanvragen',
        thereAreThecomingDays: 'Er zijn de komende',
        thereIsAccreditationFound: 'Er is geen accreditatie gevonden',
        thereIsAnEvaluationRequests: 'Evalueer jouw training',
        thereIsNoLocationSelected: 'Er is geen locatie geselecteerd',
        thereIsNoTeacherSelected: 'Er is geen docent geselecteerd',
        theSelectedAssessor: 'De geselecteerde beoordelaar',
        theorems: 'Stellingen',
        thisCatalogItemIs: 'Dit catalogusitem is',
        thisCatalogItemIsDisabled: 'Dit catalogusitem is uitgeschakeld',
        thisCatalogItemIsDenied: 'Dit catalogusitem is niet toegewezen',
        thisExaminerIsNotSkilled: 'Deze beoordelaar is niet bekwaam',
        thisMinervaPortalDoesNotExist: 'Dit SDB Leerplatform bestaat niet',
        thisScheduleIsFullTheNewRegistrationsWillBeQueued:
            'Dit rooster is vol. Als beheerder / planner kan je het rooster negeren. Wanneer je doorgaat wordt de medewerker toch ingeschreven.',
        thisScheduleIsFullTheNewRegistrationsWillBeQueuedOnPosition:
            'Dit rooster is vol. De nieuwe inschrijving komt op de wachtrij op positie {number}',
        thisScheduleConflictsWithAnotherScheduleForWhichThisParticipantIsRegistered:
            'Dit rooster conflicteert met een ander rooster waarvoor deze deelnemer ingeschreven is',
        thisScheduleConflictsWithAnotherScheduleForWhichYouAreRegistered:
            'Dit rooster conflicteert met een ander rooster waarvoor u ingeschreven bent',
        thisScheduleCannotBeEditedBecauseItIsInTheFuture:
            'Dit rooster kan niet bewerkt worden omdat het in de toekomst is',
        time: 'Tijd',
        timeslotsToDeleteWarning: 'Let op! Deze reserveringen worden verwijderd:',
        Title: 'Titel',
        to: 'Aan',
        today: 'Vandaag',
        todolist: 'Todolist',
        tool: 'Hulpmiddel',
        toolDeleted: 'Hulpmiddel verwijderd',
        tools: 'Hulpmiddelen',
        Tooltip: 'Tooltip',
        toPlannings: 'Toon planning',
        total: 'Totaal',
        totalAfterANumber: 'totaal',
        totalNumberOfEvaluations: 'Totaal aantal evaluaties',
        TotalNumberOfHours: 'Totaal aantal uur',
        totalResultsFound: 'Totaal gevonden resultaten',
        training: 'Training',
        trainingDeleted: 'Training verwijderd',
        trainingInformation: 'Opleidingsinformatie',
        trainingonthejob: 'Training on the job',
        trainingsStarted: 'gestart',
        trainingType: 'Type opleiding',
        transferEnrollment: 'Overschrijven',
        transferInsufficientRights: 'Je hebt niet genoeg rechten om over te schrijven',
        true: 'ja',
        toj: 'Training on the job',
        trainings: 'Opleidingen',
        translate: 'Vertalen',
        types: 'Typen',
        'type.all': 'Alles',
        'type.skill': 'Toegewezen als bekwaamheid',
        'type.learningPath': 'Gepubliceerd in catalogus',
        'type.both': 'Beide',
        'type.none': 'Geen',
        Uncouple: 'Ontkoppelen',
        UncoupleEmployee: 'Medewerker ontkoppelen',
        Underline: 'Onderstrepen',
        underlyingDepartments: 'Onderliggende afdelingen',
        Undo: 'Ongedaan maken',
        unenroll: 'uitschrijven',
        unenrollment: 'Uitschrijfbevestiging',
        unenrollmentDeadline: 'Uitschrijftermijn',
        unenrollmentDeadlineInDays: 'Uitschrijftermijn in dagen',
        'Unordered List': 'Opsommingsteken',
        units: {
            size: ['B', 'kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
        },
        uniqueUsers: 'Unieke gebruikers',
        unknown: 'Onbekend',
        Unknown: 'Onbekend',
        unKnownOn: 'Onbekend op',
        unlockAccount: 'Ontgrendel account',
        unregister: 'Uitschrijven',
        unRegisterInsufficientRights: 'Je hebt niet genoeg rechten om uit te schrijven.',
        unregisterOrTansferOptions: `{ option, select,
            myUnregister {Je kunt je niet uitschrijven omdat jouw presentie / resultaat al is verwerkt.}
            myTransfer {Je kunt je niet overschrijven omdat jouw presentie / resultaat al is verwerkt.}
            someoneElseUnregister {Deze medewerker kan niet worden uitgeschreven omdat de presentie / het resultaat al is verwerkt.}
            someoneElseTransfer {Deze medewerker kan niet worden overgeschreven omdat de presentie / het resultaat al is verwerkt.}
            other {{option}}
        }`,
        unRegisterPeriodExceeded: 'Het is niet meer mogelijk je uit te schrijven.',
        unRegisterPeriodExceededTitle: 'Uitschrijftermijn verstreken',
        unsupportedBrowserHeader: 'Verouderde browser',
        unsupportedBrowserMessage:
            'U gebruikt een browser die wij niet meer ondersteunen. Update uw browser voor een betere ervaring!',
        until: 'tot',
        untilTime: 'Tot en met',
        up: 'Omhoog',
        upcomingTrainings: 'Aankomende opleidingen',
        UpdateValidityForExistingAssignments:
            'Pas geldigheid ook aan voor eerdere gemaakte toewijzingen',
        upload: 'Upload',
        uploadAutomatically:
            'Bijlagen in de wachtrij worden automatisch geupload bij het opslaan van dit dossieritem.',
        uploadCertificateBackgroundImage1: 'Achtergrondafbeelding',
        uploadCertificateBackgroundImage2:
            'De afbeelding moet een afmeting van 1400 bij 1000 of 1000 bij 1400 pixels hebben.',
        uploading: {
            status: {
                connecting: 'Verbinden...',
                stalled: 'Vastgelopen.',
                processing: 'Bestand verwerken...',
                held: 'Wachten',
            },
        },
        uploadQuestion: 'Uploadvraag',
        uploadQuestionDescription: 'Beschrijving bij bestandsupload',
        uploadQuestionInfo: 'Gebruikers kunnen via een uploadknop een bestand toevoegen.',
        uploadQuestionNotUploaded: 'Er is geen bestand geüpload.',
        unregistered: 'Uitgeschreven',
        Unregistered: 'Uitgeschreven',
        unregisteredParticipants: 'Uitgeschreven deelnemers',
        updateAttendance: 'Presentie bijwerken',
        url: 'URL',
        URL: 'URL',
        usageReport: 'Gebruiksrapportage',
        'usageReport.subtitle': 'E-learnings & klassikale opleidingen',
        'usageReport.generate': 'Genereer rapportage',
        'usageReport.usageUniqueCoursesUsers':
            'Aantal unieke gebruikers dat zich heeft ingeschreven',
        'usageReport.usageUniqueUsers':
            'Aantal unieke gebruikers dat deze e-learning gestart heeft',
        'usageReport.activeUsersPeriod': 'Actieve gebruikers in geselecteerde periode',
        'usageReport.elearningDetails.user': 'Gebruiker',
        'usageReport.elearningDetails.searchUser': 'Gebruiker zoeken',
        'usageReport.elearningDetails.status': 'Status',
        'usageReport.info.usersStartedBetween': 'Gebruikers gestart tussen {selectedDates}',
        useCustomValue: 'Eigen waarde gebruiken',
        useDefault: 'Standaardwaarde',
        useExaminerFunctionality: 'Toetsfunctionaliteit gebruiken',
        UseOnlyDefaultTemplates: 'Gebruik standaardsjabloon voor alle communicatie',
        user: 'Gebruiker',
        'user.course.result.validUntil': 'Geldig tot',
        uservoiceIcon: 'Geef je verbetersuggestie door',
        userInfo: 'Gebruikers informatie',
        userGroupDeleted: 'Gebruiker/groep verwijderd',
        userProfile: 'Gebruikersprofiel',
        userManagement: 'Gebruikersbeheer',
        users: 'Gebruikers',
        vacantPlace: 'plek vrij',
        vacantPlacesAvailable: `{number, select,
         1 {1 plek vrij}
         other {{number} plekken vrij}
         }`,
        vacantPlaces: 'plekken vrij',
        valid: 'Geldig',
        validity: 'Geldigheid',
        validityMonths: '{number} maanden',
        validityPeriodInMonths: 'Geldigheidsduur in maanden',
        validityUpdated: 'Geldigheid aangepast',
        validUntil: 'Geldig tot',
        Version: 'Versie',
        version: 'versie',
        refresher: 'Vervolg',
        viewComment: 'Commentaar inzien',
        viewPlanning: 'Rooster bekijken',
        viewPreconditions: 'Bekijk randvoorwaarden',
        viewSkill: 'Bekijk bekwaamheid',
        viewTheClassActivitiesForWhichYouAreRegistered:
            'Bekijk de klassikale activiteiten waarvoor je bent ingeschreven',
        viewYourScheduledLessons: 'Bekijk jouw ingeroosterde lessen',
        virtualQueue: 'Interesselijst',
        visibility: 'Zichtbaarheid',
        visible: 'Zichtbaar',
        visibleFrom: 'Zichtbaar per {date}',
        visibleUntil: 'Zichtbaar tot {date}',
        week: 'Week',
        weekAbout: '{number} week',
        weekAgo: '{number} week geleden',
        weekOverview: 'Weekoverzicht',
        weekOverviewReport: 'Weekoverzicht rapport',
        weeks: 'Weken',
        weeksAbout: '{number} weken',
        weeksAgo: '{number} weken geleden',
        welcomeToTCGMinerva: 'Welkom bij de leeromgeving',
        whatAreYouSearchingFor: 'Waar ben je naar op zoek?',
        when: 'Wanneer',
        WhoDoYouWantToRegister: 'Inschrijven',
        width: 'Breedte',
        withdrawTheApplication: 'Aanvraag intrekken',
        WithCertificate: 'Met certificaat',
        WithoutCertificate: 'Zonder certificaat',
        workLearningMethods: 'Werk- & Leervormen',
        workLearningMethodsDisabled:
            'De werkvormen Dagstart, Reflectie in Beeld en Online Beeldsessie verdwijnen per 2 november. Daarna kunt u deze niet meer gebruiken. Vragen? Neem contact op met Support.',
        workPhone: 'Telefoon werk',
        writtentest: 'Schriftelijk',
        year: 'Jaar',
        years: 'Jaar',
        yearAbout: '{number} jaar',
        yearsAbout: '{number} jaren',
        yearAgo: '{number} jaar geleden',
        yearsAgo: '{number} jaren geleden',
        yes: 'Ja',
        youAreAlreadyRegistered: 'U bent al ingeschreven',
        youAreNotAuthorizedToViewThisInformation:
            'U bent niet bevoegd om deze informatie te bekijken.',
        youCurrentlyHaveNoLesson: 'Je hebt momenteel geen les',
        YouDoNotHaveAddedFavorites: 'Je hebt geen favorieten toegevoegd.',
        youHaveMadeChangesDoYouWantToContinueWithoutSavingIt:
            'U heeft wijzigen gemaakt. Wilt u doorgaan zonder deze op te slaan?',
        youHaveNoLessonInTheNextSelectedDays: 'U heeft geen les in de komende geselecteerde dagen',
        youMustAddRecipients: 'U moet ontvangers toevoegen',
        youMustUploadDocuments: 'U moet bewijsstukken bijvoegen',
        YourDepartments: 'Jouw afdelingen',
        YourFavoriteCourses: 'Uw favoriete cursussen',
        YouAreSignedInAsAndDoesNotHaveRightsOn:
            'Je bent ingelogd als {name} en hebt met dit account geen rechten om {portal} te betreden',
        youWillBeAssessedBy: 'Je wordt beoordeeld door',
        yourProgress: 'Jouw voortgang',
        viewYourProgress: 'Bekijk jouw voortgang',
        zipCode: 'Postcode',
        showChildDepartmentsWhenNotManager:
            'Toon ook onderliggende afdelingen aan managers van een bovenliggende afdeling',
        'ssoManagement.mainTitle': 'Gebruiker zoeken',
        'ssoManagement.pageInfo': 'SSO Beheer PageInfo',
        'ssoManagement.listHeading': 'SSO Lijst',
        'ssoManagement.addSsoUser': 'Nieuwe SSO gebruiker',
        'ssoManagement.updateSsoUser': 'SSO gebruiker bewerken',
        'ssoManagement.enableDisableLabel': 'Activeren/Deactiveren',
        'ssoManagement.lockedOut': 'Geblokkeerd',
        'ssoManagement.disabledSince': 'Gedeactiveerd per',

        'ssoManagement.logOnName': 'Gebruikersnaam',
        'ssoManagement.logOnAlias': 'Alias',
        'ssoManagement.displayName': 'Weergavenaam',
        'ssoManagement.description': 'Omschrijving',
        'ssoManagement.emailAddress': 'Email Adres',
        'ssoManagement.userPrincipalName': 'UPN',
        'ssoManagement.employeeId': 'Personeelsnummer',

        'ssoManagement.password': 'Wachtwoord',
        'ssoManagement.resetPassword': 'Reset Wachtwoord',

        'ssoManagement.filter.enabled': 'Geactiveerd',
        'ssoManagement.filter.disabled': 'Gedeactiveerd',
        'ssoManagement.filter.lockedOut': 'Geblokkeerd',

        'ssoManagement.tab.users': 'Gebruikers',
        'ssoManagement.tab.groups': 'Groepen',

        'ssoManagement.actions.changePassword': 'Wachtwoord wijzigen',
        'ssoManagement.actions.generatePassword': 'Wachtwoord Genereren',
        'ssoManagement.actions.sendResetLink': 'Reset link verzenden',
        'ssoManagement.actions.unlock': 'Deblokkeren',
        'ssoManagement.actions.enableDisable': `{ disabled, select,
            true {Activeren}
            false {Deactiveren}
            undefined {Deactiveren}
            other {{disabled}}
        }`,

        'ssoManagement.errors.mustBeUnique': `De gebruikers naam en alias moeten verschillend zijn!`,
        'ssoManagement.errors.alreadyInUse': `Deze gebruikersnaam is al in gebruik!`,
        'ssoManagement.errors.selectDomain': `Kies een domein!`,
        'ssoManagement.errors.upnAlreadyInUse': `Deze UPN is al in gebruik!`,
        'ssoManagement.errors.invalidCharacters': `Alleen letters, cijfers, punten (.), koppeltekens (-) en underscores (_) zijn toegestaan.`,

        'ssoGroupManagement.groupDetails': 'Groep details',
        'ssoGroupManagement.mainTitle': 'SSO Groep Beheer',
        'ssoGroupManagement.pageInfo': 'SSO Groep Beheer PageInfo',
        'ssoGroupManagement.listHeading': 'SSO Groep Lijst',
        'ssoGroupManagement.addSsoGroup': 'SSO Groep Aanmaken',
        'ssoGroupManagement.updateSsoGroup': 'SSO Groep Bewerken',
        'ssoGroupManagement.updateSsoGroupMembers': 'SSO Group Members Bewerken',
        'ssoGroupManagement.memberOf': 'Lid van',

        tags: 'Tags',
        labels: 'Labels',
        addLabel: 'Label toevoegen',
        noLabels: 'Geen Labels',

        Supplier: 'Eigenaar',

        supplierTags: 'Leverancier Tags',
        addTag: 'Tag toevoegen',
        noTags: 'Geen Tags',
        noWPL: 'Je bent nog niet aan een werk- of leervorm gekoppeld',

        'scormManagement.mainTitle': 'SCORM Beheer',
        'scormManagement.pageInfo': 'SCORM Beheer PageInfo',
        'scormManagement.listHeading': 'SCORM Lijst',
        'scormManagement.uploadScormPackage': 'Upload Scorm 1.2 (.zip) Pakket',

        'scormManagement.filter.zipped': 'Zipped',
        'scormManagement.filter.unzipped': 'Unzipped',

        'scormManagement.actions.upload': 'Uploaden',
        'scormManagement.actions.delete': 'Verwijderen',

        'learningPath.resetDialogTitle': 'Leerpad opnieuw maken?',
        'learningPath.resetDialogBody':
            'Weet je zeker dat je dit leerpad opnieuw wilt maken? <br/><br/>Bij een nieuwe poging wordt opnieuw gekeken naar de status van de onderliggende activiteiten. Activiteiten die verlopen(d) zijn of nog niet eerder gestart, moeten (opnieuw) afgerond worden om een resultaat op dit leerpad te halen.<br/><br/>Deze reset heeft geen invloed op eerder behaalde resultaten op dit leerpad.',
        'tcgLearningPlan.resetDialogTitle': 'E-learning opnieuw maken?',
        'tcgLearningPlan.resetDialogBody':
            'Weet je zeker dat je deze e-learning opnieuw wilt maken? <br/><br/>Je huidige voortgang gaat dan verloren.Het heeft geen invloed op eerder behaalde resultaten.',
        'tcgLearningPlan.somethingWentWrong': 'Er is helaas iets misgegaan',
        'tcgLearningPlan.retryProcessProgress': 'Probeer opnieuw om de voortgang te verwerken.',
        'tcgLearningPlan.resetIfNotWorking':
            'Lukt het niet? Reset dan de opleiding en begin opnieuw.',
        'tcgLearningPlan.handInDialogTitle': 'Inleveren?',
        'tcgLearningPlan.handInDialogText':
            'Weet u zeker dat u {title} wilt inleveren? Na inleveren kunt u geen wijzigingen meer aanbrengen!',
        'tcgLearningPlan.handIn': 'Inleveren',
        'tcgLearningPlan.skip': 'Overslaan',
        'tcgLearningPlan.completed': 'Afgerond',
        'tcgLearningPlan.open': 'Openen',
        'tcgLearningPlan.notAvailableYet': 'Nog niet beschikbaar',
    },
    en: {
        aboutToExpire: 'About to expire',
        absentOn: 'Absent on',
        accept: 'Accept',
        Accept: 'Accept',
        Accepted: 'Accepted',
        accessToEvaluationByTrainers: 'Access to evaluations by trainers',
        accessToEvaluationByTrainersSubtitle:
            'Trainers may view all evaluations, including those from each other’s sessions.',
        accreditation: 'Accreditation',
        'accreditation.status': `{status, select,
            accepted {Accepted by PE-Online}
            failed {Failed at PE-Online}
            badResponse {Bad response from PE-Online}
            error {Error at PE-Online}
            pending {Pending}
            notValid {Not valid}
            other {No status by PE-Online}
        }`,
        'accreditation.process': 'Process',
        'accreditation.processDate': 'Process date',
        'accreditation.processed': 'Processed',
        'accreditation.endDate': 'Completed op',
        'accreditation.info': 'Accreditation settings',
        'accreditation.setBySdb': 'Set by SDB',
        'accreditation.processSuccess': 'Accreditations haven been processed',
        'accreditation.saveFailed': 'Saving the accreditation settings failed. Please try again.',
        'accreditation.processTitle': 'Process accreditations',
        'accreditation.processText':
            'All the results of this course will be processed at once. This could take some time.',
        'accreditation.processDoYouWantToContinue': 'Do you want to continue processing?',
        accreditations: 'Accreditations',
        achieved: 'Achieved',
        AchievedResults: 'Achieved results',
        achievedOn: 'Achieved on',
        Achievement: 'Achievement',
        AchievementIsAboutToExpire: 'Your result expires soon!',
        AchievementIsExpired: 'Your result expired!',
        AchievementIsFailed: 'You have failed',
        AchievementIsMandatory: 'Your result is mandatory!',
        AchievementIsPassed: 'Your result completed / passed',
        achievementRead: 'I have read the manual/protocol',
        achievementStatus: `{status, select,
            aborted {Aborted}
            absent {Absent}
            canceled {Cancelled}
            completed {Completed}
            deleted {Deleted}
            expired {Expired}
            failed {Failed}
            faulted {Error}
            not_registered {Not registered}
            not_started {Not started}
            passed {Completed}
            started {Started}
            registered {Registered}
            unregistered {Unregistered}
            other {Unknown}
        }`,
        achievementStatusForUserCourseResults: `{status, select,
            aborted {Aborted}
            absent {Absent}
            canceled {Cancelled}
            completed {Completed}
            deleted {Deleted}
            expired {Completed (expired)}
            failed {Failed}
            faulted {Error}
            not_registered {Not registered}
            not_started {Not started}
            passed {Completed}
            started {Started}
            registered {Registered}
            unregistered {Unregistered}
            other {Unknown}
        }`,
        activate: 'Activate',
        ActivateELearning: '(De)activate e-learning',
        activatePackage: 'Activate package',
        active: 'Active',
        Active: 'Active',
        activities: 'Activities',
        activity: 'Activity',
        activityName: 'Activity name',
        add: 'Add',
        addAccreditation: 'Add accreditation',
        AddAFavoriteFirst: 'Reset the filter and choose your first favorite item!',
        addAnActivity: 'Add an activity',
        addAnswer: 'Add answer',
        addAssessment: 'Add assessment',
        addAssessors: 'Add users who you want to want to be able to assess other users',
        addAssets: 'Add assets',
        addAttachments: 'Add attachment(s)',
        addBlock: 'Add block',
        addCategory: 'Add category',
        addComment: 'Add comment',
        addCourse: 'Add classical course',
        addEmployee: 'Add employee',
        addExemption: 'Add exemption',
        addExternalCatalogItem: 'Add external content',
        addFiles: {
            one: 'Select file...',
            many: 'Select files...',
        },
        Additional: 'Additional',
        addMailTemplate: 'Add mail template',
        addForm: 'Add form',
        addGroup: 'Add group',
        addIndividuals: 'Add individuals',
        addNew: 'Add new',
        AddNewsItem: 'Add news item',
        addNewPrice: 'Add new price',
        addOption: 'Add option',
        addPlanners: 'Add users who you want to give planner permission to departments',
        addPlanning: 'Add planning',
        AddPortalGroup: 'Add department',
        addQuestion: 'Add question',
        address: 'Address',
        addressGroup: 'Address',
        addReservations: 'Add reservations',
        addReviewers: 'Add users who you want to give read only permission to departments',
        addSchedule: 'Add session',
        addTeacher: 'Add teacher',
        addSubcategory: 'Add subcategorie',
        AddTextAndPressEnter: 'Add a text and press ENTER',
        addTextField: 'Add text field',
        addTheorem: 'Add theorem',
        addToVirtualQueue: `I''m interested in this training`,
        addToVirtualQueueDialogHeader: 'Add to virtual queue?',
        addToVirtualQueueDialogMessage:
            'This will add you to the virtual queue for this training. Based on the amount of people showing interest in this training future sessions might be scheduled.',
        addTraining: 'Add training',
        addUser: 'Add user',
        addUsers: 'Add users',
        administration: 'Administration',
        administrators: 'Administrators',
        administratorsAdd: 'Add administrators',
        advancedFilters: 'Advanced filters',
        advised: 'Advised',
        agree: 'Agree',
        all: 'All',
        allCategories: 'All categories',
        allAssignmentsAreDeleted: 'All assignments are deleted',
        allMandatoryFieldsMustBeFilled: 'All mandatory fields must be filled',
        allReservationsDeleteWarning:
            'Warning! All the reservations related to this schedule will be deleted!',
        AlmostExpired: 'Almost Expired',
        allDepartmentsAndRolesDeleted: 'All departments & roles deleted',
        Allignment: 'Alignment',
        allowedToFollow: 'Allowed to follow',
        allowMandatoryAssignments: 'Mandatory assignments',
        allowMandatoryAssignmentsDescription:
            'Enable or disable mandatory assigning of catalogitems application-wide',
        allowMultipleAnswers: 'Allow multiple answers',
        allowOnlyYourOwnNames: 'Allow only your own names',
        allowQueue: 'Queue',
        AllowEnroll: 'Allow enroll',
        AllowUnenroll: 'Allow unenroll',
        allowVirtualQueue: 'Watchlist',
        'allowVirtualQueue.explainer': 'Users can express their interest if no courses are planned',
        allAssignmentTypes: 'All kinds of assignment',
        allTypes: 'All',
        always: 'Always',
        answerText: 'Answer text',
        'apiMessages.saved': 'Saved',
        'apiMessages.error': 'An error has occurred',
        applicationParts: 'Application parts',
        apply: 'Apply',
        appointment: 'appointment',
        appointmentAt: 'Appointment at',
        allPresent: 'All present',
        approved: 'Approved',
        approvedDate: 'Approved date',
        aProblemHasOccuredContactTheAdministrator:
            'A problem has occured. Contact the administrator',
        archive: 'Archive',
        AreYouSureYouWantToDeactivateThisPackage:
            'Are you sure you want to deactivate this package?',
        AreYouSureYouWantToDeleteThisPackage: 'Are you sure you want to delete this package?',
        areYouSureYouWantToDelete_what_: `Are you sure you want to delete {what, select,
            role {this role}
            other {''{what}''}
        }?`,
        areYouSureYouWantToDeleteAllAssignmentsForThisAssessor:
            'Are you sure you want to delete all assignments for this assessor?',
        areYouSureYouWantToDeleteThisAssessment: 'Are you sure you want to delete this assessment?',
        areYouSureYouWantToDeleteThisBlock: 'Are you sure you want to delete this block',
        areYouSureYouWantToDeleteThisCategory: 'Are you sure you want to delete this category',
        areYouSureYouWantToDeleteThisComment: 'Are you sure you want to delete this comment?',
        areYouSureYouWantToDeleteThisConnection: 'Are you sure you want to delete this connection',
        areYouSureYouWantToDeleteThisCourse: 'Are you sure you want to delete this course?',
        areYouSureYouWantToDeleteTheseConnections:
            'Are you sure you want to delete these connections',
        areYouSureYouWantToDeleteThisForm: 'Are you sure you want to delete this form?',
        areYouSureYouWantToDeleteThisGroup: 'Are you sure you want to delete this group',
        areYouSureYouWantToDeleteThisIndividualSkill:
            'Are you sure you want to delete this individual skill',
        areYouSureYouWantToDeleteThisMessage: 'Are you sure you want to delete this message',
        areYouSureYouWantToDeleteThisQuestion: 'Are you sure you want to delete this question',
        areYouSureYouWantToDeleteThisSection: 'Are you sure you want to delete this section',
        areYouSureYouWantToDeleteThisSkill: 'Are you sure you want to delete this skill',
        areYouSureYouWantToDeleteThisTextField: 'Are you sure you want to delete this text field',
        areYouSureYouWantToPublishThisSkillToCatalog:
            'Are you sure you want to publish this skill ({name}) to the catalog?',
        areYouSureYouWantToUnassignEmployeeFromSkill:
            'Are you sure you want to unassign this employee ({userName}) from the skill ({skillName})?',
        areYouSureYouWantToUnsubscribe: 'Are you sure you want to unsubscribe ?',
        are_you_sure_you_want_to_delete_this_accreditation:
            'Are you sure you want to delete this accreditation?',
        are_you_sure_you_want_to_delete_this_location:
            'Are you sure you want to delete this location?',
        are_you_sure_you_want_to_delete_this_schedule:
            'Are you sure you want to delete this session?',
        are_you_sure_you_want_to_delete_this_tool: 'Are you sure you want to delete this tool?',
        are_you_sure_you_want_to_remove_this_user_from_list:
            'Are you sure you want to remove this user from the list?',
        areYouSureYouWantToUnregister: 'Are you sure you want to unregister?',
        areYouSureYouWantToUnregisterThisStudent:
            'Are you sure you want to unregister this student?',
        assessedOn: 'Assessment date',
        assessEmployees: 'Assess employees',
        assessment: 'Assessment',
        assessmentAppointments: 'Assessment appointments',
        assessmentName: 'Assessment form name',
        assessmentDescription: 'Assessment description',
        assessmentForm: 'Assessment form',
        assessmentsForms: 'Assessment forms',
        assessmentResult: 'Assessment result',
        assessments: 'Assessments',
        assessmentIncomplete: 'Assessment is incomplete',
        assessmentMustContainAtLeastOneSection: 'Assessment must contain at least one section',
        assessmentSectionsMustContainAtLeastOneQuestion:
            'Assessment sections must contain at least one question',
        assessmentQuestionMustHaveYesNoOptions: 'Question must have yes/no as options',
        assessor: 'Assessor',
        assessors: 'Assessors',
        assessorMoments: 'Assessment moments',
        assessorsManagement: 'Assessors management',
        assessorsView: 'Assessors view',
        assessorsViewManageAssignments: 'Manage assignments (outdated method)',
        assignment: 'Assignment',
        assignmentsNumber: 'Number of assignments',
        assignmentType: 'Assignment type',
        examinerWithName: 'Examiner: {name}',
        examinerAppointments: 'Examiner appointments',
        examinerAppointmentsOverview: 'List of examiner appointments',
        examinerFirstAvailableTimeSlot: 'First available timeslot',
        examinermanagement: 'Examiner management',
        examinerNoLocation: 'No location found!',
        assign: 'Assign',
        'assignMatrix.title': `{type, select,
            department {Entire department}
            group {User / group}
            user {User}
            function {Function}
            other {{type}}
        }`,
        'assignMatrix.department.explainer': 'Regardless of function',
        assignCatalogItems: 'Assign catalog items',
        assignCatalogItemsBulk: 'Which catalog items do you want to assign?',
        assignCatalogItemsBulkChooseDomain: 'Choose a domain',
        assignCatalogItemsBulkChooseFunctions: 'And to which functions?',
        assignCatalogItemsBulkMandatory: 'Make mandatory?',
        assignCatalogItemsBulkHowToAssign: 'How do you want to assign?',
        assignCatalogItemsBulkToDomainOrDepartment: 'To whom do you want to assign?',
        assignCatalogItemsBulkSelectAllFunctions: 'Select all functions',
        assignCatalogItemsBulkWithDepartments: 'To which departments do you want to assign?',
        assignCatalogItemTypes: 'What catalog item type do you want to assign?',
        assignCategoriesBulk: 'Which categories do you want to assign?',
        assignCategoriesChooseCatalogItemsType:
            'To which type of catalog item do you want to assign the categories?',
        assignCategoriesChooseCatalogItems:
            'To which catalog items do you want to assign the categories?',
        AssignCertificateToSelectedCatalogItems: 'Assign certificate to selected catalog items',
        assignDirectly: 'Assign directly',
        assigned: 'Assigned',
        assignedCoursesBlockTypes: `{status, select,
            notCompleted {Not completed / expired}
            expiring {Expires soon}
            completed {Completed}
            other {{status}}
        }`,
        assignedTrainings: 'Assigned trainings',
        assignIndividual: 'Assign individual',
        assignIndividuals: 'Assign individuals',
        assignManagers: 'Assign managers',
        assignments: 'Assignments',
        'assignmentSource.individual': 'Individual',
        'assignmentSource.department': 'Department {department}',
        'assignmentSource.allDepartments': 'All departments',
        'assignmentSource.departmentFunction': '{department} / {function}',
        'assignmentSource.function': 'Function {function}',
        'assignmentSource.allFunctions': 'All functions',
        'assignmentSource.parentDepartment': '{department} (incl. sub-departments)',
        'assignmentSource.parentDepartmentFunction':
            '{department} (incl. sub-departments) / {function}',
        'assignmentSource.domain': 'Domain {name}',
        'assignmentSource.ssoGroup': 'Group {name}',
        'assignmentSource.other': 'Other',
        'userAssignments.source': 'Source',
        'userAssignments.loadFailed': 'The assigned trainings could not be loaded.',
        'userAssignments.forbidden':
            'You are not allowed to see the assigned trainings of this user.',
        'userAssignments.sourceFilter': 'Source',
        'userAssignments.sourceFilter.individual': 'Individual',
        'userAssignments.sourceFilter.inherited': 'Inherited',
        'userAssignments.sourceFilter.department': 'Department',
        'userAssignments.sourceFilter.function': 'Function',
        'userAssignments.sourceFilter.domainOrGroup': 'Domain or group',
        assignedTo: 'Assigned to',
        assignedUsers: 'Assigned users',
        assignToDepartmentFunction: 'Assign to department / function',
        asSoonAsAPlaceBecomesAvailableTheNextParticipantWillBeRegisteredAutomatically:
            'When maximum participants is reached a user can enroll on a queue and will be enrolled automatically when a seat becomes available.',
        asSoonAsSpaceBecomesAvailableTheEntireQueueWillReceiveAnInvitation:
            'As soon as space becomes available, the entire queue will receive an invitation',
        at: 'at',
        atLeastOneAssignmentMustBeSelected: 'At least one assignment must be selected.',
        atLeastOneFunctionMustBeSelected: 'At least one function must be selected.',
        atLeastOneBlockMustAdded: 'At least one block must be added.',
        atLeastOneActivityMustAdded: `At least one item must be added to the block. In the case of Basic with Refresher, at least one activity must be added for both Basic and Refresher`,
        attachedCertificate: 'Attached certificate',
        attachments: 'Attachment(s)',
        attachedUsers: 'Attached employees',
        attendanceList: 'Attendance list',
        attendees: 'Attendees',
        askAuthorizationToManager:
            'Permission required to start this elearning, would you like to ask permission?',
        authorizationNeededByManager: 'Authorization needed by manager',
        authorizationRequest: `{ number, select,
            1 {Review a request}
            other {Review {number} requests}
        }`,
        AuthorizationRequest: 'Authorization request',
        AuthorizationRequests: 'Authorization requests',
        AvailableLabels: 'Available labels',
        AvailableVersions: 'Available versions',
        beginDate: 'Start date',
        beginTime: 'Start time',
        back: 'back',
        Back: 'Back',
        basic: 'Basic',
        belowYouSeeTheListWhereYouNeedToUpdateThePresence:
            'Below you see the list where you need to update the presence',
        belowYouSeeThePlanningOfTheLessonsForWhichYouAreRegistered:
            'Below you see the planning of the lessons for which you are registered',
        betaHeadline: 'Want to try out the new look & feel?',
        bhpStatusEnrolled: 'Enrolled',
        bhpStatusAchieved: 'Achieved on',
        bhpValidity: 'Validity',
        block: 'Block',
        blockName: 'Block name',
        Bold: 'Vet',
        both: 'Both',
        bulkAssignmentsSaved: 'Success, assignments processed',
        buy: 'Buy',
        by: 'By',
        calendar: 'Calendar',
        calculateSupportColors: 'Automatically calculate support colors',
        cancel: 'Cancel',
        cancelled: 'Cancelled',
        Cancelled: 'Cancelled',
        cancelPendingRequest: 'Would you like to revoke your pending request?',
        cancelSchedule: 'Cancel schedule',
        canTest: 'Can test',
        capacity: 'Capacity',
        capacityReached: 'Schedule is full',
        catalog: 'Catalog',
        catalogCategories: 'Catalog categories',
        'catalog.fab.course': 'Add course',
        'catalog.fab.elearning': '(De)activate elearning',
        'catalog.participants.heading.lastAction': 'Last action',
        'catalog.participants.filter.action': 'Action',
        'catalog.participants.filter.name': 'Filter on employee',
        'catalog.participants.filter.dateFrom': 'Date from',
        'catalog.participants.filter.dateUntil': 'Date until',
        'catalog.participants.heading.result': 'Result',
        'catalog.participants.heading.bestResult': 'Best result',
        'catalog.participants.heading.expirationDate': 'Expiration date',
        'catalog.participants.heading.currentStatus': 'Current status',
        'catalog.participants.heading.date': 'Date',
        catalogAssignmentWarning:
            'All selected catalog items will be assigned based on the choices made.',
        catalogAssignmentWarning2: 'This can only be undone manually.',
        CatalogInterests: 'Watchlist',
        CatalogInterestsDetails: 'Catalogitems on your watchlist',
        catalogItem: 'Catalog item',
        catalogItemCompleted: ' - last completed on: ',
        catalogItemAboutToExpire: 'Catalog item expires soon!',
        catalogItemExpired: 'Catalog item expired!',
        catalogItemMandatory: 'Catalog item is mandatory!',
        catalogItemPassed: 'Catalog item completed / passed',
        'catalogItem.status': `{status, select,
            disabled {[DISABLED]}
            deleted {[DELETED]}
            other {}
        }`,
        catalogItems: 'Catalog items',
        'catalogItem.replaces': 'This course replaces the following other courses',
        'catalogItem.replacedBy': 'This course is replaced by the following course',
        'catalogEdit.general': 'Catalogitem general',
        'catalogEdit.sdbPlanning': 'SDB Planning',
        'catalogEdit.sdbPlanningIntro':
            'These settings determine what the Learning Platform sends to SDB Planning.',
        'catalogItem.detail.header.resultsAndHistory': 'All results & history',
        'catalogItem.detail.assignedTo.explainer':
            'Shows all users that are currently assigned to this catalogitem including their status. If a user has no status, this user has not taken any action in the selected period.',
        'catalogItem.detail.participant.explainer':
            'Shows all results, regardless of whether user is linked to this catalogitem.',
        catalogOf: 'Catalog of',
        categories: 'Categories',
        categoriesAssignmentWarning:
            'All selected categories will be assigned based on the choices made.',
        categoriesNotFound: 'No available categories found',
        category: 'Category',
        categoryAdd: 'Add category',
        categoryDelete: 'Categorie delete',
        categoryDeleteWarning: 'Are you sure you want to delete this category?',
        categoryDeleted: 'Category deleted',
        categoryEdit: 'Edit category',
        categoryName: 'Category name',
        Center: 'Center',
        'cert-all': 'All',
        'cert-yes': 'All with certificate',
        'cert-no': 'All without certificate',
        certificate: 'Certificate',
        certificates: 'Certificates',
        certificateApply1: `The certificate ''{certificaat}'' `,
        certificateApply2: 'will be applied to {number} catalog item(s).',
        certificateAssign: 'Assign certificates',
        certificateDefinition: 'Certificate definition',
        certificateDefinitions: 'Certificates',
        certificateDefinitions2: 'Certificate definitions',
        certificateDeleteConfirm: 'Are you sure you want to remove this certificate definition?',
        certificateDeleteWarning: 'This definition is used {number} times in catalog items!',
        certificateHide: 'Hide items with certificate:',
        certificateLabelDeleteHeader: 'Delete selected label?',
        certificateLabelDelete: 'Do you want to delete this label?',
        certificateLabelNew: 'New empty label',
        certificateLabelUsername: 'Label: username',
        certificateLabelBirthdate: 'Label: birthdate',
        certificateLabelCoursename: 'Label: course name',
        certificateLabelResultdate: 'Label: result date',
        certificateLabelPoints: 'Label: score',
        certificateAccreditationCode: 'Label: accreditation code',
        certificateShow: 'Show items with certificate:',
        changeCategory: 'Change category',
        changeComment: 'Change comment',
        changed: 'changed',
        changeOrder: 'Change order',
        changePassword: 'Change password',
        changeProfile: 'Edit profile',
        changeYourPassword: 'Change your password',
        changeRegistration: 'Change registration',
        changeSsoAccount: 'Edit account',
        checkAppointments: 'Existing appointments are not deleted!',
        checkPortfolioItems:
            'You have been asked to check {number, plural, one {one dossier item} other {# dossier items}}',
        chosenDate: 'Chosen date',
        chosenTraining: 'Chosen training',
        chooseAnEvaluationForm: 'Choose an evaluation form',
        chooseAnExaminer: 'Choose an examiner',
        chooseATimeslot: 'Choose a timeslot',
        chooseASkillThatYouWantToLinkToThisDepartment:
            'Choose a skill that you want to link to this department.',
        chooseCertificate: 'Choose certificate',
        chooseDateAndRegion: 'Choose date and region',
        chooseDeleteToPreventThisUserFromReviewingAnySkill: `Choose ''DELETE'' to prevent this user from reviewing any skill.`,
        chooseFunctions: 'choose functions',
        chooseImportToMakeThisUsersAnAssessorForTheSameActivitiesAsAnotherUser: `Choose ''IMPORT'' to make this user an assessor for the same activities as another user.`,
        choosePortfolioDefinition: 'Choose a dossier item definition',
        ChooseWhichRolesYouWantToUncouple: 'Choose which roles you want to decouple',
        city: 'City',
        class: 'Class',
        classDeleted: 'Class deleted',
        classes: 'Classes',
        classical: 'Classical',
        Classical: 'Classical',
        classicalTheoryLesson: 'Classical theory lesson',
        classroom: 'Classical',
        Classroom: 'Classical',
        'classroom.conflictMessage.maxCapacityLowerThanMinCapacity':
            'Max capacity may not be lower than min capacity',
        'classroom.teacheroverviewfilter.all': 'All',
        'classroom.teacheroverviewfilter.active': 'Active',
        'classroom.teacheroverviewfilter.cancelled': 'Cancelled',
        ClassroomActivities: 'Classroom activities',
        ClassroomActivity: 'Classroom activity',
        ClassroomCancel: 'Cancel classical Lesson',
        ClassroomDequeue: 'Remove from queue',
        ClassroomEnroll: 'Enroll classical lesson',
        ClassroomEnqueue: 'Enrolll on queue',
        ClassroomExaminerActivity: 'Classroom and examiner activity',
        ClassroomUnenroll: 'Unenroll from classical lesson',
        classroomTraining: 'Classroom training',
        classroomTypes: 'Classroom',
        clear: 'Clear',
        ClearImage: 'Clear image',
        ClearList: 'Clear list',
        clickOnRegisterToRegisterYourself: `Click on ''ENROLL'' to register yourself.`,
        close: 'Close',
        closeDown: 'Close',
        closeRegistration: 'Close registration',
        code: 'code',
        Code: 'Code',
        combineSkillExams: 'Combine exams',
        colleague: 'Colleague',
        color: 'Color',
        comment: 'Comment',
        commentDate: 'Comment date',
        comments: 'Comments',
        communication: 'Communication',
        compatibility: 'Compatibility',
        complete: 'Complete',
        completeBefore: 'Complete before',
        completed: 'Completed',
        Completed: 'Completed',
        completedStatus: 'Completed',
        completionDate: 'Completion date',
        'components.acaDepartmentSearch.label': 'Navigate to department',
        composition: 'e-Learning',
        compulsory: 'Compulsory',
        compulsoryNumber: 'Compulsory number',
        confirm: 'Confirm',
        confirmDelete: `Are you sure you want to delete ''{name}''?`,
        ConfirmNewPassword: 'Confirm new password',
        ConfirmUnenroll: 'Are you sure you want to unenroll?',
        ConflictingEnrollmentFound: 'Conflicting enrollment found',
        ConflictingSchedule: 'Unable to create schedule due to conflict with existing schedule',
        connect: 'Connect',
        connected: 'Connected',
        connectFunctions: 'Connect roles',
        contactGroup: 'Contact',
        contactInformation: 'Contact information',
        contentEndDate: 'This course can no longer be started from: {date}!',
        contentExpired: 'This course is expired and can no longer be started!',
        contents: 'Contents',
        continue: 'Continue',
        continueLearning: 'Continue learning',
        course: 'Classical course',
        courseHasBeenReplaced: 'This course has been replaced with',
        CourseProvider: 'Course provider',
        courseResetTitle: 'User can reset progress:',
        courseResetAllow: 'Always',
        courseResetDeny: 'Never',
        courseResetDefault: 'Depending on global setting',
        'courseResultsHistory.deleteAchievementDialog.body':
            'Are you sure you want to delete this achievement?',
        'courseResultsHistory.deleteAchievementDialog.title': 'Delete achievement',
        'courseResultsHistory.result.success': 'Achievement successfully deleted',
        'courseResultsHistory.result.error': 'An error occurred',
        courses: 'Classical courses',
        courseSelected: 'course selected',
        Costs: 'Costs',
        created: 'Started',
        creationDate: 'Creation date',
        createdBy: 'Created by',
        createNewLearningPath: 'Create new learning path',
        createNewAssessment: 'Create new assessment',
        createNewForm: 'Create new form',
        current: 'Current',
        currentProgress: 'Current progress',
        currentRegistrations: 'Current registrations',
        CurrentPassword: 'Current password',
        currentStartDates: 'Current start dates',
        currentStatus: 'Current status',
        dashboard: 'Dashboard',
        'dashboard.widgets.adminnotification.title': 'Courses',
        'dashboard.widgets.adminnotification.subtitle': 'Monitor warnings for the coming 3 months',
        'dashboard.widgets.notification.title': 'My messages',
        'dashboard.widgets.notification.subtitle': 'View unread messages...',
        dashboardLinks: 'Dashboard links',
        dashboardTitle: 'Dashboard welcome text',
        dashboardTile: 'This text will appear in the top section of the dashboard',
        'dashboard.widget.hl.traject': 'Leertraject',
        'dashboard.widget.hl.community': 'Community',
        'dashboard.widget.hl.scan': 'Scan',
        'dashboard.widget.hl.box': 'Box',
        date: 'Date',
        dateAndInfo: 'Date & info',
        DateAndTime: 'Date & time',
        dateAscending: 'Date ascending',
        dateDescending: 'Date descending',
        dateIsNotKnown: 'Date is not known',
        dateOfAssessment: 'Date of assessment',
        dateOfBirth: 'Date of birth',
        dateOfExpiry: 'Date of expiry',
        dateShownInterest: 'Shown interest on',
        dateStatusFrom: 'Status date from:',
        dateStatusTill: 'Status date till:',
        dateToExpire: 'It will expire in {number} months',
        day: 'Day',
        dayAbout: '{number} day',
        dayAgo: '{number} day ago',
        dayClassroomTraining: 'day classroom training',
        dayParts: 'lessons',
        days: 'Days',
        daysAbout: '{number} day',
        daysAgo: '{number} days ago',
        Deactivate: 'Deactivate',
        DeactivatePackage: 'Deactivate package',
        definitionAvailable: 'Available',
        definitionReviewByTeacher: 'Review by teacher',
        definitionReviewByManager: 'Review by manager',
        definitionAcceptByTeacher: 'Accept by teacher',
        definitionAcceptByManager: 'Accept by manager',
        delete: 'Delete',
        delete_what_: `Delete {what, select,
            role {role}
            other {item}
        }`,
        deleteAnswer: 'Delete answer',
        deleteAllAssignments: 'Delete all assignments',
        deleteAllAssignmentsForThisExaminer: 'Delete all assignments for this examiner',
        deleteApprovalDate: 'Reset base approval date',
        deleteAssessment: 'Delete assessment',
        deleteAssessor: 'Delete assessor',
        deleteAssignments: 'Delete',
        deleteCategory: 'Delete category',
        deleted: 'Deleted',
        deletedBy: 'Deleted by',
        deleteForm: 'Delete form',
        deleteConfirmationForAssignmentForCatalogItem: `Are you sure you want to delete the assignment for ''{catalogItemName}''?`,
        deleteConfirmationForAllCatalogAssignments: `Are you sure you want to remove all assignments from this catalog item? This means that this catalog item is no longer assigned to any department, function, group or user. No user can find this catalog item in the catalog (excluding administrator)`,
        deleteConfirmationForAllDepartmentsAndRoles:
            'Are you sure you want to delete the assignment for all departments and roles?',
        deleteConfirmationForAssignmentForGroupAndFunction: `Are you sure you want to delete the assignment for department ''{groupName}'' and function ''{roleName}''?`,
        deleteConfirmationForAssignmentForGroups: `Are you sure you want to delete the assignment for department/class ''{groupName}''?`,
        deleteConfirmationForAssignmentForFunctions: `Are you sure you want to delete the assignment for function ''{roleName}''?`,
        deleteConfirmationForAssignmentForUsers: `Are you sure you want to delete the assignment for user/group ''{displayName}''?`,
        deleteConfirmationForAdmin: `Are you sure you want to remove the user/group ''{displayName}'' from administrators?`,
        deleteConfirmationForAssessors: `Are you sure you want to remove ''{displayName}'' as assessor?`,
        deleteConfirmationForDepartmentReviewers: `Are you sure you want to remove the user/group ''{displayName}'' from department reviewers?`,
        deleteConfirmationForPlanners: `Are you sure you want to remove the user/group ''{displayName}'' from planners?`,
        deleteConfirmationForResult: `Are you sure you want to recalculate the date of this baseline? Doing so may cause the baseline result to become invalid, as the underlying activities may have already expired.`,
        deleteBasicApprovalDate: `Are you sure you want to reset the basic approval date for ''{groupName}''?`,
        deleteDepartment: 'Delete department',
        deleteGroup: 'Delete group',
        DeleteNewsItem: `Are you sure you want to remove news item ''{newsItemTitle}''?`,
        deleteConfirmationForLink: `Are you sure you want to delete this link ''{link}'' ?`,
        deleteCourse: 'Delete course',
        deleteCourseImpossible: 'It is currently not possible to remove this course.',
        'deleteCourseImpossible.courseHasConnections': 'This course is assigned',
        'deleteCourseImpossible.courseHasEnrollees':
            'This course has enrollees (active or in archive).',
        'deleteCourseImpossible.courseHasPlannings':
            'This course has plannings (active or in archive)',
        'deleteCourseImpossible.courseAssignedToSkillAsActivity':
            'This course is assigned to the following skills:',
        deleteOption: 'Delete option',
        DeletePackage: 'Delete package',
        DeletePortalGroup: `Are you sure you want to remove department ''{portalGroupName}''?`,
        deletePortfolio: 'Are you sure you want to delete this portfolio item?',
        deletePortfolioDefinition: 'Are you sure you want to delete this portfolio definition?',
        deletePortfolioItem: 'Delete portfolio item?',
        deletePortfolioItemText: 'Are you sure you want to delete this portfolio item?',
        deletedPortfolioDefinition: 'Dossier definition deleted',
        deleteQuestion: 'Delete question',
        deleteSchedule: 'Delete session',
        deleteSection: 'Delete section',
        deleteSkill: 'Delete skill',
        deleteSkillAssignment: 'Delete skill assignment',
        deleteTextField: 'Delete text field',
        deleteMessage: 'Delete message',
        deleteUser: 'Delete user',
        department: 'Department',
        departmentDeleted: 'Department deleted',
        departmentRoleDeleted: 'Department/function deleted',
        departmentNoActiveMembers: 'The selected department has no (active) users',
        departmentFunction: 'Department / function',
        departments: 'Departments',
        'departmentSaveMessage.added': 'Department saved successfully',
        'departmentSaveMessage.deleted': 'Department deleted successfully',
        'departmentSaveMessage.conflict': 'A department with the same name exist already',
        'departmentSaveMessage.generalError': 'A problem has occured. Contact the administrator',
        departmentsSelectAll: 'Select all departments',
        departmentReviewers: 'Department reviewers',
        dequeue: 'Dequeue',
        description: 'Description',
        DirectLink: 'Direct link',
        disable: 'Disable',
        disabled: 'Disabled',
        disableAccount: 'Disable account',
        disabledAccount: 'Disabled account',
        disableUserAccountDialog: 'Disable account',
        disableUserAccountPerDate: 'Disable account per',
        disagree: 'Disagree',
        discard: 'Discard',
        discardChanges:
            'You have made changes and have not yet saved them. If you leave this screen now, the changes will be discarded. Do you want to discard changes?',
        discardChangesShort: 'Unsaved changes will be lost.',
        discardChangesTitle: 'Discard changes?',
        disconnectEmployee: 'Disconnect employee',
        disconnectFunctions: 'Disconnect functions',
        disconnectIndividual: 'Disconnect individual',
        displayFromDate: 'Display from',
        displayName: 'Full name',
        displayUntilDate: 'Display until',
        displaySettings: 'Display settings',
        documents: 'Documents',
        documentDeleted: 'Document deleted',
        documentAlwaysVisible: 'Document always visible',
        documenttype: 'Document',
        documentVisibleAfterRegistration: 'Document visible after enrollment',
        done: 'Done',
        DoNotShowThisVideoAnymore: 'Do not show this video anymore',
        DoubleTeacher: 'Double teacher',
        DoubleLocation: 'Double location',
        down: 'Down',
        download: 'Download',
        downloadCertificate: 'Download certificate',
        downloadCertificates: 'Download certificates',
        downloadCertificatesNoAttendance: 'No participants have attended',
        downloadAttendanceList: 'Download attendance list',
        downloadAttendanceListDescription:
            'Select the additional information you would like to add to the report',
        dragAndDrop: 'Drag and drop',
        duplicate: 'Duplicate',
        duplicateAssessor: 'Duplicate assessor',
        duplicateBlock: 'Duplicate block',
        duplicatePlanning: 'Duplicate planning',
        duplicateQuestion: 'Duplicate question',
        duplicateTextField: 'Duplicate text field',
        duration: 'Duration',
        'duration.start': 'Duration start date',
        'duration.end': 'Duration end date',
        edit: 'Edit',
        editAccreditation: 'Edit accreditation',
        editApprovalDate: 'Edit base approval date',
        editAssessment: 'Edit assessment',
        editBlockTitle: 'Edit block title',
        editCatalog: 'Edit catalog',
        editCatalogItem: 'Edit catalog item',
        editCategory: 'Edit category',
        editContent: 'Edit content',
        editCourse: 'Edit course',
        editEvaluationForm: 'Edit evaluation form',
        editForm: 'Edit form',
        editLearningPath: 'Edit learning path',
        editLink: 'Edit link',
        editLocation: 'Edit location',
        EditNewsItem: 'Edit news item',
        editOption: 'Edit option',
        editPlanning: 'Edit planning',
        EditPortalGroup: 'Edit department',
        editQuestion: 'Edit question',
        editSectionTitle: 'Edit section title',
        editSkill: 'Edit skill',
        editTool: 'Edit tool',
        elearningmanagement: 'E-learning management',
        elearning: 'E-learning',
        elearnings: 'E-learnings',
        elearningReset: 'Reset e-learning & learning path',
        enrollDepartmentUsers: 'Enroll department members',
        Error404: 'Error 404',
        email: 'E-mail',
        emailaddress: 'E-mail address',
        emailNotification: 'Email Notification',
        emailPrivate: 'Private email',
        emailWork: 'Work email',
        employee: 'Employee',
        employeeAndRoleAreMandatory: 'Employee and role are mandatory',
        employeeNumber: 'Employee number (username)',
        employees: 'Employees',
        enableAccount: 'Enable Account',
        end: 'End',
        endDate: 'End date',
        endTime: 'End time',
        enqueue: 'Enqueue',
        enroll: 'Enroll',
        enrollAnotherEmployeeAfterProcessing: 'Enroll another employee after processing',
        enrollEmployees: 'Enroll department employees',
        enrollment: 'Enrollment',
        enrollmentFailed: 'Enrollment not possible',
        enrollmentSucceeded: 'Enrollment succeeded',
        Enrollments: 'Enrollments',
        enrollmentDeadline: 'Enrollment Deadline',
        errorEnrolling:
            'Unfortunately, something went wrong. The registration was not processed. Please try again later.',
        enrollmentDeadlineInDays: 'Enrollment deadline in days',
        enrollReservationError: `{ status, select,
            NotExists {Reservationcode does not exist}
            Expired {Reservationcode is expired}
            AlreadyUsed {Reservationcode has already been used}
            AlreadyEnrolled {This person is already enrolled}
            NoValidSchedule {This planning is invalid or in the past}
            other {{status}}
        }`,
        enterReviews: 'Enter reviews',
        entire: 'Entire',
        errorDownloadingFile: 'Error downloading file! Message:',
        errorMessageText: 'Message',
        errorMessageTextHeadline: 'Global message',
        errorMessageTextSubtitle: 'Message shown in upper part of every page',
        errorMessageWarningTypeHeadline: 'Message type (color)',
        errorMessageWarningTypeSubtitle: 'Select the message type and color',
        'message.settings.warningType.label': 'Message type',
        'message.settings.warningType.error': 'Error / outage (red)',
        'message.settings.warningType.warning': 'Warning (orange)',
        'message.settings.warningType.success': 'Success (green)',
        'message.settings.warningType.inprogress': 'Neutral (blue)',
        errorNavigateToElearning: 'This e-learning cannot be started',
        evaluateTheCoursesThatYouHaveAccomplished:
            'Evaluate the courses that you have accomplished',
        evaluation: 'Evaluation',
        evaluationFormName: 'Evaluation form name',
        evaluations: 'Evaluations',
        evaluationForm: 'Evaluation Form',
        evaluationForms: 'Evaluation Forms',
        everyone: 'Everyone',
        everyoneVisible: 'Everyone visible',
        examUpdated: 'Test results updated',
        examiner: 'Examiner',
        Examiner_not_found_in_activity: 'Examiner was not registered for this activity',
        Examiner_region_description_address_required: 'Address is mandatory',
        ExaminerNotFoundInActivity: 'Examiner was not registered for this activity',
        examinerReview: 'Examiner review',
        examinerReviews: 'Examiner reviews',
        examiners: 'Examiners',
        examinersCannotBeUsed:
            'Assessors are appointed to this skill. Therefore it is not possible to activate the examiner functionality. Remove the assessors first.',
        examinersUserCanSelectTimeSlot: 'User can choose timeslot',
        examinersUserCanSelectExaminer: 'User can choose examiner',
        examinersUserCanCombineExams: 'User can combine exams',
        examinersStandardDurationTimeSlot: 'Default duration timeslot',
        examinersStandardDurationExam: 'Default exam time',
        examinersRegionLocation: 'Region / location',
        examinersRegionsLocations: 'Regions / locations',
        examinersAddRegionLocation: 'Add region / location',
        examinersDeleteRegionLocation: 'Delete region / location "{location}"?',
        examinersAddAvailability: 'Add availability',
        examinersEditAvailability: 'Edit availability',
        examinersAddSchedule: 'Add a schedule',
        examinersScheduleDetails: 'Activities on {date} - {timeslot}',
        examinersNoReservations: 'No reservations',
        examinersHasReservations: 'Has reservations',
        examinersDeleteCurrentSchedule: 'Delete current schedule?',
        examinersPlannedExams: 'Planned exams',
        examinersAvailability: 'Availability',
        examinerScheduleMandatoryStartEndDate: 'Enter a start and end date',
        examinerScheduleSameStartEndTime: 'Start time and end time cannot be the same',
        examinerScheduleStartEndDateNotTheSame: 'Start and end date have to be the same',
        endDateBeforeStartDateError: 'End date cannot be before start date',
        examinerScheduleNoRegion: 'Region is mandatory',
        examinerAvailableSpace:
            'You have appointments with extra room. Would you like to combine this appointment?',
        examinerValidResult:
            'You still have result that is valid until {date}. Continue planning a new appointment?',
        examinerCombineTest: 'combine appointment?',
        examinerCombineTestYes: 'Yes, combine appointment',
        examinerCombineTestNo: 'No, plan a new appointment',
        examinerDurationOfTheExam: 'Duration of the exam (minutes)',
        examinerNewAppointment: 'New appointment',
        examinerCombineToWhichAppointment: 'To which appointment would you like to add this one?',
        'examiner.appointment.activity': 'Combine activity: ',
        'examiner.appointment.combine': 'With the appointment below?',
        'examiner.appointment.examiner': 'Examiner: ',
        'examiner.appointment.dateTime': 'Date and time: ',
        'examiner.appointment.regionLocation': 'Region / location: ',
        examinerNoAppointmentsTitle: 'Planned appointments',
        examinerNoAppointmentsDescription: 'No planned appointments found',
        examinerDeleteAppointment: 'Delete appointment?',
        exceededRegistrationPeriod: 'It is no longer possible to enroll.',
        exceededUnRegistrationPeriod:
            'You want to unregister or transfer a participant but the un-register/transer period has been exceeded. "You can no longer un-register or transfer a participant. For more information contact the trainers."',
        exceededUnRegistrationPeriodSelf:
            'You want to unregister or to transfer your registration but the un-register/transer period has been exceeded. "You can no longer un-register. For more information contact the trainers."',
        exception: 'Exception',
        'exception.add': 'Add exception',
        'exception.remove': 'Remove exception',
        'exception.remove.areYouSure':
            'Are you sure you want to remove the exception for this training ({name})?',
        exceptions: 'Exceptions',
        exemption: 'Exemption',
        exemptionEdit: 'Grant exemption',
        exemptionExpired: 'Exemption expired',
        exemptionsHaveBeenGranted:
            'Exemptions have been granted. Please note, it may take a few minutes before this is visible in the competence passport',
        exemptionStatusDescription: `The skill is marked as 'completed' until the set date. This means that the employee does not have to take any action until this date.`,
        expertiseDeleted: 'Dossier deleted',
        expertiseTodoTasks: 'Tasks:',
        Expertises_authorize: 'Authorize dossier items',
        Expertises_review: 'Review dossier items',
        Expertises_updated_status: 'Dossier tasks updated',
        export: 'Export',
        exportContent: 'Export content',
        exportContentNothingToExport: 'There is nothing to export',
        exportCurrentState: 'Current status',
        exportFailed: 'Export failed',
        exportFailedTryAgain: 'Export failed, please try again',
        exportOptions: 'Export options',
        exportPDF: 'PDF export',
        exportSpecificPeriod: 'Specific period',
        exportSpecificPeriodWarning: `An export of a specific period only shows skills and activities achieved within the selected period. Employees who are competent, but achieved this in an earlier period, are not included in this export.`,
        exemptionUntil_date_: 'Exemption until {date}',
        exemptionValidTill: 'Exemption until',
        expertise: 'Dossieritem',
        expirationPeriod: 'Expiration period',
        ExpirationPeriod: 'Expiration period',
        existingAssignments: 'Existing assignments',
        individualAssignmentValidityInfo:
            'Validity in months for these employees. Can be changed per employee afterwards.',
        expirationDate: 'Expiration date',
        expirationDateEditInfo:
            'In the event of a change, the newly calculated expiration date is applied to all (already achieved) results after a few minutes.',
        expires: 'Expires',
        expiresOn: 'Expires on',
        expiresOn_date_: 'Expires on {date}',
        expired: 'Expired',
        expiredOn_date_: 'Expired on {date}',
        explanationOrquestion: 'Explanation / question',
        extendExpirationDate: 'Extend expiration date',
        ExternalRegistrationNumber: '{name} number',
        ExtraOptions: 'Extra options',
        ExternalCost: 'External cost',
        failed: 'Failed',
        Failed: 'Failed',
        FailedAlreadyRegistered: 'Already registered',
        FailedAlreadyRegisteredOnThisPlanning: 'The person is already registered on this planning.',
        FailedCapacityReachedPlanningIsFull:
            'It is not possible to register the person on this planning, because the planning is full.',
        FailedConflictingEnrollmentOnOtherCourse: 'Already registered on a different course.',
        FailedMaxNumRegistrationsReachedOnCourse:
            'It is not possible to register the person on this planning, because the max registration is reached on this course.',
        fileUploadRequired: 'File upload required',
        false: 'no',
        favoriteTrainings: 'Favorites',
        fullCatalog: 'Full catalog',
        FavoriteWidgetInfo: 'View your favorite catalog items',
        filterByDate: 'Filter by date',
        filterOnCatalogName: 'Filter on catalog name',
        filterOnCategory: 'Filter category',
        filterOnCategories: 'Filter on categories',
        filterOnCategoryOrSkill: 'Filter on category or skill',
        filterOnCluster: 'Filter cluster',
        filterOnDepartment: 'Filter on department',
        filterOnDepartmentName: 'Filter on department name',
        filterOnEmployee: 'Filter on employee',
        filterOnFunction: 'Filter on function',
        filterOnName: 'Filter on name',
        filterOnDescription: 'Filter on portfolio item name',
        filterOnSkill: 'Filter skill',
        filter: 'Filter',
        filters: 'Filters',
        findUnderlyingDepartment: 'Find underlying department',
        finished: 'finished',
        firstName: 'First name',
        fivePointLikertScale: '5-Point Likert Scale',
        Float: 'Float',
        font: 'Font',
        'forecastPlanningReport.available': 'Available seats',
        'forecastPlanningReport.forecast': 'Forecast',
        'forecastPlanningReport.training': 'Training',
        'forecastPlanningReport.isAlmostExpired': 'Almost expired',
        'forecastPlanningReport.isRed': 'Failed / expired',
        'forecastPlanningReport.months': `{ month, select,
            january {Januari}
            february {Februari}
            march {Maart}
            april {April}
            may {Mei}
            june {Juni}
            july {Juli}
            august {Augustus}
            september {September}
            october {Oktober}
            november {November}
            december {December}
            other {{month}}
        }`,
        'forecastPlanningReport.from': 'of',
        'forecastPlanningReport.disclaimer.reportInfo': 'Report explanation',
        'forecastPlanningReport.disclaimer.title':
            'This report shows a forecast of the number of required spots based on expiration dates and assignments:',
        'forecastPlanningReport.disclaimer.info': 'Column explanation',
        'forecastPlanningReport.disclaimer.training': 'Training',
        'forecastPlanningReport.disclaimer.trainingInfo':
            'Name of training. If there are not enough seats (compared to minimum), an orange bar will be shown.',
        'forecastPlanningReport.disclaimer.seats': 'Available seats',
        'forecastPlanningReport.disclaimer.seatsInfo':
            'The number of available seats (and the total capacity) for this training in this month.',
        'forecastPlanningReport.disclaimer.willExpire': 'Almost expired',
        'forecastPlanningReport.disclaimer.willExpireInfo':
            'Number of employees whose result for this training expires this month.',
        'forecastPlanningReport.disclaimer.minimum': 'Min.',
        'forecastPlanningReport.disclaimer.minimumInfo':
            'Number of employees for whom this training is mandatory with an expiring result (orange) this month.',
        'forecastPlanningReport.disclaimer.maximum': 'Max.',
        'forecastPlanningReport.disclaimer.maximumInfo':
            'Number of employees for whom this training is recommended or optional and who have an expiring result (orange) in this month.',
        'forecastPlanningReport.disclaimer.redCount': 'Not compliant / expired',
        'forecastPlanningReport.disclaimer.redCountInfo':
            'Current number of employees for whom this training is mandatory and who do not have a valid result (red).',
        'forecastPlanningReport.conclusion': `Please note: This is a forecast. The organization determines the final number of spots.`,
        forbidden: 'Access denied',
        forbiddenDepartment: 'You are not allowed to view this department.',
        forms: 'Forms',
        formName: 'Form name',
        formDescription: 'Form description',
        formIncomplete: 'Form is incomplete',
        formMustContainAtLeastOneSection: 'Form must contain at least one section',
        formSectionsMustContainAtLeastOneQuestion:
            'Form sections must contain at least one question',
        freeChoice: 'Free choice',
        freeSpace: 'Free space',
        from: 'from',
        fromMax: 'from max.',
        fromNow: 'From now',
        fromTime: 'From',
        Full: 'Full',
        fullProfile: 'Full profile',
        function: 'Function',
        functions: 'Functions',
        functionsManagement: 'Functions management',
        fromLeft: 'From left',
        fromTop: 'From top',
        future: 'Future',
        general: 'General',
        generateAndDownloadExportFile:
            'Generate and download an Excel file with all achieved e-learning and course results in the selected year.',
        generateAndDownloadExportFileTitle: 'E-learning & courses',
        generateAndDownloadExportFileLearningPaths:
            'Generate and download an Excel file with all achieved learning path results in the selected year.',
        generateAndDownloadExportFileLearningPathsTitle: 'Learning Paths',
        generateAndDownloadExportFileSkills:
            'Generate and download an Excel file with all achieved skills results in the selected year.',
        generateAndDownloadExportFileSkillsTitle: 'Skills',
        getContactIfQuestion: 'If you have any questions, please contact the administrator',
        giveManagersRightsToSubDepartments: 'Also give managers rights to sub-departments',
        getPwa: 'Install app',
        gotoCatalogitem: 'Open Catalogitem',
        gotoChildLevel: 'Goto underlying departments',
        gotoCommunity: 'Go to community',
        gotoReport: 'Open report',
        groupEnrollmentTitle:
            'Select the planning to enroll the employees of the selected department.',
        groupEnrollmentEmptyPlanning: 'No participants registered',
        group: 'Group',
        groupName: 'Group name',
        groups: 'Groups',
        HasTaggedRegistration: 'Has tagged registration',
        Headings: 'Headings',
        headingColor: 'Heading color',
        Hello: 'Hello',
        Help: 'Help',
        hideNoActionNotAssigned: 'Hide no action / not assigned',
        hideNotAssigned: 'Hide not assigned',
        hidden: 'Hidden',
        hlapps: 'Interactive components',
        'hlapps.back': 'Back to Interactive Components',
        'hlapps.back.mobile': 'Interactive Components',
        'hlapps.name': `{id, select,
            1 {Community}
            2 {Scan}
            12 {Box}
            13 {Strengths & Development points}
            17 {Learning Path}
            other {Werk- & Leervorm}
        }`,
        'hlapps.subtitle': `{id, select,
            1 {Meet each other online}
            2 {Make development visible}
            12 {Consult sources}
            13 {Go for personal growth}
            17 {View your course overview}
            other {''{id}''}
        }`,
        'hlapps.rib': 'Startup & Reflection',
        'hlapps.rib.sub': 'Share practical situations',
        'hlapps.obs': 'Online Video Session',
        'hlapps.obs.sub': 'Virtual dialogue',
        'hlapps.userman': 'User management',
        'hlapps.userman.sub': 'Who will participate?',
        'hlapps.productman': 'Product management',
        'hlapps.productman.sub': 'What will we use?',
        helpAndFeedback: 'Help and feedback',
        hereYouFindAnOverviewOfAllAvailableElearningTrainingsExpertiseItemsAndClassActivities:
            'On this page, you will find an overview of all available e-learning trainings, expertise items and class activities',
        hereYouFindAnOverviewOfAllAvailableDepartments:
            'On this page, you will find an overview of all available departments',
        hereYouFindAnOverviewOfAllAvailableFunctions: 'All available functions',
        hereYouFindAnOverviewOfAllAvailableTrainings:
            'On this page, you will find an overview of all available formal courses, e-learning and class activities.',
        hereYouFindAnOverviewOfTheDepartmentsWhereYouAreAManager:
            'On this page, you will find an overview of the departments where you are a manager',
        hereYouFindAnOverviewOfTheDepartmentsWhereYouWork:
            'On this page, you will find an overview of the departments where you work',
        hereBelowYouCanUpdateTheAttendanceOfTheParticipants:
            'Below this text, you can update the attendance of the participants.',
        hiddenAt: 'Hidden at {date}',
        hour: 'Hour',
        hourAbout: '{number} hour',
        hourAgo: '{number} hour ago',
        hours: 'Hours',
        hoursAbout: '{number} hours',
        hoursAgo: '{number} hours ago',
        hundredPercentVisibleInProportion: '100% visible, in proportion',
        hundredVisibleStretched: '100% visible, stretched',
        ifTheMaximumNumberOfParticipantsIsReachedRegistrationWillClose:
            'If the maximum number of participants is reached, registration will close',
        ignore: 'Ignore',
        ignoreChanges: 'Ignore changes?',
        insufficientRightsText: 'You have insufficient rights to view this page.',
        insufficientRightsTitle: 'Insufficient rights',
        Image: 'Image',
        'importmanagement.catalogItemResult': 'Catalog item result',
        'importmanagement.catalogItemResult.catalog.header':
            'Add directly a result for this catalog item to the portfolio of a desired employee.<br/><br/>Select the employee and set a result date.',
        'importmanagement.catalogItemResult.portfolio.header':
            'Add a result directly to the portfolio of {username}. Select the relevant catalog item and set a result date.',
        'importmanagement.catalogItemResult.portfolio.extraInfo':
            'After importing the result, you may need to refresh the page to display the imported result.',
        'importmanagement.classroomResults': 'Classroom results',
        'importmanagement.confirm.beware': 'ATTENTION!',
        'importmanagement.confirm.areYouSure': 'Are you sure you want to import the uploaded file?',
        'importmanagement.confirm.overwrite':
            'Existing data (e.g. with different expiration date) may be overwritten with this import.',
        'importmanagement.confirm.lost': 'This may result in the loss of results.',
        'importmanagement.confirm.noReturn': 'This cannot be undone!',
        'importmanagement.confirm.startImport': 'I am sure, start import',
        'importmanagement.details': 'Details',
        'importmanagement.disclaimer':
            'I take full responsibility for the imported data and all consequences of that import.',
        'importmanagement.dossierItems': 'Dossieritems',
        'importmanagement.downloadTemplate': 'Download template',
        'importmanagement.elearningResults': 'E-learning / Learning path results',
        'importmanagement.error': 'Error',
        'importmanagement.exemptions': 'Skills Exemptions',
        'importmanagement.importFailed': 'Import failed',
        'importmanagement.importSuccessful': 'Import successful',
        'importmanagement.fileImport': 'Import file',
        'importmanagement.fileUpload': 'Upload importfile (.csv)',
        'importmanagement.heading.date': 'Date',
        'importmanagement.heading.result': 'Result',
        'importmanagement.heading.type': 'Import type',
        'importmanagement.newImport': 'New import',
        'importmanagement.notImported': 'NOT imported',
        'importmanagement.optionsByTemplate': 'Options based on selected template',
        'importmanagement.portfolioItemResult': 'Portfolio item results',
        'importmanagement.provider': 'Provider',
        'importmanagement.publishDirectly': 'Publish the items directly in the catalog',
        'importmanagement.result': 'Import result',
        'importmanagement.selectProvider': 'Select provider',
        'importmanagement.selectTemplate': 'Select template',
        'importmanagement.skillOrLearningPathResult': 'Skill / learning path activity results',
        'importmanagement.skillActivityResults': 'Skill activity results',
        'importmanagement.template.catalogItemResult': 'Results for catalog item',
        'importmanagement.template.exemptions': 'Exemptions for skill',
        'importmanagement.template.noActivitiesToImportWarningMessage':
            'This skill does not include activities for which an import via this import route is possible',
        'importmanagement.template.numberOfActivitiesInTheReportInfoMessage':
            '{number} activity(ies) in this template',
        'importmanagement.template.portfolioItemResult': 'Results for portfolio item',
        'importmanagement.template.skillActivityResults':
            'Results for competency/learning path activities (excluding catalog items)',
        'importmanagement.template.skillActivityResultsWarningMessage':
            'This template contains all activities from the selected competency, except catalog items (these have their own import route via "Results for catalog item")',
        'importmanagement.whatDomain': 'In what domain do you want to import?',
        'importmanagement.whatToImport': 'What do you want to import?',

        'importmanagement.errorCode': `{error, select,
            ERR0 {Document structure is incorrect}
            ERR1 {non-existing users detected}
            ERR2 {non-existing skills detected}
            ERR3 {non-linked skills detected}
            ERR4 {academyInfo not found}
            ERR6 {non-existing catalog items detected}
            ERR7 {non-existing dossier definitions detected}
            ERR8 {completed with errors}
            ERR9 {unhandled exception}
            other {{error}}
        }`,

        'importmanagement.status': `{statusId, select,
            0 {Files uploaded}
            1 {Test in progess...}
            2 {Users exist}
            3 {Skills exist}
            4 {Skills assigned to users}
            5 {Import failed}
            6 {Import in progress...}
            7 {Import succeeded}
            8 {Imported with errors}
            other {{statusId}}
        }`,

        'importmanagement.type': `{typeId, select,
            0 {E-learning results}
            1 {Skills Exemptions}
            2 {Skill / learning path activity results}
            3 {Classroom}
            4 {Classroom results}
            5 {Portfolio item results}
            6 {LTI-items}
            other {{typeId}}
        }`,

        import: 'Import',
        imported: 'import',
        Inactive: 'Inactive',
        inapplicable: 'This skill does not apply',
        inapplicable2: 'Does not apply',
        includeChildDepartments: 'Incl sub depts.',
        includeAllSubdepartments: 'Include all sub departments',
        Indent: 'Indent',
        individual: 'Individual',
        individual2: 'Individual',
        inheritAssignments: 'Inherit assignments',
        inheritAssignmentsFromOtherUsers: 'Inherit assignments from other users',
        individuals: 'Individuals',
        information: 'Information',
        informationCancelPlanning:
            'Are you sure you want to cancel this schedule? You will need to unsubscribe or transfer participants from this schedule to another schedule.',
        informationForYou: 'More information for you',
        initials: 'Initials',
        inShort: 'In short',
        institution: 'Institution',
        Intake: 'Intake',
        InternalCost: 'Internal cost',
        introductionVideo: 'Introduction video SDB Leerplatform',
        invalidDate: 'Invalid date',
        invalidUrl: 'Invalid URL',
        isExemptFromPayment: 'Is exempt from payment',
        isGoingToExpire: 'Is going to expire',
        IsSkill: 'Assigned as skill',
        Italic: 'Italic',
        Justify: 'Justify',
        keepOpen: 'Keep open',
        copied: 'Copied',
        copy: 'Copy',
        copyAssignments: 'Copy assignments',
        copyAssignmentsToOtherUsers: 'Copy assignments to other users',
        copyNoun: 'Copy',
        country: 'Country',
        lastLoginDate: 'Last login date',
        lastName: 'Last name',
        lastNamePrefix: 'Prefix',
        lastResult: 'Last result',
        lastReviewDate: 'Last review date',
        lastSuccessfulMark: 'Last successful mark',
        learningpath: 'Learning path',
        LearningPath: 'Learning path',
        latestAction: 'Latest action',
        learningPath: 'Learning path',
        learningPaths: 'Learning paths',
        learningPathsAndSkills: 'Learning paths & skills',
        learningPathOrSkill: 'Learning path / Skill',
        learningPathProgressWarning:
            'This view shows the current progress per activity. Please note: the validity of the learning path is independent of this status. A learning path can remain "green" while underlying activities expire.',
        learningplan: 'E-learning',
        Learningplan: 'e-Learning',
        LearningPoints: 'Learning points',
        learningProgram: 'Learning program',
        learningplanTypes: 'eLearning',
        Left: 'Left',
        lesson: 'lesson',
        lessons: 'lessons',
        likert: 'Likert-scale',
        likertInfo:
            'Users can give their opinion on, for example, a statement via a Likert scale. This consists of 5 options, from "Disagree completely" to "Agree completely". Simply add multiple questions to create a group.',
        limitMaxNumberOfEnrollmentsPerParticipant:
            'Limit the number of enrollments per participant',
        Link: 'Link',
        linkMustBeginWith: 'Link must begin with http:// or https://',
        listOfInterestedUsers: 'Interested users',
        listOfInterestedUsersInCourse: 'Interesed users in course',
        location: 'Location',
        locationDeleted: 'Location deleted',
        locations: 'Locations',
        login: 'Login',
        loginSetting: 'Welcome the user to the login screen',
        loginDescription: 'This text can be set for each portal',
        mailLogOverview: 'E-mail logging',
        mailTemplates: 'Mail Templates',
        MailTemplateType: `{type, select,
            ClassroomEnqueue {Enrollment confirmation (Queue)}
            ClassroomDequeue {Unenrollment confirmation (Queue)}
            ClassroomEnroll {Enrollment confirmation}
            ClassroomUnenroll {Unenrollment confirmation}
            ClassroomTransfer {Transfer confirmation}
            ClassroomCancel {Cancel confirmation}
            ClassroomReminder {Reminder email}
            other {{type}}
        }`,
        makeAppointment: 'Click to make an appointment',
        makeAChoice: 'Make a choice',
        manageUsers: 'Manage users',
        managerGroups: 'groups',
        managersAreAllowedToAssignCatalogItems: 'Managers are allowed to assign catalog items',
        managersMayNotAssign: 'Managers may not assign',
        manageAssignments: 'Manage assignments',
        manageSkills: 'Manage skills',
        mandatory: 'Mandatory',
        mandatoryAndRecommendedTrainings: 'Mandatory and recommended trainings',
        mandatoryOrRecommended: 'Mandatory & recommended',
        mandatoryFieldsMustBeCompleted: 'Mandatory fields must be completed',
        mandatoryFrom: 'Mandatory from',
        mandatoryFromSkillExpiry: 'Only mandatory once the skill expires',
        mandatoryNotMandatory: 'Mandatory / not mandatory',
        mandatoryTrainings: 'Mandatory trainings',
        mandatoryTrainingsShort: 'Mand. trainings',
        MandatoryTrainingsSubtitle: `Don''t forget to start!`,
        manual: 'Manual',
        markAsRead: 'Mark as read',
        markAsUnread: 'Mark as unread',
        maxAmount: 'Maximum number',
        maxAttachmentFileSize: 'The total size for the files may not exceed 50 MB',
        maxCapacity: 'Maximum number of participants',
        maxCapacityMustBeHigherThanMinCapacity:
            'Maximum number is mandatory and must be higher than minimum number',
        maximum: 'maximum',
        maxNumberOfEnrollmentsPerParticipant: 'Max. enrollments per participant',
        maxNumberOfEnrollmentsPerParticipantIncorrect:
            'Value must be greater than 0 and at most 10',
        MaxNumberOfParticipantsReached: 'Max. number of participants reached',
        Message: 'Message',
        'message.header': `{ created, select,
            undefined {}
            other {{created} - }
        }{ sender, select,
            undefined {System message}
            other {{sender}}
        }{ autoGenerated, select,
            true { (sent automatically)}
            other {}
        }`,
        'message.to': `To: {recipients}`,
        'message.subjectElearningNotificationMessage': 'Course completed',
        'message.achievementMessagePassed': `''{identityDisplayName} ({identityLogOnName})'' has passed ''{catalogItemName}''`,
        'message.achievementMessageFinished': `''{identityDisplayName} ({identityLogOnName})'' has successfully completed ''{catalogItemName}''`,
        'message.assessorAppointmentMade': `An appointment was made for ''{studentDisplayName}'' on ''{dateTime}'' to assess the following activity: ''{activityDescription}''`,
        'message.assessorAppointmentRejected': `The assessment request for activity ''{activityDescription}'' on ''{dateTime}'' is rejected by ''{assessorDisplayName}''`,
        'message.assessorAppointmentRemoved': `The appointment for user ''{studentDisplayName}'' on ''{dateTime}'' for activity ''{activityDescription}'' has been removed`,
        'message.assessorAppointmentMadeSubject': `Assessment appointment created`,
        'message.assessorAppointmentRemovedSubject': 'Assessment appointment removed',
        'message.catalogAuthRequestPermissionSubjectLearningplan': `{studentDisplayName} has requested permission for elearning module ''{displayName}''.`,
        'message.catalogAuthRequestPermissionSubjectClassroom': `{studentDisplayName} has requested permission for the classical training module ''{displayName}'' which starts at {planningStart}.`,
        'message.catalogAuthRequestPermissionBody': `Go to the dashboard and click ''Authorization requests'' to process the request.`,
        'message.catalogAuthRequestBodyLearningPlanAccepted': `Your request for elearning ''{displayName}'' is accepted`,
        'message.catalogAuthRequestBodyLearningPlanAcceptedRemark': `Your request for elearning ''{displayName}'' is accepted. Your manager added the following remark: {managerRemark}`,
        'message.catalogAuthRequestBodyLearningPlanRejected': `Your request for elearning ''{displayName}'' is rejected.`,
        'message.catalogAuthRequestBodyLearningPlanRejectedRemark': `Your request for elearning ''{displayName}'' is rejected. Your manager added the following remark: {managerRemark}`,
        'message.catalogAuthRequestBodyLearningPlanDeleted': `Your request for elearning ''{displayName}'' is deleted.`,
        'message.catalogAuthRequestBodyLearningPlanDeletedRemark': `Your request for elearning ''{displayName}'' is deleted. Your manager added the following remark: {managerRemark}`,
        'message.catalogAuthRequestBodyLearningPlanUnknown': `Your request for elearning ''{displayName}'' is status unknown.`,
        'message.catalogAuthRequestBodyLearningPlanUnknownRemark': `Your request for elearning ''{displayName}'' is status unknown. Your manager added the following remark: {managerRemark}`,
        'message.catalogAuthRequestPermissionRevoked': `The user revoked the authorization request for ''{displayName}''.`,
        'message.catalogAuthRequestBodyClassroomAccepted': `Your request for classical training ''{displayName}'' which starts at {planningStart} is accepted.`,
        'message.catalogAuthRequestBodyClassroomAcceptedRemark': `Your request for classical training ''{displayName}'' which starts at {planningStart} is accepted. Your manager added the following remark: {managerRemark}`,
        'message.catalogAuthRequestBodyClassroomRejected': `Your request for classical training ''{displayName}'' which starts at {planningStart} is rejected`,
        'message.catalogAuthRequestBodyClassroomRejectedRemark': `Your request for classical training ''{displayName}'' which starts at {planningStart} is rejected. Your manager added the following remark: {managerRemark}`,
        'message.catalogAuthRequestBodyClassroomDeleted': `Your request for classical training ''{displayName}'' which starts at {planningStart} is deleted.`,
        'message.catalogAuthRequestBodyClassroomDeletedRemark': `Your request for classical training ''{displayName}'' which starts at {planningStart} is deleted. Your manager added the following remark: {managerRemark}`,
        'message.catalogAuthRequestBodyClassroomUnknown': `Your request for classical training ''{displayName}'' which starts at {planningStart} is status unknown.`,
        'message.catalogAuthRequestBodyClassroomUnknownRemark': `Your request for classical training ''{displayName}'' which starts at {planningStart} is status unknown. Your manager added the following remark: {managerRemark}`,
        'message.catalogAuthRequestPermissionAccepted': `Your request for ''{displayName}'' is accepted.`,
        'message.catalogAuthRequestPermissionRejected': `Your request for ''{displayName}'' is rejected.`,
        'message.catalogAuthRequestPermissionDeleted': `Your request for ''{displayName}'' is deleted.`,
        'message.catalogAuthRequestPermissionUnknown': `Your request for ''{displayName}'' is status unknown.`,
        'message.catalogAuthRequestBodyRevokedByUser': `User ''{studentDisplayName}'' revoked the authorization request for ''{displayName}''`,
        messageBodyIsRequired: 'Message body is required',
        messageSent: 'Message sent',
        'message.filterByMessage': 'Filter by message',
        'message.searchSubject': 'Search on subject',
        'message.filterByReceiver': 'Filter by receiver',
        'message.filterBySender': 'Filter by sender',
        'message.originalMessageInfo': 'On {date} {sender} wrote:',
        'message.new': 'Message to user',
        'message.newClass': 'Message to coursegroup',
        'message.newDepartment': 'Message to department',
        'message.Received': 'Received',
        'message.Sent': 'Sent',
        'message.Settings': 'Settings',
        'message.settings.sendEmailForInternalMessage': `{key, select,
            title {Forward message box to email}
            subtitle {Also send new messages in the message box to the email address}
            label {Forward}
            other {{key}}
        }`,
        'message.settings.sendSkillExpirationsMail': `{key, select,
            title {Activity email}
            subtitle {Send periodic email notifications about skills, learning paths and catalog items}
            label {Forward}
            other {{key}}
        }`,
        'message.settings.sendSummaryEmailTimeInterval': `{key, select,
            title {Email notifications for unread messages}
            subtitle {Send notifications about the number of unread messages per email}
            label {Frequency}
            other {{key}}
        }`,
        'message.settings.sendUnprocessedAttendanceTimeInterval': `{key, select,
            title {Unprocessed attendance lists email notifications (trainers)}
            subtitle {Send notifications about the number of unprocessed attendance lists per email}
            label {Frequency}
            other {{key}}
        }`,
        'message.settings.organisationDefault': 'Organization default',
        'message.settings.OnOffOptions': `{ option, select,
            on {On}
            off {Off}
            other {{option}}
        }`,
        'message.settings.IntervalOptions': `{ option, select,
            none {Never}
            daily {Daily}
            weekly {Weekly}
            biWeekly {Biweekly}
            monthly {Monthly}
            other {{option}}
        }`,
        'message.settings.admin.title': 'Message box settings',
        'message.settings.admin.description':
            'Set the default message box settings for all users. These settings will apply to all users, except for users who changed their personal settings in their own message box settings.',
        'message.settings.title': 'My messagebox settings',
        'message.settings.emailNotification.senderName': 'Email sender name',
        'message.settings.emailNotification.senderName.description':
            'Set a name that will be displayed as the sender of all emails (Default is "SDB Leerplatform")',
        'message.settings.emailNotification.name': 'Sender name',
        'message.skills.expirationNotification.subject': `Skills update`,
        'message.skills.expirationNotification.body': `Dear participant,\n
            { expired, select,
                0 {}
                other {At the moment {expired, select, 1 {1 skill has} other {{expired} skills have}} expired.}
            }
            { expiring, select,
                0 {}
                other {In the period up to {until}, {expiring} more {expiring, select, 1 {skill} other {skills}} will expire.}
            }
            { new, select,
                0 {}
                other {Since the last update, {new} {new, select, 1 {skill has} other {skills have}} been assigned to you.}
            }

            You can view your skills in your portfolio.
        `,
        mayBeRedoneAgain: 'May be redone again',
        media: 'Media',
        min0max100: 'Min. 0 and Max. 100',
        minAmount: 'Minimum number',
        minCapacity: 'Minimum number of participants',
        minCapacityMustBeLowerThanMaxCapacity:
            'Minimum number is mandatory and must be lower than maximum number',
        minMaxCapacity: 'Minimum/maximum participants',
        minuteAbout: '{number} minute',
        minuteAgo: '{number} minute ago',
        minutes: 'Minutes',
        minutesAbout: '{number} minutes',
        minutesAgo: '{number} minutes ago',
        mobilePhone: 'Mobile Phone',
        modifyEnrollment: 'Modify enrollment',
        'modules.accessmanagement.activatedRights': 'Activated rights',
        'modules.accessmanagement.applicationPart': 'Application part',
        'modules.accessManagement.descriptions': `{key, select,
            roles_and_rights {Roles and rights}
            roles_and_rights_manage_roles {Manage roles}
            roles_and_rights_manage_assignments {Manage assignments}
            classroom {Classroom}
            classroom_manage_courses {Manage courses}
            classroom_manage_schedules {Manage schedules}
            classroom_manage_enrollments {Manage enrollments}
            classroom_manage_presence {Manage presence}
            classroom_manage_evaluations {Manage evaluations}
            classroom_manage_plannings {Manage plannings}
            classroom_manage_reservations {Manage reservations}
            other {{key}}
        }`,
        'modules.accessmanagement.errors': `{error, select,
            duplicate_name {A role with this name already exists}
            no_name_provided {No rolename provided}
            other {An error has occured}
        }`,
        'modules.accessManagement.rights_count_': `Rights: {count}`,
        'modules.accessManagement.roleName': 'Rolename',
        'modules.admin.classroom.presence.NumberOfResults': 'Total number of results:',
        'modules.adminMenu.labels': `{label, select,
            settings {Settings}
            catalog {Catalog}
            categories {Categories}
            compositionmanagement {E-learning management}
            scormmanagement {Scorm management}
            elearningmanagement {E-learning management}
            evaluations {Evaluations}
            definities {Portfolio items}
            classroom {Classical}
            skills {Skills}
            certificates {Certificates}
            usermanagement {Usermanagement}
            examinermanagement {Examiner management}
            importmanagement {Import management}
            exportmanagement {Export management}
            maillogoverview {E-mail logging}
            other {{label}}
        }`,
        'modules.catalog.assign.description': 'Select how you want to assign the catalog item',
        'modules.catalog.assign.allDepartmentAndFunctionsAssignments':
            'All departments and functions assignments',
        'modules.catalog.assign.departmentAssignments': 'Department assignments',
        'modules.catalog.assign.departmentRoleAssignments':
            'Department / role combination assignments',
        'modules.catalog.assign.roleAssignments': 'Role assignments',
        'modules.catalog.assign.identityAssignments': 'Identity assignments',
        'modules.catalog.assign.domainAssignments': 'Domain assignments',
        'modules.catalog.assignmentType.description': `{value, select,
            departmentrole {The catalog item is assigned to all employees in specifically selected roles and departments.}
            department {The catalog item is assigned to all employees in these department(s), regardless of their role.}
            role {The catalog item is assigned to all employees in these role(s), regardless of the department they work in.}
            all {The catalog item is assigned to everyone who holds a role within a department.}
            user {The catalog item is assigned to specific user.}
            domains {The catalog item is assigned to all employees within the selected domain(s).}
            other {{value}}
        }`,
        'modules.catalog.assignmentType.value': `{value, select,
            departmentrole {Specific Department / Role combination}
            department {Department (regardless of role)}
            role {Role (regardless of department)}
            all {All departments & roles}
            user {Individual}
            domains {Domains}
            other {{value}}
        }`,
        'modules.catalog.authorizationStatus': `{status, select,
            pending {Request pending}
            rejected {Request denied}
            other {Ask permission}
        }`,
        'modules.catalog.course.authorization.noManagersNotPossibleToAuthorize':
            'No manager was found to submit the authorization request to.',
        'modules.catalog.course.ParticipantOverviewExportName': 'Participant overview',
        'modules.catalog.statusType': `{statusType, select,
            all {All}
            completed {Completed}
            notcompleted {Not completed}
            started {Started / Registered}
            other {{statusType}}
        }`,
        'modules.catalog.areYouSureYouWantToResetAll':
            'Are you sure you want to reset all progress of all users?',
        'modules.catalog.resetAll': 'Reset all progress',
        'modules.catalog.resetAllMessage':
            'This will reset the progress all users of all versions of this learningplan.',
        'modules.catalog.resetAllSuccess': 'All progress is reset',
        'modules.classroom.exportPresence': 'Download presence report',
        'modules.classroom.participants.resultValue': `{value, select,
            passed {Passed}
            failed {Failed}
            other {Not filled in}
        }`,
        'modules.classroom.presenceListFileNamePart': 'attendance list',
        'modules.classroom.presenceValue': `{value, select,
            all {All}
            present {Present}
            absent {Absent}
            other {Not filled in}
        }`,
        'modules.classroom.presenceAbsentValue.none': 'None',
        'modules.classroom.presenceAbsentValue.Absent': 'Absent',
        'modules.classroom.presenceAbsentValue.AbsentWithExcuse': 'Absent with excuse',
        'modules.classroom.presenceAbsentValue.AbsentWithoutExcuse': 'Absent without excuse',
        'modules.classroom.queueEnabledAndAuthorizationRequiredWarning': `The 'Authorization needed by manager' and 'Queue' options cannot be enabled at the same time.`,
        'modules.classroom.queueEnabledAndPlanningIntegrationWarning': `The 'Send training hours to SDB Planning' and 'Queue' options cannot be enabled at the same time.`,
        'modules.classroom.registrations': `Registered {enrollmentCount} — Max. {maxCapacity}`,
        'modules.classroom.resultReportFileNamePart': 'result report',
        'modules.classroom.upcomingplanninglist.details': `details`,
        'modules.classroom.upcomingplanninglist.unsubscribe': `unsubscribe`,
        'modules.classroomNotifications.enrollment.value': `{value, select,
            both {Confirmation e-mail and calendar invites}
            confirmation {Only confirmation e-mail}
            none {None}
            other {{value}}
        }`,
        'modules.classroomNotifications.sendConfirmation': 'Send confirmation:',
        'modules.classroomNotifications.teachersReceiveUnenrollNotifications':
            'Teachers receive notifications when users unenroll',
        'modules.classroomNotifications.unenrollNotificationsList':
            'The following users receive notifications when someone unenrolls from a classroom course',
        'modules.classroomNotifications.teacherNotifications': 'Notifications for teachers',
        'modules.department.assignmentType.value': `{value, select,
            department {Department (regardless of role)}
            role {Specific role in the department}
            individual {Individual}
            other {{value}}
        }`,
        'modules.department.level': 'Level',
        'modules.department.currentProgress': 'Current selection with progress',
        'modules.department.departmentName': 'Department name',
        'modules.department.numberOfEmployees': 'Number of staff',
        'modules.department.downLoadDepartmentsListReport': 'Download departments report',
        'modules.department.totalExport': 'Total export departments without progress',
        'modules.elearningmanagement.tabs': `{tab, select,
            lti {LTI 1.1}
            ltiadvantage {LTI 1.3}
            drafts {Compositions}
            os {Microlearnings}
            scorm {SCORM}
            youtube {YouTube}
            vimeo {Vimeo}
            other {{tab}}
        }`,
        'modules.maillog.EmailLogging': 'E-mail logging',
        'modules.maillog.EmailReceiver': 'E-mail receiver',
        'modules.maillog.events': `{event, select,
            Deferred {deferred}
            Bounce {delivery failed}
            Delivered {delivered}
            Dropped {not processed}
            Blocked {delivery blocked}
            other {{event}}
        }`,
        'modules.maillog.selectEvent': 'Select status',
        'modules.mailtemplates.deleteMailTemplate.title': 'Delete mailtemplate',
        'modules.mailtemplates.deleteMailTemplate.message': `Are you sure you want to delete this mailtemplate?
            After deletion, the default mailtemplate will be used again.`,
        'modules.mailtemplates.labels': `{label, select,
            cursist {[cursist]}
            opleiding {[opleiding]}
            planning {[planning]}
            start {[start]}
            eind {[eind]}
            locatie {[locatie]}
            docent {[docent]}
            roosteritems {[roosteritems]}
            roosteritems2 {{roosteritems}}
            other {{label}}
        }`,
        'modules.mailtemplates.labels.roosteritems.usage': 'This is used as',
        'modules.mailtemplates.labels.roosteritems.content':
            'roosteritems "Session [sessieNaam] with description [sessieOmschrijving]: from [start] till [eind] in [locatie] by [docent]."',
        'modules.mainMenu.labels': `{label, select,
            start {Start}
            catalog {Catalog}
            departments {Departments}
            skills {Skills}
            hlapps {Interactive components}
            myMinerva {Portfolio}
            search {Search}
            administration {Administration}
            other {{label}}
        }`,
        'modules.messages.markReadAllButton': `mark all as read`,
        'modules.packages.areYouSureYouWantToResetThisPackage':
            'Are you sure you want to reset this package?',
        'modules.packages.deletePackageMessage': `{numberOfParticipants, select,
    1 {There is currently {numberOfParticipants} user active in a learning plan from this package.}
    other {There are currently {numberOfParticipants} users active in a learning plan from this package.}
} If you delete this version, these learning plans will be reset.`,
        'modules.packages.sendMailToUsers': 'Send an e-mail to the users',
        'modules.packages.resetPackage': 'Reset package',
        'modules.packages.resetPackageMessage':
            'This package version has active workflows running. When resetting this package version these workflows will reset and the corresponding users will be sent a notification by e-mail.',
        'modules.reports.filename': `{ shortid, select,
                rJeCvDtQU {{department} - Overview courses - {date}}
                JOMB63Bg {{department} - Overview courses - {date}}
                BJvunt {{skillName} - Skills report - {date}}
                HypXvdb3Y {{skillName} - Skills report - {date}}
                BJ55OI8yB {Overview departments - {date}}
                ryig1muL {Overview departments - {date}}
                8ckLsHAlV {Overview departments - {date}}
                ByXnzmK7U {{departmentName} - Overview skills - {date}}
                rJETt6bQF {{departmentName} - Overview skills - {date}}
                rk8WuxqkS {{departmentName} - Overview members - {date}}
                Sy2YFJEQD {{departmentName} - Overview members - {date}}
                SygyTwlht {Skills report - {date}}
                r1K1tdg3t {Skills report - {date}}
                rkhUeslMq {Skills report - Total including department & function - {date}}
                3B6kKWccg {Skills report - History - {selectedUser} - {selectedDate}}
                e5tXcT9ns {Skills report - History - {selectedUser} - {selectedDate}}
                HMDwn6lX {Skills report - History - {selectedDate}}
                XiWMm2YEx {Skills report - History - {selectedDate}}
                Af1MbWQs3 {Skills report - History - {skillName} - {selectedDate}}
                LFTryvYyB {Skills report - History - {skillName} - {selectedDate}}
                RTzrTESs {skills passport - {nameUser} - {date}}
                Ax1lS9bO9 {skills passport - {nameUser} - {date}}
                Bk56ndo2I {Assigned trainings - {nameUser} - {date}}
                SkEMJXxpE {Results - {nameUser} - {date}}
                BJHAIQOB {Participants - {catalogItemName} - {date}}
                SyNfMGOmd {Participants - {catalogItemName} - {date}}
                Sk6F3QoI {Result report - {catalogItemName} - {date}}
                HkRoZWO {Result report - {catalogItemName} - {date}}
                ByHs3jRnS {Attendance list - {catalogItemName} - {sessionDate}}
                vhkxJeLKH {Week overview classical courses - {period}}
                hUw7gJKlO {Week overview classical courses - {period}}
                knXgMInu {{nameUser} - {skillName} - {date}}
                NM9SkSjW {Classroom presence - {date}}
                O8rHIenBK {History report - {customer}}
                NJq4r8R3J {{department} - Enrollments - {date}}
                GwjVxmq_q {{department} - Presence - {date}}
                other {{shortid}}
        }`,
        'modules.skills.achievedOn': 'Achieved on {date}',
        'modules.skills.activity.status': `{status, select,
            exemption {exemption}
            red {expired / not yet finalized}
            yellow {expires soon}
            green {completed}
            other {{status}}
        }`,
        'modules.skills.activityGroup.subtitle': `{groupType, select,
            compulsory {All compulsory}
            optional {Compulsory with option}
            recommended {Recommended}
            other {{groupType}}
        } - {activities} {activities, select,
            1 {activity}
            other {activities}
        } {groupType, select,
            optional {of which {required} required}
            other {}
        } {notApplicable, select,
            0 {}
            other {({notApplicable} disabled)}
        }`,
        'modules.skills.activityGroupType': `{type, select,
            standard {Standard}
            basicWithRefresher {Basic with refresher}
            other {{type}}
        }`,
        'modules.skills.activityLockedDialog.title': 'Not accessible yet',
        'modules.skills.activityLockedDialog.message':
            'This activity is not yet accessible. Complete the previous activities first.',
        'modules.skills.activityType': `{type, select,
            document {Documents (document, protocol, manual)}
            documenttype {Document}
            protocol {Protocol}
            manual {Manual}
            catalog {Catalog (learning path, e-learning, classroom course)}
            learningpath {Learning path}
            elearning {E-learning}
            classroom {Classroom course}
            assessment {Assessment (practical, written assessment, self assessment)}
            skillslabtraining {Skillslab assessment}
            trainingonthejob {Training on the job}
            classical {Classical assessment}
            writtentest {Written assessment}
            skillslabtest {Skillslab assessment}
            practical {Practical assessment}
            peerassessment {Peer assessment}
            selfassessment {Self assessment}
            expertiseActivity {Portfolio item}
            groupActivity {Sub block}
            other {{type}}
        }`,
        'modules.skills.activityCurrentStatus': `{ status, select,
            elearning_created { Started }
            classical_registered { Registered }
            classical_unregistered { Unregistered }
            other {}
        }`,
        'modules.skills.activityExpirationStatus': `{ status, select,
            achieved {Achieved}
            expires {Expires at {date}}
            never_expires {Never expires}
            exemption {Exemption untill {date}}
            effective_from {Complete before {date}}
            expired {Expired at {date}}
            other {}
        }`,
        'modules.skills.activityValidity.title': 'Validity period',
        'modules.skills.activityValidity.value': `{value, select,
            default {Default}
            custom {Custom}
            oneoff {Oneoff}
            other {{value}}
        }`,
        'modules.skills.activityValidity.months': `{ months, select,
            1 {Maand}
            other {Maanden}
        }`,
        'modules.skills.activityValidity.validityPeriodWarning':
            'Note: for a validity period of 3 months or shorter, the skill remains orange.',
        'modules.skills.assignToUser': 'Assign skills to {name}',
        'modules.skills.assignmentDialog.title': 'Select departments and roles',
        'modules.skills.assignmentDialog.noSelectionInfo':
            'Select at least one department and roles',
        'modules.skills.assignmentDialog.departments': `Departments`,
        'modules.skills.assignmentDialog.roles': `Roles`,
        'modules.skills.assignmentDialog.selected': `selected`,
        'modules.skills.assignmentName.header': 'Assignment',
        'modules.skills.bulkValidity.title': 'Change validity',
        'modules.skills.bulkValidity.description': 'Applies to the {count} selected assignments.',
        'modules.skills.assignmentType.header': 'Type of assignment',
        'modules.skills.assignmentType': `{ type, select,
            individual {Individual}
            department {Department}
            role {Role}
            departmentrole {Department | Role}
            all {All}
            everyone {Everyone in organization}
            other {}
        }`,
        'modules.skills.assignmentType.value': `{value, select,
            departmentrole {Specific Department / Role combination}
            department {Department (regardless of role)}
            role {Role (regardless of department)}
            all {All departments & roles}
            individual {Individual}
            everyone {Everyone in organization}
            other {{value}}
        }`,
        'modules.skills.assignmentType.toggleLabel': `{value, select,
            learningplan {All e-learnings}
            classroom {All classical courses}
            learningpath {All learning paths}
            all {All catalog items}
            other {{value}}
        }`,
        'modules.skills.assignmentType.description': `{value, select,
              departmentrole {The skill is assigned to all employees in specifically selected roles and departments.}
            department {The skill is assigned to all employees in these department(s), regardless of their role.}
            role {The skill is assigned to all employees in these role(s), regardless of the department they work in.}
            all {The skill is assigned to everyone who holds a role within a department.}
            individual {The skill is assigned to the selected employees, regardless of their department or role.}
            other {{value}}
        }`,
        'modules.skills.assignments.headline': `Number assigned: {assigned}, of which {notApplicable} not applicable`,
        'modules.skills.assignSkill': 'Assign skill',
        'modules.skills.basicWithRefresher': 'Basic - Refresher',
        'modules.skills.basicWithRefresher.basicValidity': 'Refresher activation date',
        'modules.skills.basicWithRefresherHelpMonths':
            'Determine when the refresher course will become active after initially completing the basic course.',
        'modules.skills.basicWithRefresher.basicOneOff': 'Basic course is one-off',
        'modules.skills.basicWithRefresher.basicOneOffHelp':
            'Turn on to determine that the basic course must be completed only once.',
        'modules.skills.basicWithRefresherHelpGracePeriod':
            'Determine how many extra months an employee gets to finalize the refresher activities before the base will become applicable again.',
        'modules.skills.basicWithRefresher.summaryTitle': 'Summary',
        'modules.skills.basicWithRefresher.summary': `After initially achieving the basic course, the refresher course becomes leading after {basicValidity}
        { basicValidity, select,
            1 {month}
            other {months}
        }.
        { gracePeriod, select,
            null {The basic course only has to be achieved once and therefore does not expire, regardless of whether the refresher course is achieved on time.}
            0 {If the refresher block is not achieved in time, the basic block will become applicable after {basicValidity}
            { basicValidity, select,
                1 {month}
                other {months}
            }. The employee does not have a grace period.}
            other {If the refresher block is not achieved in time, the basic block will become applicable again. The employee has {gracePeriod}
            { gracePeriod, select,
                1 {month}
                other {months}
            } extra months after the initial {basicValidity}
            { basicValidity, select,
                1 {month}
                other {months}
            }.}
        }`,

        'modules.skills.editor.assign': 'Assign',
        'modules.skills.editor.assign.description': 'Select how you want to assign the skill',
        'modules.skills.editor.general': 'General',
        'modules.skills.editor.content': 'Skill content',
        'modules.skills.editor.validity': 'Default validity',
        'modules.skills.editor.validity.description':
            'Default validity for all activities (a custom validity can be set per activity)',
        'modules.skills.editor.months': 'Months',
        'modules.skills.editor.moveActivities': 'Move activities',
        'modules.skills.editor.moveActivities.description':
            'Move activities to another block while keeping results',
        'modules.skills.editor.moveFrom': 'Move from',
        'modules.skills.editor.moveTo': 'Move to',
        'modules.skills.editor.assignRights': 'Rights',
        'modules.skills.editor.allCatalogItems': 'All catalog items',
        'modules.skills.editor.selectCatalogItems': 'Select catalog items',
        'modules.skills.editor.allDepartments': 'All departments',
        'modules.skills.editor.allRoles': 'All roles',
        'modules.skills.editor.allowedToCustomizeBlocks': 'Modify blocks and/or activities',
        'modules.skills.editor.allowedToCustomizeBlocksInfo':
            'Components of this skill can be modified when assigning.',
        'modules.skills.editor.allowedToExtendTheValidity': 'Also extend validity',
        'modules.skills.editor.allowedToExtendTheValidityInfo':
            'When assigning this skill, the default validity period can always be shortened. By enabling this setting, it can also be extended.',
        'modules.skills.editor.allowOwnerToModifyExemption': 'Self exemption',
        'modules.skills.editor.allowOwnerToModifyExemptionDiscontinuedInfo': `The 'Self exemption' option has been discontinued. Please use the 'Self assessment' activity instead. Note: if you disable this option, it cannot be re-enabled for this skill.`,
        'modules.skills.editor.activitiesAre': 'Activities are',
        'modules.skills.editor.persistOrder': 'Persist order',
        'modules.skills.editor.removeBlock': 'Remove block',
        'modules.skills.editor.selectActivities': 'Select activities',
        'modules.skills.editor.removeBlockCheck':
            'Are you sure you want to remove this block with all linked activities?',
        'modules.skills.editor.removeGroup': 'Remove sub block',
        'modules.skills.editor.removeGroupCheck':
            'Are you sure you want to remove this sub block with all linked activities?',
        'modules.skills.editor.selectDepartments': 'Select department(s)',
        'modules.skills.editor.selectAllCurrentDepartments': 'Select all current departments',
        'modules.skills.editor.allCurrentDepartmentsWarningMessage':
            'This selection will not automatically include new departments created in the future. To include them, please assign to "Function (regardless of department)".',
        'modules.skills.editor.selectDepartmentsWarning':
            'Attention! When selecting more than one department at the same time, assignments may be created for department/function combinations that do not (yet) exist.',
        'modules.skills.editor.selectIndividuals': 'Select individual(s)',
        'modules.skills.editor.selectRoles': 'Select role(s)',
        'modules.skills.editor.warningRecommended':
            'None of the activities in this block count towards completion',
        'modules.skills.editor.noBlockYet':
            'No block has been created yet. Please create a block first.',
        'modules.skills.editor.noActivityYet':
            'No activity has been created yet. Please create an activity first.',
        'modules.skills.editor.addActivity': 'Add activity',
        'modules.skills.editor.removeActivity': 'Remove activity',
        'modules.skills.editor.assessmentForm': 'Assessment form',
        'modules.skills.editor.examinerFunctionality': 'Examiner functionality',
        'modules.skills.editor.combineExams': 'Combine exams',
        'modules.skills.editor.examDuration': 'Exam duration (minutes)',
        'modules.skills.editor.advancedSettings': 'Advanced settings',
        'modules.skills.editor.advancedValidityInfo':
            'How long does the result of this activity count within this skill after the employee has completed the activity?',
        'modules.skills.editor.mandatory': 'Mandatory',
        'modules.skills.editor.mandatoryInfo': 'From when must an employee complete this activity?',
        'modules.skills.editor.mandatoryOption': `{option, select,
            now {Immediately}
            date {From a fixed date}
            expiry {Once the skill of the employee expires}
            other {{option}}
        }`,
        'modules.skills.editor.mandatoryOptionInfo': `{option, select,
            now {For all employees as soon as the skill is saved.}
            date {A specific date for all employees, for example when new policy takes effect per quarter.}
            expiry {Employees who are currently approved only need to complete this activity after their own expiration date. The moment therefore differs per employee.}
            other {}
        }`,
        'modules.skills.editor.mandatoryResultTitle': 'What employees experience',
        'modules.skills.editor.mandatoryResult.now':
            'All employees with this skill must complete the activity immediately.',
        'modules.skills.editor.mandatoryResult.date':
            'All employees with this skill must complete this activity before {date}. If they do not, their skill expires on {date}.',
        'modules.skills.editor.mandatoryResult.noDate':
            'Pick a date. Without a date the activity is mandatory immediately.',
        'modules.skills.editor.mandatoryResult.expiryApproved':
            'Approved employees: mandatory from the expiration date they have at the moment this skill is saved. If they renew afterwards, that date does not move.',
        'modules.skills.editor.mandatoryResult.expiryNotApproved':
            'Employees who are not approved: mandatory immediately.',
        'modules.skills.editor.mandatoryResult.expiryNeverExpires':
            'Employees whose skill never expires do not get the activity.',
        'modules.skills.editor.examinerFunctionalityInfo':
            'Employees register for an exam slot with an examiner.',
        'modules.skills.editor.useExaminerFunctionality':
            'Use examiner functionality for this activity',
        'modules.skills.editor.advancedChip': `{chip, select,
            validityDefault {Default validity}
            validityOneoff {Valid once}
            mandatoryNow {Mandatory immediately}
            mandatoryExpiry {Mandatory once skill expires}
            mandatoryDateMissing {Mandatory from: date missing}
            examinerOn {Examiner functionality on}
            examinerOff {No examiner functionality}
            other {{chip}}
        }`,
        'modules.skills.editor.advancedChipValidity': `Valid {months, plural,
            =1 {# month}
            other {# months}
        }`,
        'modules.skills.editor.advancedChipMandatoryFrom': 'Mandatory from {date}',
        'modules.skills.editor.advancedChipExamDuration': 'Exam slot {minutes} min',
        'modules.skills.editor.catalogitem': 'Catalog item',
        'modules.skills.editor.expertiseitem': 'Expertise item',
        'modules.skills.editor.numberOfAssessors': `{assessors, select,
            1 {1 assessor}
            other {{assessors} assessors}
        }`,
        'modules.skills.editor.gracePeriod': 'Grace Period',
        'modules.skills.editor.alsoShowRolesOutsideTheSelectedDepartments':
            'Also show roles outside the selected departments',
        'modules.skills.errors.errorOnSavingChanges':
            'Something went wrong while saving the changes',
        'modules.skills.errors.errorOnSavingSomeOfItems':
            'Something went wrong while saving some of the changes',
        'modules.skills.expirationInfo': `{date, select,
            null {{approved, select,
                true {Never expires}
                false {Not yet finalized}
                other {{approved}}
            }}
            other {{date}}
        }`,
        'modules.skills.groupType': `{groupType, select,
            compulsory {All compulsory}
            optional {Compulsory with option}
            recommended {Recommended}
            other {{value}}
        }`,
        'modules.skills.warningRecommendedUser':
            'Recommended, activities do not count towards completion',
        'modules.skills.historyReportDisclaimer':
            'In this overview, all skills demonstrated in the past are listed, regardless of whether they are still assigned at this moment.',
        'modules.skills.managerSettings.allowManageAssignments.headline': 'Assign skills',
        'modules.skills.managerSettings.allowManageAssignments.description':
            'Managers are allowed to assign skills',
        'modules.skills.managerSettings.assessmentByManagers.headline': 'Assess activities',
        'modules.skills.managerSettings.assessmentByManagers.description':
            'Select on what level managers can assess activities',
        'modules.skills.managerSettings.assessmentByManagers.options': 'Options',
        'modules.skills.managerSettings.assessmentByManagers.all': 'All employees',
        'modules.skills.managerSettings.assessmentByManagers.whereManager':
            'Only employees of own department',
        'modules.skills.messages.assignedToAllAvailableFunctions':
            'The skill is assigned to all available roles',
        'modules.skills.messages.errorCategoryNotEmpty':
            'The category still contains one or more skills',
        'modules.skills.modifySearchFilter': 'No assessors found matching your query...',
        'modules.skills.noLearningPathAssignmentsFound':
            '({userName}) has not started ({learningPathName}) yet.',
        'modules.skills.noSkillAssignmentsFound': '{userName} is not assigned to {skillName}.',
        'modules.skills.noExpirationDate': 'Not expiration date',
        'modules.skills.noLongerAssigned': 'no longer assigned',
        'modules.skills.noResults.noAssignments.title': 'Not assigned yet',
        'modules.skills.noResults.noAssignments.text': 'The skill is not assigned yet',
        'modules.skills.notApplicableReason': 'Not applicable reason',
        'modules.skills.resultDeletedOn': 'Result deleted on {date}',
        'modules.skills.resultValidUntil': 'Result valid until {date}',
        'modules.skills.requestAssessment': 'Request assessment',
        'modules.skills.requestAssessmentFor': 'Request assessment for',
        'modules.skills.revokedBy': `{ revokedBy, select,
            null {Revoked}
            other {Revoked by {revokedBy}}
        }`,
        'modules.skills.overallProgress.status': `{status, select,
            notApproved {Not approved / expired}
            expiring {Expires soon}
            approved {Approved / exemption}
            notApplicable {Not applicable}
            other {{status}}
        }`,
        'modules.skills.optionalBlockName': 'Block name',
        'modules.skills.subBlock': 'Sub block',
        'modules.skills.subBlockName': 'Sub block name',
        'modules.skills.overallProgress.title': 'Overall progress',
        'modules.skills.persistActivityOrder': 'Persist activity order',
        'modules.skills.persistActivityGroupOrder': 'Persist block order',
        'modules.skills.persistActivityGroupOrderInfo': 'Users can only open blocks in order',
        'modules.skills.selectReviewer': `{ current, select,
            null {Select an assessor from whom you'd like to request an assessment. }
            other {{current} is set as assessor. Choose another assessor or withdraw the application.}
        }`,
        'modules.skills.skillCard.assignmentInfo': `{assignment, select,
            individual {individual}
            other {{assignment}}
        }`,
        'modules.skills.settings.skillsMatrixToggleLabel': 'Matrix view',
        'modules.skills.status': `{status, select,
            grey {Not assigned}
            red {Not approved / expired}
            blue {In progress}
            orange {Expires soon}
            green {Approved / exemption}
            other {{Status}}
        }`,
        'modules.trainings.status': `{status, select,
            grey {No action / not assigned}
            red {Not approved / expired (mandatory)}
            blue {Enrolled / started}
            orange {Will expire}
            green {Completed}
            purple {Not approved / expired (recommended)}
            brown {Exception}
            other {{Status}}
        }`,
        'modules.uservoice.emailWarning': 'Missing email address',
        'modules.uservoice.noValidEmail':
            'A valid email address is missing in your profile. Please provide an email adres below to update your profile.',

        'modules.planningIntegration.always':
            'Enabled | Block when overlapping with an existing shift (Enrollment not possible)',
        'modules.planningIntegration.alwaysAllowOverlap':
            'Enabled | Write as registration-hours when overlapping with an existing shift (Training scheduled alongside the shift)',
        'modules.planningIntegration.cancelAndTransfer':
            'Canceling and transferring is not possible',
        'modules.planningIntegration.forCancelPlanning': 'For cancel planning',
        'modules.planningIntegration.forTransfer': 'For transfer',
        'modules.planningIntegration.functionalityCantBeUsedInCombination': ` "This functionality currently can't be used in combination with the integration
                    with SDB Planning"`,
        'modules.planningIntegration.planningCantBeCanced': `"This planning can't be canceled, first unenroll all users"`,
        'modules.planningIntegration.toggleText': 'Send training hours to SDB Planning',
        'modules.planningIntegration.text':
            'Determines whether the hours of a session are added to the shift of the employee.',
        'modules.planningIntegration.never':
            'Disabled | Hours only in SDB Learning Platform (Do not send to Planning)',
        'modules.planningIntegration.nominalDuty.toggleText': 'Send study load to SDB Planning',
        'modules.planningIntegration.nominalDuty.text':
            'Sends the study load of {minutes} minutes to SDB Planning as nominal hours.',
        'modules.planningIntegration.nominalDuty.noStudyLoad':
            'First enter the study load under Catalogitem general.',
        'modules.planningIntegration.nominalDutyActivityCode': 'Nominal hour code',
        'modules.planningIntegration.dropdownLabel': 'Planning contract',
        'modules.planningIntegration.qualificationSync.toggleText':
            'After completion, send the result as a qualification to SDB Planning',
        'modules.planningIntegration.qualificationSync.text':
            'The achieved result is sent to SDB Planning as a qualification every night.',
        'modules.planningIntegration.qualificationSync.turningOn':
            'Results are sent from the next nightly synchronisation onwards. Everything completed before then comes along once.',
        'modules.planningIntegration.qualificationSync.turningOff':
            'No further results will be sent. What is already in SDB Planning stays there.',

        month: 'Month',
        monthAbout: '{number} month',
        monthsAbout: '{number} months',
        monthAgo: '{number} month ago',
        monthsAgo: '{number} months ago',
        months: 'Months',
        multiChoice: 'Multiple choice',
        multiChoiceInfo: 'At least 2 answer options where only 1 answer can be chosen.',
        multiChoiceWithMultipleAnswersInfo:
            'At least 2 answer options where several answers can be chosen.',
        multipleEntries: 'Multiple entries',
        allCatalogItems: 'All catalog items',
        myDepartments: 'My departments',
        myMessages: 'My messages',
        myMessagesAndNotifications: 'My messages and notifications',
        myMinerva: 'Portfolio',
        myProgress: 'My progress',
        overallProgress: 'Overall progress',
        progressSummaryCompleted:
            'Good job: you’ve completed <b>{done}</b> of <b>{total}</b> items. Below, you can see what you still need to do. Good luck!',
        itemsLeftToDo: 'to do',
        mySelf: 'Myself',
        name: 'Name',
        nameBlock: 'Name block',
        nameActivity: 'Name activity',
        nameAscending: 'Name ascending',
        nameDescending: 'Name descending',
        nameGroup: 'Name',
        navigateToClassroom: 'Do you want to open the classroom page?',
        navigateToEnroll: 'Navigate to enroll page?',
        navigateToElearning: 'Do you want to open the e-learning page?',
        navigateToElearningPage: 'Click to open the e-learning page',
        navigateToFavorites: 'See your list with favorites.',
        neutral: 'Neutral',
        never: 'Never',
        NewAndConfirmPasswordsDoNotMatch: 'Passwords do not match',
        newDashboard: 'New dashboard',
        newDashboardDescription:
            'You are currently using the new dashboard. Turn this option off to return to the current dashboard.',
        newExternalCatalogItem: 'External Content',
        newestFirst: 'Newest first',
        newEvaluationForm: 'New evaluation form',
        newLink: 'New link',
        newLocation: 'New location',
        newMessage: 'New message',
        newParticipant: 'New participant',
        NewPassword: 'New password',
        newPlanning: 'Add planning',
        newsItems: 'News items',
        NewsItemsWidgetInfo: `Don''t miss anything that happens in your organisation`,
        newsMessage: 'News message',
        newTool: 'New tool',
        newVersion:
            'A new version of this application is available. Refresh to update to the latest version',
        next: 'next',
        nextSessionDateTime: 'Next session is on {date} at {time}',
        no: 'No',
        noAccreditationFoundTitle: 'No accreditations found',
        noAccreditationInfoFoundTitle: 'No accreditation settings',
        noAccreditationInfoFoundText:
            'There are no accreditation settings configured for this course',
        noAssignments: 'No assignments',
        noAssignmentFoundTitle: 'No assigned trainings found',
        noAssignmentFoundText: 'Assign a training',
        noCatalogItemsFoundTitle: 'No catalog items found',
        noCatalogItemsFoundText: 'Try changing the filter settings.',
        NoCatalogItemInterestsFoundText: 'You have not showed any interest in a catalog item yet',
        NoCatalogItemInterestsFoundTitle: 'No catalog item interests found',
        noCertificate: 'No certificate',
        noComment: 'No comment',
        noCompetencyPassportFound: 'No competency passport found',
        noCurrentClassroomActivities: 'There are no current classroom activities',
        noCoursesFoundTitle: 'No courses found',
        noDashBoardLinksTitle: 'No dashboard links yet',
        noDashBoardLinksText: 'There are no dashboard links yet. Add possibly a dashboard link.',
        noDeadline: 'No Deadline',
        noDefinitionFoundTitle: 'No definitions found',
        noDefinitionFoundText: 'Add a definition tool',
        noDepartmentsTitle: 'No departments found',
        noDepartmentsText: 'Try adjusting the filter settings.',
        noEmail: 'No e-mail',
        noEmployeesFound: 'No employees found',
        noEnrollmentsYet: 'No enrollments yet.',
        noEvaluationsFound: 'No evaluations found',
        noEvaluationFormReports: 'No evaluation reports were found',
        noExemption: 'No exemption',
        noExpertiseText: 'Gained experience or knowledge? Add it to your portfolio!',
        noExpertiseTitle: 'No dossier items',
        NoFavorites: 'No favorites',
        noFavoritesButNavigateToAdd:
            'No favorites yet. Go to the catalog and click on <3 to add favorites.',
        noExaminers: `There isn't yet an assessor that can be selected for this activity. For more information get in touch with the administrator.`,
        noHlApps: 'No Interactive components found',
        notAvailableAnymore: 'not available anymore',
        notification: 'Notification',
        notifications: 'Notifications',
        notifyUserAfterCompletion: 'After completion send notification to user',
        None: 'None',
        noLesson: 'No lesson',
        noLink: 'No link was supplied!',
        NoLocation: 'No location',
        NoLocationOrDoubleLocation: 'No location or the locatie is double planned',
        noLocationFoundTitle: 'No locations found',
        noLocationFoundText: 'Enter the name of a location in the search field.',
        noLocationSelected: 'No location selected.',
        noPublicHlApps: 'No public Work forms & Learning methods',
        noParticipantsCatalog: 'Start a search action from the filter panel on the right.',
        noPlannings: 'No schedules were found',
        noRelevantTrainingFoundText: 'No relevant training found in personal catalog',
        noEmployeesSelectedYet: 'No employees selected yet. Search by name above.',
        noReportDataFound: 'No report data found',
        noResultsFound: 'No results found',
        noResultsFoundTitle: 'No results found',
        noResultsFoundText: 'Try changing the filter settings',
        noRevocation: 'No revocation',
        noRolesExistForThisDepartment: 'No roles exist for this department',
        noSchedulesAddedYet: 'No sessions added yet.',
        noSchedules: 'You should add at least one session to the planning',
        noSeatsAvailable: 'There are no seats available at this moment.',
        noSkillsAndMandatoryAssigned: 'No skills or mandatory trainings assigned',
        noSsoGroupsFound: 'No sso groups found',
        notAchieved: 'Not achieved',
        notAssigned: 'Not assigned',
        NotAuthorized: 'Not authorized',
        notAvailable: 'na',
        NoTeacherOrDoubleTeacher: 'No teacher or a teacher is double planned',
        noteThisIsAMultiDayPlanningAllDaysWillBeCancelled:
            'Note: This is a multi-day planning. All days will be canceled.',
        noTrainingFoundTitle: 'No training found',
        noTrainingFoundText: 'Add a training or reset filters',
        noTrainingFoundTextAlt: 'No trainings found',
        notRequired: 'Not required',
        noEnrollmentsFound: 'No enrollments found',
        noEnrollmentsHeader: 'No enrollments',
        noEnrollmentsText: 'No problem, you can enroll through the catalog',
        notVisibleAnymore: 'Not visible anymore',
        notYetVisible: 'Not yet visible',
        notApproved: 'Not approved',
        notComplete: 'Not complete',
        notCompletedStatus: 'Not completed',
        NotEnoughParticipants: 'Not enough participants',
        notRead: 'Not read',
        noReviewers: 'No reviewer selected.',
        NoTeacher: 'No teacher',
        noTeachers: 'No teacher selected.',
        NotEnoughRightsForAccreditations:
            'You do not have enough rights to see these accreditations.',
        notEnrolledEnrollFirst: 'Not yet enrolled. Go to the catalog to enroll.',
        notKnown: 'Not known',
        notMandatory: 'May skip',
        notMandatoryOrRecommended: 'Assigned (Not required or recommended)',
        notOnAllPresent: 'not attended a meeting',
        NotOnAllPresentAndNotOnAllNotPresent: 'presence not fully filled in',
        notPassed: 'Failed',
        notRegistered: 'Not registered',
        NotSatisfied: 'Not satisfied',
        NotStarted: 'Not started',
        noPlanningsFoundTitle: 'No plannings found',
        noPlanningsFoundText: 'Try to adjust the filters.',
        noReservationsFoundTitle: 'No reservations found',
        notApplicableStatusDescription: `If enabled, the obligation of this skill is no longer applicable. This skill will then be hidden from the skill passport by default.`,
        noTool: 'No tool selected.',
        noToolFoundTitle: 'No tools found',
        noToolFoundText: 'Add a new tool',
        notSet: 'Not set',
        notVisible: 'Not visible',
        notYetDone: 'Not yet done',
        notYetFinalized: 'Not yet finalized',
        notYetKnown: 'Not yet known',
        notYetStarted: 'Not yet started',
        noUnrollNotificationsFoundTitle: 'No notifications found',
        noUsersFoundTitle: 'No users found',
        noUsersFoundText: 'Select the correct domain and enter the username',
        noTeachersFoundTitle: 'No teachers found',
        noTeachersFoundText: 'There are no teachers assigned',
        SkillsReportViewers: 'Skills report viewers',
        'skillsReportViewers.AllSkills': 'All skills',
        'skillsReportViewers.ConfigureSkillsReportViewers': 'Configure skills report viewers',
        'skillsReportViewers.ConfirmDeleteAllSkillsReportViewerAssignments':
            "Are you sure you want to remove ''{displayName}'' as a skills report viewer?",
        'skillsReportViewers.ConfirmDeleteSkillsReportViewerWithContextAssignment':
            "Are you sure you want to remove access to skill ''{context}'' for ''{displayName}''?",
        'skillsReportViewers.ConfirmDeleteSkillsReportViewerWithoutContextAssignment':
            "Are you sure you want to remove access to all skills for ''{displayName}''?",
        'skillsReportViewers.Explainer':
            'Skills report viewers have access to the skills report and insight into the progress of selected skills, both at department level and at individual level.',
        'skillsReportViewers.NoSkillsReportViewersFoundTitle': 'No skills report viewers found',
        'skillsReportViewers.NoSkillsReportViewersFoundText':
            'There are no skills report viewers assigned',
        'skillsReportViewers.SelectEmployee': 'Select employee',
        'skillsReportViewers.SelectSkillsReportViewer': 'Skills report viewer',
        'skillsReportViewers.SelectSkill': 'Skill',
        'skillsReportViewers.SelectSkills': 'Select skills',
        noWPL: `You haven''t been attached to WPL`,
        number: 'Number',
        numberApproved: 'Number approved',
        numberCatalogItems: 'Number catalog items',
        numberdays: 'Number of days',
        numberhours: 'Number of hours',
        numberminutes: 'Number of minutes',
        numberOfCompletedEvaluations: 'Number of completed forms',
        numberOfUnCompletedEvaluations: 'Number of uncompleted evaluations',
        numberOfPlacesAvailable: 'Number of places available',
        numberOfPoints: 'Number of points',
        numberOfPointsAchieved: 'Achieved points',
        numberOfRegisteredParticipants: 'Number of registered participants',
        numberOfReservations: 'Number of reservations',
        numberOfSelectedItems: 'number of items selected',
        numberOfSkills: '{numberOfSkills} skills',
        numberOfSkillsInTotal: '{numberOfSkills} skills in total',
        numberparticipants: 'Number of participants',
        numberrecipients: 'Number of recipients',
        ofAssessmentsCarriedOutByYou: 'of assessments carried out by you',
        off: 'Off',
        ofWhichMandatory: 'Of which mandatory',
        ok: 'OK',
        oldestFirst: 'Oldest first',
        oneOfTheScheduleIsNotFilledInWell: 'One of the sessions contains errors',
        on: 'On',
        On2: 'On',
        on2: 'on',
        onAllPresent: 'attended every meeting',
        one: 'one',
        onlyActiveAccounts: 'Only active accounts',
        onlyAssignableByAdmins: 'Only assignable by administrators',
        onlyAssignableByAdminsSkills: 'Skill only assignable by administrators',
        onlyAssignableByAdminsSkillsInfo:
            'This only applies to skills. Assignment limitations for learning paths can be set in the catalogitem.',
        onlyDisabledAccounts: 'Only disabled accounts',
        onlyWithSkills: 'Hide departments without skills',
        onlyWithWarnings: 'Only with warnings',
        onlyQualifiedAssessorsAllowed: 'You are not qualified to examinate this item',
        oops: 'Oops',
        open: 'Open',
        openApplications: 'Open applications',
        openCatalogItem: 'Open catalog item',
        openElearningDialogInFullscreenText: 'Open e-learning dialog fullscreen',
        openInANewWindow: 'Open in a new window',
        openQuestion: 'Open question',
        openQuestionInfo:
            'Users can enter a number of keywords via an open input field. No answer options are provided for this question.',
        openScormInNewWindow: 'Open SCORM package(s) in new window',
        openScormInNewWindowDetail: `When this catalog items contains SCORM packages, open them in a new window. Only use this when the opening in the same window doesn''t work, because opening in a new window might trigger popup blockers. This options does not do anything when there are no SCORM packages in the catalog item.`,
        openScormInNewWindowDontClose: `Content was opened in a new window. Don''t close this window/tab`,
        optional: 'Optional',
        options: 'Options',
        optionText: 'Option text',
        optionQuestion: 'Option question',
        order: 'Order',
        'Ordered List': 'Ordered List',
        orEnterAssessmentsByName: 'assess a colleague',
        Outdent: 'Outdent',
        overrideTheMasterDescription: 'Use custom text instead of the default description',
        overrideTheMasterSummary: 'Use custom text instead of the default summary',
        overview: 'Overview',
        ownName: 'Own name',
        Package: 'Package',
        PackagesActive: 'Packages active',
        PackagesInactive: 'Packages inactive',
        PageNotFound: 'The page could not be found...',
        pageIsUnavailableTitle: 'Page unavailable',
        pageIsUnavailable: 'This page is either unavailable or disabled.',
        payAttention: 'Pay attention',
        parentPortalGroup: 'Upper department',
        participant: 'Participant',
        participantAdded: 'Participant added',
        ParticipantEntersTheQueue: 'Participant  the queue',
        participantIsNotSelected: 'Participant is not selected',
        participantRegistered: 'participant registered',
        participants: 'Participants',
        participantsRegistered: 'participants registered',
        participantUnRegistered: 'Participant unregistered',
        passed: 'Passed',
        Passed: 'Passed',
        PassedAndExpired: `Passed but it''s expired`,
        past: 'Past',
        pathToImage: 'Path to image',
        paymentHeading: 'Payment',
        'pe.externalPersonId': 'PE-online Person ID',
        'pe.courseId': 'PE-online Course ID',
        'pe.editionId': 'PE-online Edition ID',
        'pe.moduleId': 'PE-online Module ID',
        'pe.organization': 'Professional body',
        'nonpe.code': 'Code',
        peerassessment: 'Peer assessment',
        peerAssessment: 'Peer assessment',
        percentageApproved: 'Percentage approved',
        'percentageApproved%': '% approved',
        period: 'Period',
        Periods: 'Periods',
        periodsInDays: 'Enrollment & Unenrollment deadline',
        permalink: 'Permalink',
        permissionRequestHasFailed: 'Permission request has failed',
        personalGroup: 'Personal',
        phasedOut: 'Phased out',
        phasedOutOn: 'Phased out on {date}',
        phasingOutOn: 'Phasing out on {date}',
        phaseout: 'Phase out',
        phaseOutBy: 'Phase out by {date}',
        phaseOutDate: 'Phase out date',
        phaseOutDateContent: 'not available from {date}',
        phaseOutDateContentSkills: 'Not available from {date}',
        phone: 'Phone',
        placeOfBirth: 'Place of birth',
        plannedActivities: 'Planned activities',
        plannedSessions: 'Planned sessions',
        planners: 'Planners',
        'planners.ConfirmDeletePlannerAssignmentWithContextAssignment':
            "Are you sure you want to remove access to catalog item ''{context}'' for ''{displayName}''?",
        planning: 'Planning',
        planningIsInPast: 'Planning is in the past',
        plannings: 'Plannings',
        planningInformation: 'Planning information',
        planningOverlap: 'There is overlap in your planning, please check your schedule',
        planningOverlapButton: 'Overlap in planning',
        planningOverlapFictitiousHours:
            'There is an overlap with your schedule in Planning. Where possible, training hours will be registered alongside your shifts after enrollment.',
        planningOverlapGeneral: 'There is an overlap in your planning, please check your schedule',
        planningErrorAbsenceOverlap:
            'Enrollment is not possible: the training overlaps with leave in your schedule. Please check your planning.',
        planningErrorUnknown:
            'The enrollment was rejected by the planning (code: {code}). Please contact the planning department or the administrator.',
        planningErrorRejected:
            'The enrollment was rejected by the planning. Please contact the planning department or the administrator.',
        planningErrorNotConfigured:
            'The planning integration is not configured for this portal. Please contact the administrator.',
        planningSelectContract: 'Select a valid contract!',
        pleaseChooseTheDesiredDateAndClickEnrollToRegisterForTheNewSchedule:
            'Please choose the desired date and click "Enroll" to register for the new planning',
        point_s: 'point',
        points: 'Points',
        points_s: 'points',
        portfolio: 'Portfolio',
        PortfolioDefinitions: 'Portfolio items',
        PortfolioInstance: 'Portfolio item',
        PortfolioTasks: 'Portfolio tasks',
        PortfolioTasksAuthorize: 'Portfolio tasks - authorize',
        PortfolioTasksName: 'Portfolio tasks name',
        PortfolioTasksReview: 'Portfolio tasks - review',
        PortfolioTasksAccept: 'Portfolio tasks - accept',
        PortfolioAccept: 'Accept',
        PortfolioReject: 'Reject',
        'portfolioTask.accepted': 'Accepted',
        'portfolioTask.rejected': 'Rejected',
        'portfolioTaskOptions.active.name': 'Portfolio Item is active',
        'portfolioTaskOptions.active.description': 'User can add a Portfolio Item of this type',
        'portfolioTaskOptions.fileUploadRequired.description':
            'User must attach supporting documents',
        'portfolioTaskOptions.multipleInstances.name': 'Multiple entries possible',
        'portfolioTaskOptions.multipleInstances.description':
            'User can add multiple Portfolio Items of this type',
        'portfolioTaskOptions.review.name': 'Review',
        'portfolioTaskOptions.review.description': 'Enable review option',
        'portfolioTaskOptions.reviewByManager.name': 'Manager',
        'portfolioTaskOptions.reviewByManager.description':
            'This type of Portfolio Item must be reviewed by a manager',
        'portfolioTaskOptions.reviewByAssignedUsers.name': 'Assigned users',
        'portfolioTaskOptions.reviewByAssignedUsers.description':
            'You have to assign users to review this Portfolio item',
        'portfolioTaskOptions.reviewBySkillReviewer.name': 'Assessors',
        'portfolioTaskOptions.reviewBySkillReviewer.description':
            'This Portfolio item will be reviewed by assessors (Admin -> Assessors)',
        PortfolioRemoveMarking: 'Reset',
        'portfolio.mandatory.heading.mandatoryTraining': 'Mandatory training',
        'portfolio.mandatory.heading.bestResult': 'Best result',
        'portfolio.mandatory.heading.certificate': 'Certificate',
        'portfolio.results.heading.course': 'Course',
        'portfolio.results.heading.lastAction': 'Last action',
        'portfolio.results.heading.bestResult': 'Best result',
        'portfolio.results.heading.certificate': 'Certificate',
        preference: 'Preference',
        presence: 'Presence',
        presenceProcessing: 'Presence processing',
        practical: 'Practical',
        presenceOfTheDaysBefore: 'Presence of the days before',
        presenceNotFullyUpdated: 'Presence not fully updated',
        present: 'Present',
        presentOn: 'Present on',
        presentParticipants: 'Present participants',
        previousElearning: 'Previous e-learning(s)',
        previousStep: 'Previous step',
        primaryBackgroundColor: 'Primary background color',
        primaryBackgroundColorDark: 'Primary dark background color',
        primaryBackgroundColorLight: 'Primary light background color',
        price: 'Price',
        Price: 'Price',
        Process: 'Process',
        PaymentValidity: 'Validity period (days)',
        Lumpsum: 'Centrally funded',
        PaymentInfo: 'Payment information',
        VATPercentage: 'VAT',
        DomainSpecificPrice: 'Domain Specific Prices',
        Platform: 'Platform',
        PlatformSettings: 'Platform settings',
        PortalSpecificPrice: 'Portalgroup Specific Prices',
        PlatformText: 'Platform text',
        profile: 'Profile',
        ProfileOf: 'Profile of',
        profileImage: 'Profile image',
        profileSaved: 'Profile saved',
        progress: 'Progress',
        protocol: 'Protocol',
        public: 'Public',
        publishedToCatalog: 'Published to catalog',
        publishToCatalog: 'Publish to catalog',
        question: 'Question',
        questionText: 'Question text',
        questionType: 'Question type',
        queue: 'Queue',
        queued: 'You are queued',
        Queued: 'Queued',
        QueuedAlreadyOnAPlanning: 'The person is already registered on queue of a planning.',
        queueThenAutomaticRegistration: 'Queue, then automatic registration',
        queueThenSendInvitation: 'Queue then send invitation',
        QueuedWhenFull: 'Queued when full',
        read: 'Read',
        readyForYou: 'Ready for you',
        readDocumenttype: 'Have you read the document?',
        readProtocol: 'Have you read the protocol?',
        readManual: 'Have you read the manual?',
        readless: 'Read less',
        readmore: 'Read more',
        reason: 'Reason',
        recalculate: 'recalculate',
        receivedMessages: 'Received messages',
        receivedOn: 'Received on',
        receiverDomain: 'Receiver domain',
        recipients: 'Recipients',
        recommended: 'Recommended',
        recommended_label: 'Recommended',
        redo: 'Redo',
        Redo: 'Redo',
        referenceDate: 'Reference date',
        refresh: 'Refresh',
        refreshThePage: 'Refresh the page',
        register: 'Register',
        registered: 'Registered',
        Registered: 'Registered',
        registeredBy: 'Registered by',
        registerFrom: 'On {date}',
        registeredOn: 'Registered on',
        registeredFrom: 'Registered from',
        registeredParticipants: 'Registered participants',
        registeredTill: 'Registered till',
        registerMe: 'Register me',
        registration: 'Registration',
        registrationClosed: 'Registration closed',
        registrationFailedTheAllowedNumberOfRegistrationsHasBeenReached:
            'Registration failed. The allowed number of registrations has been reached',
        registrationNumbers: 'Registration numbers',
        registrationNumbersSaved: 'Registration numbers saved',
        registrationPeriodHasExpired: 'Registration period has expired',
        registrationTransferPeriodExceededTitle: 'Transfer period expired',
        registrationTransferPeriodExceeded:
            'You want to transfer to another session but the transfer period of this session has expired.',
        'registrationNumbers.notAllowed': 'It is not possible to enter registration numbers.',
        relatedDocuments: 'Related documents',
        relatedDocumentsText:
            'By default these files are visible to anyone. If you want them to only be visible after someone enrolled into this course set the switch to enabled.',
        relevantCourses: 'Relevant courses',
        removedRole: '[removed role]',
        ReservationRevoked: 'Revoked',
        reservationCode: 'Reservation code (optional)',
        reservation: 'Reservation',
        reinstatedCancelledPlanning: 'Planning reinstated',
        reinstatePlanning: 'Reinstate planning',
        deleteCancelledPlanning: 'Planning deleted',
        RegionAlreadyExists: 'A region with this name already exists!',
        regionLocation: 'Region / location',
        Region_still_in_use: 'Region is used by a schedule, it cannot be deleted',
        reject: 'Reject',
        Rejected: 'Rejected',
        rejectedPortfolioItems:
            'You have {number, plural,  one {one rejected portfolio item} other {# rejected portfolio items}}',
        rejectRequest: 'Reject request',
        remarkUser: 'User remark:',
        removeAppointment:
            'You already have an appointment, do you want to cancel this appointment?',
        removeFunctionUserDepartment:
            'User {username} has the functions below in this department. If this user no longer has a certain function, then uncheck it.',
        removeFunctionUserDepartment2ndLine:
            'Please note, some functions are obtained by an automatic import and therefore cannot be changed.',
        removeAllUsersFromVirtualQueueHeader: 'Remove all users from watchlist?',
        removeAllUsersFromVirtualQueueMessage:
            'This action removes all shown interest for this catalogitem',
        removeFromList: 'Remove from list',
        removeFromVirtualQueue: 'Remove from watchlist',
        removeFromVirtualQueueDialogHeader: 'Remove yourself from watchlist?',
        removeFromVirtualQueueDialogMessage:
            'You will be removed from the watchlist of this catalogitem',
        removeFromVirtualQueueUserDialogHeader: 'Remove {displayName} from watchlist?',
        removeFromVirtualQueueUserDialogMessage:
            'This action will remove {displayName} from the watchlist of this catalogitem',
        removePlanningPermanently: 'Remove planning permanently?',
        replacement: 'Replacement',
        reply: 'Reply',
        reporting: 'Reporting',
        reports: 'Reports',
        'reports.department.mandatoryUsers.currentStatus': 'Current status',
        request: 'Request',
        requestRejectionConfirmation:
            'Are you sure you want to reject the assessment request of "{employeeName}" for activity "{activityName}"?',
        requests: 'Requests',
        required: 'Required',
        RequiredTrainingsWidgetInfo: 'Progress insight',
        'required and must be higher than zero': 'Required and must be higher than zero',
        requiredAndMustNotBeGreaterThan: 'Required and may not exceed {number} months',
        requiredAndMustNotBeGreaterThan1200: 'Required and may not exceed 1200 months',
        requiresTeacher: 'Requires teacher',
        'requiresTeacher.explainer':
            'A teacher must be scheduled for every session (of a planning)',
        reset: 'Reset',
        resetLearningPlan: 'Do again',
        resetProgress: 'Reset progress',
        revocation: 'Revocation',
        revocationEdit: 'Edit revocation',
        revocationDate: 'Revocation date',
        recovationAtDate: 'Revocation on {date}',
        revocationStatusDescription: `The status of all activities undertaken is ignored until the set date. This means that the employee must (again) complete the required activities after this date in order to demonstrate skill.`,
        revoked: 'Revoked',
        retry: 'Retry',
        remove: 'remove',
        RemoveCatalogInterestConfirm: `Are you sure you want to remove ''{displayName}'' as an interest?`,
        reregister: 'Register again',
        reservationCodeIsAlreadyUsed: 'The reservation code is already',
        reservationExpired: 'Expired',
        'reservation.status.revoked': 'The reservation code has been revoked',
        reservations: 'Reservations',
        reserved: 'Reserved',
        resetCourseTitle: 'Reset progress?',
        resetCourseFor:
            'It is possible to reset the progress of e-learning "{catalogName}" because it is about to expire, has already expired or because the e-learning has not been achieved by "{displayName}". All current progress of "{displayName}" will then be lost. It does not affect previous results.',
        resetCourseWarning: 'Are you sure you want to reset the progress of "{displayName}"?',
        resetFilter: 'reset filter',
        resetCatalogSettingHeader:
            'Reset e-Learning modules (this option can be overruled within the settings of a course)',
        resetCatalogSettingYes:
            'Allowed: participants are allowed to reset their progress of a course',
        resetCatalogSettingNo:
            'Not allowed: participants are not allowed to reset their progress of a course',
        resource: 'Resource',
        resources: 'Resources',
        resubmit: 'Resubmit',
        result: 'Result',
        resultDate: 'Result date',
        resultFinal: 'Final result',
        results: 'Results',
        resultsOf: 'Results of',
        resultUnknown: 'Result unknown',
        Review: 'Review',
        reviewer: 'Reviewer',
        reviewers: 'Reviewers',
        revoke: 'Revoke',
        revokeReservation: 'Revoke reservation',
        revokeConfirmation: 'Are you sure you want to revoke this reservation?',
        right: 'Right',
        Right: 'Right',
        Rights: 'Rights',
        RightsDescription: 'Other settings',
        Role: 'Role',
        roles: 'Roles',
        Satisfied: 'Satisfied',
        save: 'Save',
        saveAndContinue: 'Save and continue',
        saved: 'Saved',
        schedule: 'Session',
        scheduleDetail: 'Session details',
        scheduleDuration: 'Session duration',
        scheduleFull: 'Enrollment not possible, there are no open spots for this session',
        schedules: 'Sessions',
        scheduleMissesDuration: 'Session misses time duration',
        Schedule_not_found: 'Schedule not found!',
        schedulesOverlap: 'The sessions overlap',
        scheduleStartTimeEndTimeConflict: 'schedule start and end time conflict',
        scheduleTimeTooLong: 'Session duration too long',
        scorm: 'SCORM',
        seeAll: 'See all',
        'sdb/uriECD': 'Go to SDB ECD',
        'sdb/uriHr': 'Go to SDB HR',
        'sdb/uriPayroll': 'Go to SDB Payroll',
        'sdb/uriPlanning': 'Go to SDB Planning',
        'sdb-add-examiner-appointment-dialog.button': `{ button, select,
            previous_step {Previous step}
            schedule_new_appointment {Schedule new appointment}
            schedule_appointment {Schedule appointment}
            other {}
        }`,
        'sdb-add-examiner-appointment-dialog.errors': `{ error, select,
            no_time_slots_available {It is currently not possible to schedule an appointment because there are no time slots available.}
            time_slot_already_reserved {This appointment conflicts with another one. Go back and try a different time slot or day.}
            examiner_not_qualified {The examiner is currently not qualified and is therefore not allowed to assess this activity.}
            activity_already_present {There is already an appointment for this activity.}
            other {An unknown error has occured. [{error}]}
        }`,
        'sdb-add-examiner-appointment-dialog.headline': `{ step, select,
            1 {Combine appointment or create new appointment}
            2 {Choose date and location}
            3 {Appointment on { date_and_location }}
            4 {Plan appointment}
            other {}
        }`,
        'sdb-add-examiner-appointment-dialog.description': `{ step, select,
            1 {There is time available in a previously scheduled appointment. Choose an appointment below to combine the appointment or schedule a new appointment.}
            2 {Choose a date and location to schedule an appointment.}
            3 {Choose the desired time slot.}
            4 {Would you like to schedule the appointment below?}
            other {}
        }`,
        'sdb-continue-elearning-widget.widgetInfo': `Continue where you left off`,
        'sdb-time-slot-details.activities-to-assess': `{activities, select,
            1 {Activity to assess}
            other {Activities to assess}
        }`,
        selfassessment: 'Self assessment',
        sendMailMinimumParticipantsNotYetReached: 'Send an email over minimum participants',
        'sendMailMinimumParticipantsNotYetReached.explainer':
            'Send an email to the educator if the minimum number of participants is not reached',
        sendClassroomReminderMail: 'Send a reminder mail',
        'sendClassroomReminderMail.explainer':
            'Send an email to particpants before the course starts to remind them',
        sendClassroomReminderMailNumberOfDays: 'Days in advance',
        sendMailMinimumParticipantsNotYetReachedNumberOfDays: 'Days in advance',
        'settings.lookAndFeel': 'Look & Feel',
        'settings.lookAndFeel.uploadLogo': 'Upload logo',
        'settings.lookAndFeel.uploadHeroHeader': 'Upload header photo',
        'settings.lookAndFeel.heroheader': 'Show header photo on dashboard',
        'settings.lookAndFeel.heroheader.description':
            'Show a picture as visual introduction in the topsection of the dashboard',
        'settings.featurePreview.title': 'New (beta) features',
        'settings.featurePreview.setting': `{value, select,
            off {Off}
            admin {Administrators}
            everyone {Everyone}
            other {{value}}
        }`,
        setApprovalDate: 'Set basis date',
        setBy: 'Set by',
        setAutomatically: 'Automatically set',
        skillCategories: 'Skill categories',
        skillDeleted: 'Skill deleted',
        skillDetails: 'Skill details',
        skillsDeleted: 'Skills deleted',
        bulkAssignmentsPartiallyFailed:
            '{failed} of the {total} selected assignments could not be processed.',
        skillslabtraining: 'Skillslab',
        score: 'Score',
        search: 'Search',
        searchAClassroomTraining: 'Search for a classroom training',
        searchAssignments: 'Search assignments',
        searchByDate: 'Search by date',
        searchByLocation: 'Search  by location',
        searchByName: 'Search by name',
        searchByNameDepartmentOrJobTitle: 'Search by name, department or job title',
        searchByReceiverName: 'Search by receiver name',
        filterBySender: 'Filter by sender',
        searchBySenderName: 'Search by sender name',
        searchByTeacher: 'Search by teacher',
        searchAClassroomCourse: 'Search classroom course',
        searchDepartment: 'Search department',
        searchElearning: 'Search e-learning',
        searchForAMessageOrNotification: 'Search for a message / notification',
        searchForAUserWithSkills: 'Search for a user with skills',
        searchFunctions: 'Search functions',
        searchLocation: 'Search location',
        searchInFullCatalog: 'Search in the full catalog',
        searchInMyCatalog: 'Search in my catalog',
        searchOn: 'Search on',
        searchOnCatalogName: 'Search on catalog name',
        searchOnDepartmentName: 'Search by department name',
        searchOnEmployeeName: 'Search by employee name',
        searchOnRoleName: 'Search by role name',
        searchRecipients: 'Search recipients',
        searchRole: 'Search role',
        searchPackage: 'Search package',
        searchSkill: 'Search skill',
        searchTool: 'Search tool',
        secondAbout: '{number} second',
        secondaryBackgroundColor: 'Secondary background color',
        secondaryBackgroundColorDark: 'Secondary dark background color',
        secondaryBackgroundColorLight: 'Secondary light background color',
        secondAgo: '{number} second ago',
        secondsAbout: '{number} seconds',
        secondsAgo: '{number} seconds ago',
        selectACatalogItemToAssignAcertificateTo: 'Select a catalog item to assign to',
        selectAll: 'Select all',
        selectAnActivity: 'Select an activity',
        SelectACertificate: 'Select a certificate',
        selectAPeriod: 'Select a period',
        selectAPlanning: 'Select a planning',
        SelectASkillToChangeAssignments: 'Select a skill to change assignments',
        selectATrainingToAdd: 'Select a training to add',
        selectAssigned: 'Select assigned',
        selectAssignmentOption: 'Select target audience:',
        selectCategory: 'Select category',
        selectCategories: 'Select categories',
        selectCompetenceAndFunctions: 'Select competence and roles',
        selectDepartment: 'Select department',
        selectDomain: 'Select domain',
        selectDownloadType: 'Select download type',
        selectedEmployees: 'Selected employees',
        selectedForReview: 'Selected user for review',
        selectEmployee: 'Select employee',
        selectExportToMakeAnotherUserAssessorForTheSameActivitiesAsThisUser: `Select ''EXPORT'' to make another user assessor for the same activities as this user.`,
        SelectExternalLearningPlan: 'Select external e-learning(s)',
        selectFile: 'Select file',
        selectFunctions: 'Select functions',
        selectImportType: 'Select import type',
        SelectPhoto: 'Select photo',
        SelectManagerCatalogAuthorization: 'Select a manager to submit the request to',
        selectOption: 'Select option',
        selectPortfolioItem: 'Select portfolio item',
        selectReviewer: 'Select your reviewer',
        selectReviewerForPortfolioItem: 'Select a reviewer for this portfolio item',
        selectScormItem: 'Select scorm item',
        selectStatus: 'Select status',
        selectTargetType: 'Select type',
        selectTeacher: 'Select teacher',
        selectType: 'Select type',
        selectReportType: 'Select report type',
        selectVisibility: 'Select visibility',
        send: 'Send',
        sendAMessage: 'Send a message',
        sendMessage: 'Send message',
        senderDomain: 'Sender domain',
        sendUserConfirmationMail: 'Send a confirmation by e-mail',
        sentMessages: 'Sent messages',
        sentFromCommunity: 'Sent from Community (Interactive component)',
        sentToPortfolioItems: 'Verzonden naar dossier',
        session: 'session',
        sessionName: 'Session name',
        sessions: 'sessions',
        settings: 'Settings',
        showEmptyValues: 'Show empty values',
        skill: 'Skill',
        skillCanBeUnlinkedOnlyByAdmins: 'This skill can only be unlinked by administrators',
        skillOnlyAssignableByAdmin: 'This skill can only be assigned by administrators',
        skills: 'Skills',
        skillsReport: 'Skills report',
        skillStatusPerEmployee: 'Status per employee',
        skillsReportWidgetInfo: 'Monitor skill progress',
        skillsAlmostExpired: 'almost expired',
        skillsExpired: 'expired',
        skillslabtest: 'Skillslab',
        skillsPassport: 'Skills passport',
        skillsPassportOf: 'Skills passport of',
        'SkillsReport.WhatToExport': 'What do you want to export?',
        'SkillsReport.SummaryExport': 'Skills summary',
        'SkillsReport.TotalExport': 'Overview of all skills including department & function',
        'SkillsReport.Present': 'Present',
        'SkillsReport.DisplayProvenSkills': 'Display proven skills',
        'SkillsReport.History': 'History',
        'SkillsReport.HistoryConflictNoDate': 'Select a date',
        'SkillsReport.HistoryConflictNoType': 'Select a report type',
        'SkillsReport.HistoryConflictNoUser': 'Select a user',
        'SkillsReport.HistoryConflictMessage': 'Select a date and the preferred history data',
        'SkillsReport.PresentOverview': 'Present overview ',
        'SkillsReport.HistoryOverview': 'History overview',
        'SkillsReport.SelectUser': 'Select a user',
        'SkillsReport.ShowHistory': 'Show history of...',
        'SkillsReport.SpecificUser': 'Specific user',
        'SkillsReport.ProvenSkills': 'Proven skills',
        show: 'review',
        showAdvancedFilters: 'Show advanced filters',
        showAll: 'Show all',
        showLess: 'Show less',
        showMore: 'Show more',
        showAlsoExpiredAndFutureCatalogItems: 'Also show expired / future items',
        showAssessment: 'Show assessment',
        showDepartments: 'Show departments',
        showDisabledAccounts: 'Show disabled accounts',
        showExpiredSchedules: 'Show expired plannings',
        showForm: 'Show form',
        showOnly: 'Show only',
        showOverview: 'Show overview',
        showStandardFilters: 'Show standard filters',
        signIn: 'Sign in',
        signInToUse: 'Sign in to use SDB Leerplatform',
        signOut: 'Sign out',
        size: 'Size',
        someoneElse: 'Someone else',
        sortBy: 'Sort by',
        sortByDate: 'Sorteer op datum',
        sortedByDate: 'Sorted by date',
        spaceFillingProportionalStandard: 'Space-filling, proportional (standard)',
        ssosearch: 'Search user',
        ssoUserInformation: 'User account',
        ssoUserOrGroup: 'User / group',
        start: 'Start',
        startDate: 'Start date',
        startDates: 'Planning',
        started: 'Started',
        Started: 'Started',
        startedOn: 'Started on',
        startedCourses: 'Started courses',
        StartTime: 'Start time',
        statusAll: 'All',
        statusAccept: 'For accept',
        startedStatus: 'Started',
        statusReview: 'Review',
        statusReject: 'Rejected',
        Status: 'Status',
        statusCompleted: 'Completed',
        stillToDo: 'still to do',
        Strikethrough: 'Strikethrough',
        stronglyAgree: 'Strongly Agree',
        stronglyDisagree: 'Strongly Disagree',
        studyLoad: 'Study load',
        studyLoadInMinutes: 'Study load in minutes',
        style: 'Style',
        subject: 'Subject',
        submit: 'Submit',
        submitAssessment: 'Submit assessment',
        submitForm: 'Submit form',
        submitRequest: 'Submit request',
        submitCatalogAuthorizationRequest:
            'You are about to file a request with your manager to follow this course. These are the details:',
        subtitle: 'Subtitle',
        subDepartment: 'Subdepartment',
        subDepartments: 'Subdepartment(s)',
        SuccesRegistrationIsPossible: 'It is possible to register the person on this planning.',
        Summary: 'Summary',
        switchToNewDashboard: 'Explore the new dashboard',
        switchToNewDashboardDescription:
            'Take a look at our redesigned dashboard. You can switch back anytime.',
        tabDetails: 'Details',
        tabBijlagen: 'Attachments',
        tabComments: 'Comments',
        'targetType.all': 'All',
        'targetType.learningplan': 'E-learning',
        'targetType.composition': 'E-learning',
        'targetType.classroom': 'Classical',
        'targetType.expertise': 'Personal development',
        'targetType.learningpath': 'Learning path',
        'targetType.microlearning': 'Micro Learning',
        'targetType.scorm': 'Scorm',
        'targetType.lti': 'LTI',

        'targetType.microlearning.video': 'Video',
        'targetType.microlearning.movie': 'Video',
        'targetType.microlearning.audio': 'Audio',
        'targetType.microlearning.animation': 'Animation',
        'targetType.microlearning.infographic': 'Infographic',
        'targetType.microlearning.exercise': 'Exercise',
        'targetType.microlearning.microcourse': 'Microcourse',
        'targetType.microlearning.text': 'Text',
        'targetType.microlearning.test': 'Test',
        'targetType.microlearning.pretest': 'Sssessment',
        'targetType.microlearning.complete': 'E-learning',
        'targetType.microlearning.elearning': 'E-learning',

        tcgPasswordStrength: {
            Label: 'strength',
            None: 'none',
            VeryWeak: 'very weak',
            Weak: 'weak',
            Medium: 'medium',
            Strong: 'strong',
            VeryStrong: 'very strong',
        },
        Taught: 'Taught',
        tcgUpload: {
            dropFiles: {
                one: 'Drop file here',
                many: 'Drop files here',
            },
            addFiles: {
                one: 'Select file...',
                many: 'Select files...',
            },
            cancel: 'Cancel',
            error: {
                tooManyFiles: 'Too many files.',
                fileIsTooBig: 'File is too big.',
                incorrectFileType: 'Incorrect file type.',
            },
            uploading: {
                status: {
                    connecting: 'Connecting...',
                    stalled: 'Stalled.',
                    processing: 'Processing files...',
                    held: 'The files will be uploaded after submit.',
                },
                remainingTime: {
                    prefix: 'remaining time: ',
                    unknown: 'unknown remaining time',
                },
                error: {
                    serverUnavailable: 'Server unavailable',
                    unexpectedServerError: 'Unexpected server error',
                    forbidden: 'Forbidden',
                },
            },
            units: {
                size: ['B', 'kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
                sizeBase: 1000,
            },
        },
        tasksTitle: 'Tasks',
        tasksLoading: 'Loading tasks',
        noTasksOpenTitle: 'No open tasks',
        noTasksOpenText: 'Anything waiting for your action will show up here.',
        teacher: 'Teacher',
        teacherArchive: 'Teacher archive',
        teacherOverviewDescription: 'Overview teachers',
        teachers: 'Teachers',
        teacherIsMandatory: 'Teacher is mandatory',

        Temporary: 'Temporary',
        TemporaryEnrollmentComments: 'Temporary enrollement comments',
        temporaryParticipants: 'Temporary registered participants',
        temporaryParticipantsTab: 'Temporary enrollements',
        template: 'Template',
        tertiaryBackgroundColor: 'Tertiary background color',
        testResult: 'Result',
        text: 'Text',
        textField: 'Text field',
        textFieldInfo:
            'Used to display information or instructions. This field is not used to collect information from the user.',
        theBlockMustAtleastContainAquestion: 'The block must at least contain one question',
        theActivityIsNoLongerAvailable: 'The activity is no longer available',
        theAllowedNumberOfRegistrationsHasBeenReached:
            'The allowed number of registrations for this user has been reached',
        theAllowedNumberOfRegistrationsForMyselfHasBeenReached:
            'You have reached the maximum number of enrollments for this course',
        theAllowedNumberOfRegistrationsForThisUserHasBeenReached:
            'This user has reached the maximum number of enrollments for this course',
        theColleagueWhoWillAssessYou: 'The colleague who will assess you',
        theFirstBeginsOn: 'the first begins on',
        theFollowingParticipantsAreStillRegisteredOnTheSchedule:
            'The following participants are still registered on the schedule:',
        TheLearningPlansThatWillGetActivated: 'The e-learnings that will get activated',
        themeColors: 'Theme colors',
        themeColorPrimary: 'Primary theme color',
        themeColorSecondary: 'Secondary theme color',
        themeColorTertiary: 'Tertiary theme color',
        themeColorButton: 'Button color',
        themeColorProgress: 'Progressbar color',
        themeColorProgress100: 'Progressbar 100% color',
        themeDescription:
            'Easily set 2 theme colors. The text color and the supporting colors will be automatically calculated. Not exactly what you want? Set the colors yourself below!',
        theMinimumNumberOfMandatoryActivitiesIs:
            'The minimum number of mandatory activities is {number}',
        theNextActivityStarts: 'Next activity:',
        theNextLessonStarts: 'Next activity:',
        theNextOneIsOn: 'the next one is on',
        thereAreEvaluationRequests: 'Evaluate your training',
        thereAreListsThatNeedToBeUpdated: 'Update attendance lists',
        thereAreNoAssessmentsFound: 'There are no assessments found',
        thereAreNoAssessmentsFoundTitle: 'No assessments',
        ThereArenoAssignmentsFound: 'There are no assignments found',
        thereAreNoDepartmentsFound: 'There are no departments found',
        thereAreNoDocuments: 'There are no documents.',
        thereAreNoFormsFound: 'There are no forms found',
        thereAreNoFormsFoundTitle: 'No forms',
        thereAreNoFunctionsLinkedToThisSkill: 'There are no functions linked to this skill',
        thereAreNoFuturePlannedLessons: 'There are no future planned lessons',
        thereAreNoListsToUpdate: 'There are no lists to update',
        thereAreNoMessageFound: 'There are no messages found',
        thereAreNoMessageTitle: 'No messages found',
        thereAreNoOpenAssessmentRequests: 'There are no open assessment requests',
        thereAreNoPastPlannedLessons: 'There are no expired lessons found',
        thereAreNoParticipantsConnectedToThisSchedule:
            'There are no participants connected to this planning',
        thereAreNoParticipantsFound: 'There are no participants found',
        thereAreNoRequiredTrainings: 'There are no required trainings',
        thereAreNoRequiredTrainingsFound: 'No required trainings found',
        thereAreNoRequiredTrainingsAssigned: 'No required training assigned',
        thereAreNoSkillsCategoriesFoundTitle: 'No skills categories found',
        thereAreNoSkillsCategoriesFoundText: 'Add a skills category or reset filters',
        thereAreNoSkillsFound: 'There are no skills found',
        thereAreNoSkillsLinked: 'There are no skills linked',
        thereAreNoSkillsFoundTitle: 'No skills found',
        thereAreNoSkillsFoundText: 'Try changing the filter options',
        thereAreOpenAssessmentRequests: 'There are open assessment requests',
        thereAreThecomingDays: 'There are the coming',
        thereIsAccreditationFound: 'There is no accreditation found',
        thereIsAnEvaluationRequests: 'Evaluate your training',
        thereIsNoLocationSelected: 'There is no location selected',
        thereIsNoTeacherSelected: 'There is no teacher selected',
        theSelectedAssessor: 'The selected assessor',
        theorems: 'Theorems',
        thisCatalogItemIs: 'This catalog item is',
        thisCatalogItemIsDisabled: 'This catalog item is disabled',
        thisCatalogItemIsDenied: 'This catalog item is not assigned to you',
        thisExaminerIsNotSkilled: 'This examiner is not skilled',
        thisMinervaPortalDoesNotExist: 'This SDB Leerplatform portal does not exist',
        thisScheduleIsFullTheNewRegistrationsWillBeQueued:
            'This schedule is full. As an administrator/planner, you can ignore the schedule. If you continue, the employee will still be registered.',
        thisScheduleIsFullTheNewRegistrationsWillBeQueuedOnPosition:
            'This schedule is full. The new registration will be placed on the queue at position {number}',
        thisScheduleConflictsWithAnotherScheduleForWhichThisParticipantIsRegistered:
            'This schedule conflicts with another schedule for which this participant is registered',
        thisScheduleConflictsWithAnotherScheduleForWhichYouAreRegistered:
            'This schedule conflicts with another schedule for which you are registered',
        thisScheduleCannotBeEditedBecauseItIsInTheFuture:
            'This schedule can not be edited because it is in the future',
        time: 'Time',
        timeslotsToDeleteWarning: 'Warning! These reservations will be deleted:',
        Title: 'Title',
        to: 'To',
        today: 'Today',
        todolist: 'Todolist',
        tool: 'Tool',
        toolDeleted: 'Tool deleted',
        tools: 'Tools',
        Tooltip: 'Tooltip',
        toPlannings: 'To plannings',
        total: 'Total',
        totalAfterANumber: 'total',
        totalNumberOfEvaluations: 'Total number of evaluations',
        TotalNumberOfHours: 'Total number of hours',
        totalResultsFound: 'Total results found',
        training: 'Training',
        trainingDeleted: 'Training deleted',
        trainingInformation: 'Training information',
        trainingonthejob: 'Training on the job',
        trainingsStarted: 'started',
        trainingType: 'Training type',
        transferEnrollment: 'Transfer',
        transferInsufficientRights: 'You have insufficient rights to transfer',
        true: 'yes',
        toj: 'Training on the job',
        trainings: 'Trainings',
        translate: 'Translate',
        types: 'types',
        'type.all': 'All',
        'type.skill': 'Assigned as skill',
        'type.learningPath': 'Published to catalog',
        'type.both': 'Both',
        'type.none': 'None',
        Uncouple: 'Uncouple',
        UncoupleEmployee: 'Uncouple employee',
        Underline: 'Underline',
        underlyingDepartments: 'Underlying departments',
        Undo: 'Undo',
        unenroll: 'unenroll',
        unenrollment: 'Unenrollment',
        unenrollmentDeadline: 'Unenrollment deadline',
        unenrollmentDeadlineInDays: 'Unenrollment deadline in days',
        units: {
            size: ['B', 'kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
        },
        uniqueUsers: 'Unique users',
        'Unordered List': 'Unordered List',
        unknown: 'Unknown',
        Unknown: 'Unknown',
        unKnownOn: 'Unknown on',
        unlockAccount: 'Unlock account',
        unregister: 'Unregister',
        unRegisterInsufficientRights: 'You have insufficient rights to unenroll.',
        unregisterOrTansferOptions: `{ option, select,
            myUnregister {You are not allowed to unregister because your attendance / result has already been saved.}
            myTransfer {You are not allowed to transfer because your attendance / result has already been saved.}
            someoneElseUnregister {You can't unregister this employee, because the attendance / result has already been saved.}
            someoneElseTransfer {You can't transfer this employee, because the attendance / result has already been saved.}
            other {{option}}
        }`,
        unRegisterPeriodExceeded: 'It is no longer possible to unenroll.',
        unRegisterPeriodExceededTitle: 'Unenroll period expired',
        unsupportedBrowserHeader: 'Outdated browser',
        unsupportedBrowserMessage:
            'You are using a browser we no longer support. Update your browser for a better experience!',
        until: 'until',
        untilTime: 'Until',
        up: 'Up',
        upcomingTrainings: 'Upcoming trainings',
        UpdateValidityForExistingAssignments: 'Overwrite validity for existing assignments',
        upload: 'Upload',
        uploadAutomatically:
            'Attachments in the queue will be automatically uploaded when you save the dossier item.',
        uploadCertificateBackgroundImage1: 'Background image',
        uploadCertificateBackgroundImage2:
            'A 150dpi image at 1240px by 1754px is sufficient for a printed A4.',
        uploading: {
            status: {
                connecting: 'Connecting...',
                stalled: 'Stalled.',
                processing: 'Processing File...',
                held: 'Queued',
            },
        },
        uploadQuestion: 'Upload question',
        uploadQuestionDescription: 'Description for file upload',
        uploadQuestionInfo: 'Users can add a file via an upload button.',
        uploadQuestionNotUploaded: 'No uploaded file',
        unregistered: 'Unregistered',
        Unregistered: 'Unregistered',
        unregisteredParticipants: 'Unregistered participants',
        updateAttendance: 'Update attendance',
        url: 'URL',
        URL: 'URL',
        usageReport: 'Usage Report',
        'usageReport.subtitle': 'E-learnings & classical courses',
        'usageReport.generate': 'Generate report',
        'usageReport.usageUniqueCoursesUsers': 'Number of unique users that started this course',
        'usageReport.usageUniqueUsers': 'Number of unique users that started this e-learning',
        'usageReport.activeUsersPeriod': 'Active users in selected period',
        'usageReport.elearningDetails.user': 'User',
        'usageReport.elearningDetails.searchUser': 'Search user',
        'usageReport.elearningDetails.status': 'Status',
        'usageReport.info.usersStartedBetween': 'Users started between {selectedDates}',
        useCustomValue: 'Use custom value',
        useDefault: 'Use default',
        useExaminerFunctionality: 'Use examiner functionality',
        UseOnlyDefaultTemplates: 'Use only default mail templates',
        user: 'User',
        'user.course.result.validUntil': 'Valid until',
        userGroupDeleted: 'User/group deleted',
        userProfile: 'User profile',
        users: 'Users',
        userInfo: 'User information',
        uservoiceIcon: 'Submit an improvement',
        userManagement: 'Usermanagement',
        vacantPlace: 'seat',
        vacantPlacesAvailable: `{number, select,
         1 {1 seat available}
         other {{number} seats available}
         }`,
        vacantPlaces: 'seats',
        valid: 'Valid',
        validity: 'Validity',
        validityMonths: '{number} months',
        validityPeriodInMonths: 'Validity period in months',
        validityUpdated: 'Validity updated',
        validUntil: 'Valid until',
        Version: 'Version',
        version: 'version',
        refresher: 'Refresher',
        viewComment: 'View comment',
        viewPlanning: 'View planning',
        viewPreconditions: 'View preconditions',
        viewSkill: 'View skill',
        viewTheClassActivitiesForWhichYouAreRegistered:
            'View the class activities for which you are registered',
        viewYourScheduledLessons: 'View your scheduled lessons',
        virtualQueue: 'Watch list',
        visibility: 'Visibility',
        visible: 'Visible',
        visibleFrom: 'Visible from {date}',
        visibleUntil: 'Visible until {date}',
        week: 'Week',
        weekAbout: '{number} week',
        weekAgo: '{number} week ago',
        weekOverview: 'Week overview',
        weekOverviewReport: 'Week overzicht report',
        weeks: 'Weeks',
        weeksAbout: '{number} weeks',
        weeksAgo: '{number} weeks ago',
        welcomeToTCGMinerva: 'Welcome to the learning environment',
        whatAreYouSearchingFor: 'What are you searching for?',
        when: 'When',
        WhoDoYouWantToRegister: 'Register',
        width: 'Width',
        withdrawTheApplication: 'Withdraw the application',
        WithCertificate: 'With certificate',
        WithoutCertificate: 'Without certificate',
        workLearningMethods: 'Work forms & Learning methods',
        workLearningMethodsDisabled:
            'The "Day Start", "Visual Reflection", and "Online Visual Session" formats will be discontinued as of November 2. You will no longer be able to use them after that date. Questions? Please contact Support.',
        workPhone: 'Work phone',
        writtentest: 'Written',
        year: 'Year',
        years: 'Years',
        yearAbout: '{number} year',
        yearsAbout: '{number} years',
        yearAgo: '{number} year ago',
        yearsAgo: '{number} years ago',
        yes: 'Yes',
        youAreAlreadyRegistered: 'You are already registered',
        youAreNotAuthorizedToViewThisInformation:
            'You are not authorized to view this information.',
        youCurrentlyHaveNoLesson: 'You currently have no lesson',
        YouDoNotHaveAddedFavorites: 'You do not have added favorites.',
        youHaveMadeChangesDoYouWantToContinueWithoutSavingIt:
            'You have made changes. Do you want to continue without saving it?',
        youHaveNoLessonInTheNextSelectedDays: 'You have no lesson in the next selected days',
        youMustAddRecipients: 'You must add recipients',
        youMustUploadDocuments: 'You must attach supporting documents.',
        YourDepartments: 'Your departments',
        YourFavoriteCourses: 'Your favorite courses',
        YouAreSignedInAsAndDoesNotHaveRightsOn:
            'You are signed in as {name} and with this account you have no rights to enter {portal}',
        youWillBeAssessedBy: 'You will be assessed by',
        yourProgress: 'Your progress',
        viewYourProgress: 'View your progress',
        zipCode: 'Zip code',

        showChildDepartmentsWhenNotManager:
            'Show child departments to a manager of a parent department',
        'ssoManagement.mainTitle': 'SSO Management',
        'ssoManagement.pageInfo': 'SSO Management PageInfo',
        'ssoManagement.listHeading': 'SSO List',
        'ssoManagement.addSsoUser': 'Create SSO User',
        'ssoManagement.updateSsoUser': 'Update SSO User',
        'ssoManagement.enableDisableLabel': 'Enable/Disable',
        'ssoManagement.lockedOut': 'Locked Out',
        'ssoManagement.disabledSince': 'Disabled per',

        'ssoManagement.logOnName': 'Logon',
        'ssoManagement.logOnAlias': 'Logon Alias',
        'ssoManagement.displayName': 'Displayname',
        'ssoManagement.description': 'Description',
        'ssoManagement.emailAddress': 'Email Address',
        'ssoManagement.userPrincipalName': 'UPN',
        'ssoManagement.employeeId': 'Employee ID',

        'ssoManagement.password': 'Password',
        'ssoManagement.resetPassword': 'Reset Password',

        'ssoManagement.filter.enabled': 'Enabled',
        'ssoManagement.filter.disabled': 'Disabled',
        'ssoManagement.filter.lockedOut': 'Locked Out',

        'ssoManagement.tab.users': 'Users',
        'ssoManagement.tab.groups': 'Groups',

        'ssoManagement.actions.changePassword': 'Change password',
        'ssoManagement.actions.generatePassword': 'Generate password',
        'ssoManagement.actions.sendResetLink': 'Send reset link',
        'ssoManagement.actions.unlock': 'Unlock',
        'ssoManagement.actions.enableDisable': `{ disabled, select,
            true {Enable}
            false {Disable}
            undefined {Disable}
            other {{disabled}}
        }`,

        'ssoManagement.errors.mustBeUnique': `Logonname and LogonAlias must be different!`,
        'ssoManagement.errors.alreadyInUse': `Logonname is already in use!`,
        'ssoManagement.errors.selectDomain': `Please select a domain!`,
        'ssoManagement.errors.upnAlreadyInUse': `UPN is already in use!`,
        'ssoManagement.errors.invalidCharacters': `Only letters, numbers, dots (.), hyphens (-), and underscores (_) are allowed.`,

        'ssoGroupManagement.groupDetails': 'Group details',
        'ssoGroupManagement.mainTitle': 'SSO Group Management',
        'ssoGroupManagement.pageInfo': 'SSO Group Management PageInfo',
        'ssoGroupManagement.listHeading': 'SSO Group List',
        'ssoGroupManagement.addSsoGroup': 'Create SSO Group',
        'ssoGroupManagement.updateSsoGroup': 'Update SSO Group',
        'ssoGroupManagement.updateSsoGroupMembers': 'Update SSO Group Members',
        'ssoGroupManagement.memberOf': 'Member Of',

        tags: 'Tags',
        labels: 'Labels',
        addLabel: 'Add Label',
        noLabels: 'No Labels',

        Supplier: 'Supplier',

        supplierTags: 'Supplier Tags',
        addTag: 'Add Tag',
        noTags: 'No Tags',

        'scormManagement.mainTitle': 'SCORM Management',
        'scormManagement.pageInfo': 'SCORM Management PageInfo',
        'scormManagement.listHeading': 'SCORM List',
        'scormManagement.uploadScormPackage': 'Upload Scorm 1.2 (.zip) Package',

        'scormManagement.filter.zipped': 'Zipped',
        'scormManagement.filter.unzipped': 'Unzipped',

        'scormManagement.actions.upload': 'Upload',
        'scormManagement.actions.delete': 'Delete',

        'learningPath.resetDialogTitle': 'Restart learning path?',
        'learningPath.resetDialogBody':
            'Are you sure you want to restart this learning path? <br/><br/>With a new attempt, the status of the underlying activities is reviewed again. Activities that have expired or have not yet been started must be (re)completed to achieve a result on this learning path.<br/><br/>This reset does not affect previously achieved results on this learning path.',
        'tcgLearningPlan.resetDialogTitle': 'Do again?',
        'tcgLearningPlan.resetDialogBody':
            'Are you sure you want to do this e-learning again? All your current progress will then be lost. It does not affect previous results.',
        'tcgLearningPlan.somethingWentWrong': 'Something went wrong',
        'tcgLearningPlan.retryProcessProgress': 'Retry to save your progress.',
        'tcgLearningPlan.resetIfNotWorking': 'Not working? Reset the course to start over.',
        'tcgLearningPlan.handInDialogTitle': 'Hand in?',
        'tcgLearningPlan.handInDialogText':
            'Are you sure you want to hand in {title}? It is not possible to make changes after hand in!',
        'tcgLearningPlan.handIn': 'Hand in',
        'tcgLearningPlan.skip': 'Skip',
        'tcgLearningPlan.completed': 'Completed',
        'tcgLearningPlan.open': 'Open',
        'tcgLearningPlan.notAvailableYet': 'Not available',
    },
};
